import { Language } from "./types"
export type { Language }

export const translations: Record<Language, Record<string, string>> = {
  en: {
    popularFavoriteTeams: 'Popular Favorite Teams',
    stadiumPostTitle: "Post to Stadium",
    stadiumPostPlaceholder: "Share your thoughts with other fans of this team.",
    awaitingData: "Awaiting match data...",
    awaitingDataDesc: "The match has started, but real-time data is not yet available. Please wait a moment.",
    injuryList: "Injury",
    injuryReason_Injury: "Injury",
    injuryReason_RedCard: "Red Card",
    injuryReason_Internationalduty: "International Duty",
    injuryReason_YellowCards: "Yellow Cards",
    injuryReason_LowerBackInjury: "Lower Back Injury",
    injuryReason_ChestInjury: "Chest Injury",
    injuryReason_Jumpersknee: "Jumpers Knee",
    injuryReason_ToeInjury: "Toe Injury",
    injuryReason_Inactive: "Inactive",
    injuryReason_KneeInjury: "Knee Injury",
    injuryReason_AnkleInjury: "Ankle Injury",
    injuryReason_HamstringInjury: "Hamstring Injury",
    injuryReason_ThighInjury: "Thigh Injury",
    injuryReason_CalfInjury: "Calf Injury",
    injuryReason_GroinInjury: "Groin Injury",
    injuryReason_MuscleInjury: "Muscle Injury",
    injuryReason_FootInjury: "Foot Injury",
    injuryReason_LegInjury: "Leg Injury",
    injuryReason_BrokenLeg: "Broken Leg",
    injuryReason_ACLInjury: "ACL Injury",
    injuryReason_MCLInjury: "MCL Injury",
    injuryReason_ShoulderInjury: "Shoulder Injury",
    injuryReason_BackInjury: "Back Injury",
    injuryReason_HipInjury: "Hip Injury",
    injuryReason_HeadInjury: "Head Injury",
    injuryReason_Concussion: "Concussion",
    injuryReason_WristInjury: "Wrist Injury",
    injuryReason_HandInjury: "Hand Injury",
    injuryReason_BrokenHand: "Broken Hand",
    injuryReason_BrokenArm: "Broken Arm",
    injuryReason_ArmInjury: "Arm Injury",
    injuryReason_Sick: "Illness",
    injuryReason_Illness: "Illness",
    injuryReason_Fever: "Fever",
    injuryReason_Virus: "Virus",
    injuryReason_Infection: "Infection",
    injuryReason_Knock: "Knock",
    injuryReason_Bruise: "Bruise",
    injuryReason_Strain: "Strain",
    injuryReason_Sprain: "Sprain",
    injuryReason_Tear: "Tear",
    injuryReason_Surgery: "Surgery",
    injuryReason_PhysicalCondition: "Physical Condition",
    injuryReason_Rest: "Rest",
    injuryReason_PersonalReasons: "Personal Reasons",
    injuryReason_Suspended: "Suspended",
    injuryReason_Doubtful: "Doubtful",
    injuryReason_Achillestendonproblems: "Achilles Tendon Problems",
    injuryReason_fitness: "Fitness Issues",
    injuryReason_Injurytotheankle: "Ankle Injury",
    injuryReason_injured: "Injured",
    injuryReason_InjuredDoubtful: "Injured Doubtful",
    injuryReason_Suspension: "Suspension",
    injuryReason_RedcardSuspended: "Red Card Suspended",
    injuryReason_Muscularproblems: "Muscular Problems",
    injuryReason_Thighproblems: "Thigh Problems",
    injuryReason_KneeSurgery: "Knee Surgery",
    injuryReason_Outerligamenttear: "Outer Ligament Tear",
    injuryReason_Kneeinjury: "Knee Injury",
    injuryReason_Rupturedcruciateligament: "Ruptured Cruciate Ligament",
    injuryReason_FracturedFinger: "Fractured Finger",
    injuryReason_Sprainedankle: "Sprained Ankle",
    injuryReason_UnknownInjury: "Unknown Injury",
    sponsorshipTitle: "Support XLEVEN",
    sponsorshipDesc: "Help us keep providing the fastest football insights and AI analysis. Your support makes a difference!",
    supportSmallCoffee: "Buy us a small coffee",
    qrDonation: "QR Donation",
    qrDonationDesc: "Scan to support via direct transfer",
    sponsorshipWhy: "Why Support Us?",
    sponsorshipWhyDesc: "Your contributions help cover server costs and API fees, enabling us to continue developing innovative features for the football community.",
    magazineArchive: "Archive",
    magazineCollection: "Collection",
    magazineDiscover: "Discover the",
    magazineDeepStories: "Deep Stories",
    magazineHeroDesc: "Curated football insights, exclusive interviews, and tactical masterpieces.",
    notices: "Notices",
    noNotices: "No Notices Found",
    noNoticesDesc: "We will notify you when there are new updates",
    allLeagues: "All Leagues",
    home: "Home",
    news: "Feed",
    player: "Player",
    games: "Games",
    shorts: "Shorts",
    settings: "Settings",
    mypage: "My Page",
    gamestore: "Games",
    community: "Community",
    realTimeMatchTalk: "Live Match Talk",
    recommendedForYou: "Latest Feed",
    latestTransferNews: "Market Movements",
    helpCenter: "Help Center",
    contactUs: "Contact Us",
    privacyPolicy: "Privacy Policy",
    termsOfService: "Terms of Service",
    aboutUs: "About Us",
    aboutXleven: "About XLEVEN",
    aboutXlevenDesc:
      "XLEVEN provides the fastest football news using AI technology. Experience real-time news, transfer rumors, and data-driven predictions.",
    sponsorship: "Sponsorship",
    marketWatch: "Market Watch",
    topTransfers: "Top Transfers",
    latestHeadlines: "Latest Headlines",
    verifiedSources: "Verified Sources",
    stats: "Statistics",
    playingCareer: "Playing Career",
    fanZone: "Fan Zone",
    trendingTopic: "Trending Topic",
    analyze: "Generate Transfer Prediction",
    analyzing: "Analyzing Stats...",
    undisclosed: "Undisclosed",
    unknown: "Unknown",
    noTransfers: "No transfers found for",
    comingSoon: "Coming soon in v2.0",
    language: "Language",
    selectLanguage: "Select Language",
    clearCache: "Clear Data Cache",
    cacheCleared: "Cache Cleared",
    all: "All",
    global: "Global",
    epl: "EPL",
    laliga: "La Liga",
    seriea: "Serie A",
    bundesliga: "Bundesliga",
    ligue1: "Ligue 1",
    uefa: "UEFA",
    live: "Live",
    replay: "Replay",
    latest: "Latest",
    worldCup: "World Cup",
    leagues: "Leagues",
    weeklyMagazine: "Magazine",
    magazine: "Magazine",
    read: "read",
    welcome: "Welcome Back",
    enterCredentials: "Please enter your details to sign in.",
    continueWithGoogle: "Continue with Google",
    continueWithKakao: "Continue with Kakao",
    continueWithNaver: "Continue with Naver",
    or: "Or",
    emailAddress: "Email Address",
    password: "Password",
    signInAccount: "Sign In Account",
    noAccount: "Don't have an account yet?",
    createAccount: "Create Account",
    fullName: "Full Name",
    confirmPassword: "Confirm Password",
    startExploration: "Start Exploration",
    joinNow: "Join Now",
    recentActivity: "Recent Activity",
    recentActivityDesc: "History of viewed transfers",
    followedPlayers: "Followed Players",
    followedPlayersDesc: "Manage your tracking list",
    favoriteClubs: "Favorite Clubs",
    favoriteClubsDesc: "Team updates & notifications",
    pushNotifications: "Push Notifications",
    pushNotificationsDesc: "Real-time market alerts",
    darkMode: "Dark Mode",
    supportLegal: "Support & Legal",
    storagePrivacy: "Storage & Privacy",
    storagePrivacyDesc: "Free up local storage space",
    logOutAccount: "Log Out Account",
    verifiedProfile: "Verified Profile",
    proMember: "Pro Member",
    activity: "Activity",
    applicationSettings: "Application Settings",
    back: "Back",
    forgotPassword: "Forgot password?",
    secureSSL: "Secure SSL",
    alreadyMember: "Already a member?",
    signIn: "Sign In",
    authenticating: "Authenticating...",
    securingData: "Securing Data...",
    accessGranted: "Access Granted!",
    scoutingProfileSync: "Your scouting profile has been successfully secured.",
    dataLinkActive: "Data Link Active",
    redirecting: "Redirecting to Dashboard...",
    editNickname: "Edit Nickname",
    save: "Save",
    cancel: "Cancel",
    nicknameError: "Nickname must be between 2 and 20 characters.",
    favoriteLeagues: "Favorite Leagues",
    favoriteLeaguesDesc: "Your followed match categories",
    manageLeagues: "Choose Favorite Leagues",
    saveChanges: "Save Changes",
    selectLeaguesToFollow: "Select leagues you want to follow",
    syncSuccess: "Preferences synced successfully",
    today: "Today",
    last7Days: "Last 7 Days",
    last30Days: "Last 30 Days",
    allTime: "All Time",
    activityStats: "League Standings & Stats",
    totalInteractions: "Total Interactions",
    loadingLeagues: "Loading leagues...",
    following: "Following",
    views: "Views",
    comments: "Comments",
    discussionHub: "Discussion Hub",
    syncingHub: "Syncing Hub...",
    firstIntelligenceReport: "Post your first comment",
    relatedIntelligence: "Related Intelligence",
    relatedNews: "Related News",
    reply: "Reply",
    report: "Report",
    delete: "Delete",
    replyingTo: "Replying to",
    typeIntelligenceUpdate: "Type intelligence update...",
    establishReport: "Establish report...",
    unauthorizedLogin: "Unauthorized. Login required.",
    deleteCommentTitle: "Delete Comment?",
    loginRequiredTitle: "Log in now and join the soccer action",
    signInLabel: "Sign In",
    changingLanguage: "Updating System Language...",
    intelligenceAudio: "AI Voice Report",
    mergeFailed: "Merge Failed",
    keyBriefing: "Key Briefing",
    loadingIntelligence: "Loading detail page...",
    articleNotFound: "Article Not Found",
    goBack: "Go Back",
    joinConversation: "Join the conversation...",
    loginParticipate: "Login to participate",
    leagueSelectionDescLoggedIn: "Select leagues to follow. Your choices are synced to your account.",
    leagueSelectionDescGuest: "Select leagues to follow. Guest sessions expire in 3 minutes.",
    leagueStage: "League Stage",
    knockoutStage: "Knockout Stage",
    scenariosTab: "Scenarios",
    loadMoreNews: "Load More",
    syncSelectedFeed: "Sync Selected Feed",
    selectAtLeastOneLeague: "Please select at least one league.",
    syncFailedTryAgain: "Failed to sync selections. Please try again.",
    yourLeagues: "your leagues",
    edit: "Edit",
    loadMore: "Load More",
    latestMovements: "Latest Movements",
    syncingMarketIntel: "Syncing latest data...",
    loadingNewsFeed: "Curating Your Scouting Feed...",
    analyzingTalent: "Analyzing talent data...",
    syncingFixtures: "Syncing Match Schedule...",
    syncingMatchDetail: "Syncing Match Intel...",
    curatingShorts: "Curating Highlights...",
    postingComment: "Posting Comment...",
    searchingFor: "Searching for",
    matchStats: "Stats",
    lineUp: "Lineup",
    timeline: "Timeline",
    talk: "Talk",
    matchHighlights: "Match Highlights",
    latestTeamNews: "Latest Team News",
    close: "Close",
    fullTime: "FT",
    startingXI: "Starting XI",
    substitutes: "Substitutes",
    injuries: "Injured Players",
    coach: "Coach",
    ownGoal: "Own Goal",
    waitingKickoff: "Awaiting Kick-off",
    matchStarted: "Match Started",
    lineupAnnouncement: "Lineups announced 60 mins before KO",
    noStatsSynced: "No stats synced",
    newsFeedSeoTitle: "Football Feed",
    newsFeedSeoDesc: "Check latest football news and real-time transfer rumors from major leagues around the world by date.",
    pexelsGallery: "Pexels Gallery",
    highFidelityAssets: "High fidelity football assets",
    tapToPlayWithSound: "Tap to Play with Sound",
    videoUnavailable: "This video is unavailable in your region or has been removed.",
    shortsPreparingTitle: "Preparing Shorts Videos",
    shortsPreparingDesc: "We are currently collecting the latest videos. Please check back shortly!",
    shortsSeoTitle: "Football Highlights & Shorts | XLEVEN",
    shortsSeoDesc: "Enjoy the hottest global football highlights and shorts videos seamlessly. Experience the best football moments recommended by AI.",
    round: "Round",
    searchAllLeagues: "Search leagues",
    noGlobalMatches: "No global matches found",
    recommendedLeagues: "Recommended Leagues",
    scoutingResultsFor: "Scouting results for",
    globalData: "Global Data",
    majorLeague: "Major League",
    newScouting: "New Scouting",
    aiMatchPrediction: "Strategic Match Intelligence",
    simulatingScenarios: "Executing High-Fidelity Simulation...",
    runSimulation: "Generate Analysis Report",
    predictionReady: "AI Prediction Ready",
    geminiAiEngine: "AI Core Engine",
    predictedWinner: "Expected Dominance",
    expectedScore: "Projected Outcome",
    tacticalInsight: "Analysis Rationale",
    resetSimulation: "Reset Simulation",
    aiSimulationDesc: "AI scouts simulate matches based on players latest form, historical statistics, and tactical data.",
    loginRequiredIntelligence: "Login required to access feed",
    seasonGoals: "Season Goals",
    seasonAssists: "Season Assists",
    seasonGames: "Season Games",
    seasonRating: "Season Rating",
    performanceHistory: "Performance History",
    detailedSeasonBreakdown: "Detailed Season Breakdown",
    recentForm: "Recent Form",
    transferHistory: "Transfer History",
    freeAgent: "Free Agent",
    noDetailedStats: "No detailed stats found for current team",
    noRecentData: "No Recent Match Data",
    careerNotAvailable: "Career intel not available",
    checkMail: "Check Mail",
    resetInstructionsSent: "Instructions to reset your password have been sent to",
    returnToPortal: "Return to Portal",
    joinScoutingNetwork: "Join the scouting network",
    verify: "Verify",
    passwordInvalid: "Password must be at least 8 characters and include letters, numbers, and special characters.",
    passwordMismatch: "Password mismatch. Please verify.",
    fillAllFields: "Please fill in all mandatory fields",
    deleteAccount: "Delete Account",
    deleteAccountConfirm:
      "Are you sure you want to delete your account? This action will permanently remove all your scouting data and history.",
    confirm: "Confirm",
    yes: "Yes",
    no: "No",
    closingAccount: "Closing Account...",
    selectionDone: "Done",
    viewAll: "View All",
    viewDetails: "View Details",
    bigMatch: "Big Match",
    post: "Post",
    discoverMore: "Discover More",
    shareSuccess: "Link copied to clipboard",
    consultingGrid: "Consulting Grid...",
    matchesFound: "Matches Found",
    zeroIntel: "Zero Intel",
    refineSearch: "Refine your search parameters",
    awaitingPersonnel: "Awaiting Personnel Ident",
    scanningFrequency: "Scanning News Frequency",
    searchNewsPlaceholder: "News Search",
    searchPlayerPlaceholder: "Search",
    searchGamePlaceholder: "Find matches...",
    searchShortsPlaceholder: "Search video highlights...",
    joined: "Joined",
    agentTools: "Agent Tools",
    supportInfo: "Support & Info",
    accountActions: "Account Actions",
    marketHotspots: "Market Hotspots",
    trendingIntel: "Hot Topic",
    squadBuilderTitle: "Match Expected Lineup",
    squadBuilderSub: "Tactical Squad Simulator",
    forwards: "Forwards",
    midfielders: "Midfielders",
    defenders: "Defenders",
    goalkeepers: "Goalkeepers",
    selectPersonnel: "Select Recent Personnel",
    personnelFound: "No matching personnel found",
    selectFormation: "Select Formation",
    searchingSector: "Searching Sector...",
    move: "Move",
    clear: "Clear",
    squadTheme: "Field Theme",
    themeGrass: "Fresh Grass",
    themeBlueprint: "Tactical Blueprint",
    themeStealth: "Night Stealth",
    themePremium: "Premium Gold",
    themeGlass: "Glass Morph",
    themePaper: "Classy Paper",
    themeCyber: "Cyber Grid",
    themeRetroMud: "Retro Mud",
    themeNeonFuture: "Neon Future",
    ftResult: "FT Result",
    scheduled: "Scheduled",
    stadiumCap: "Cap.",
    syncingIntel: "Syncing Intel...",
    standings: "Standings",
    scorers: "Scorers",
    assists: "Assists",
    assistsFor: "Assists",
    managerialCareer: "Managerial Career",
    singleMatchPerformance: "Single Match Performance",
    seasonIntelPerformance: "Season Performance",
    retrievingIntel: "Retrieving...",
    saveImage: "Image Save",
    shareToFeed: "Share",
    noSectorActivity: "No Sector Activity",
    noSectorActivityDesc: "Intelligence feed empty for this date",
    season2526: "Season 25/26",
    momentumEfficiency: "Momentum & Efficiency",
    avgGoals: "Avg Goals",
    perMatch: "per match",
    goalBalance: "Goal Balance",
    goalsFor: "Goals For",
    goalsAgainst: "Goals Against",
    offensiveDominance: "Offensive Dominance",
    defensiveLeakage: "Defensive Leakage",
    teamDNAIndices: "Team DNA Indices",
    matchoutcomeDistribution: "Match Outcome Distribution",
    cleanSheets: "Clean Sheets",
    failedToScore: "Failed to Score",
    scoredPenalties: "Scored Penalties",
    missedPenalties: "Missed Penalties",
    bigWins: "Big Wins",
    toughLosses: "Tough Losses",
    noVerifiedTransfers: "No verified market movements in the last 12 months",
    reportTitle: "Report Comment",
    reportDesc: "Select a reason for reporting",
    reportReasonSpam: "Spam or misleading",
    reportReasonHarassment: "Harassment or hate speech",
    reportReasonInappropriate: "Inappropriate content",
    reportReasonViolence: "Violence or harmful behavior",
    reportReasonOther: "Other",
    reportOtherPlaceholder: "Please specify the reason...",
    submitReport: "Submit Report",
    maxLeaguesReached: "Maximum 10 leagues can be selected.",
    maxLeaguesReachedGuest: "Maximum 3 leagues can be selected for non-members.",
    maintenanceTitle: "System Refreshing",
    maintenanceDesc: "We'll be back soon with fresh highlights.\nThank you for your patience.",
    maintenanceUntil: "Resume at KST 09:00 (UTC 00:00)",
    shareIntelligence: "Write News Feed",
    whatsHappening: "What's happening in football?",
    postSuccess: "Feed shared successfully",
    uploadingIntel: "Uploading...",
    addLink: "Add Link",
    linkPlaceholder: "Paste link here (e.g. https://...)",
    linkValidationError: "Link must start with https://",
    urlRestricted: "Access to this link is restricted by the site owner.",
    urlPaywall: "This article requires a subscription to view.",
    urlDynamicWarning: "This site contains complex content. Analysis might be limited.",
    aiAnalyzing: "Analyzing...",
    aiWaitNote: "This typically takes 20-40 seconds for full verification.",
    scoutingStatus1: "Contacting local scouting network...",
    scoutingStatus2: "Cross-referencing market values...",
    scoutingStatus3: "Synthesizing tactical insights...",
    scoutingStatus4: "Finalizing report...",
    aiTimeout: "Analysis taking too long (over 60s). Please try again or check the link.",
    aiNotFootball: "Please tell us the latest news in the football world.",
    aiDraftTitle: "AI Feed Draft",
    aiDraftSubtitle: "Ready to apply to your feed",
    extractedTitle: "Extracted Title",
    generatedContent: "Generated Content",
    aiDraftDisclaimer: "This draft is for reference. Click 'Apply' to bring it into the editor, then edit freely and post.",
    applyToEditor: "Apply to Editor",
    imageSourceLabel: "Source",
    noIntelTitle: "News Empty",
    noIntelDesc: "No news feed available for this date.",
    noSectorIntel: "Intelligence unavailable for this sector",
    newsTitle: "Title",
    translateToEn: "Translate to English",
    translateToKo: "Translate to Korean",
    translating: "Translating...",
    addSource: "Add Source",
    sourcePlaceholder: "Source name (e.g. bbc)",
    apiAndCopyright: "API & Copyright Info",
    noMajorGamesToday: "No Major Games Scheduled Today",
    adminTools: "Administrator Tools",
    adminControlCenter: "Admin Control Center",
    adminControlCenterDesc: "Manage users, posts and system protocol",
    addFavoriteLeaguesTitle: "Follow Your Leagues",
    addFavoriteLeaguesDesc: "Select your favorite leagues to get real-time scores and personalized updates on your home feed.",
    setupNow: "Set Up Now",
    addFavoriteLeaguesButton: "Add Favorite Leagues",
    deleteFeedConfirm: "Are you sure you want to delete this news post? This action cannot be undone.",
    reportFeedTitle: "Report News Post",
    editFeed: "Edit Feed",
    deleteFeed: "Delete Feed",
    reportFeed: "Report Feed",
    alreadyReported: "You have already reported this content.",
    reportCompleted: "Report has been successfully submitted.",
    externalSourceReportError: "External news sources cannot be reported directly.",
    postDeletedSuccess: "Feed Deleted Successfully",
    awaitingMarketIntel: "Awaiting market movement intel...",
    scanningSectorIntel: "Scanning sector intelligence...",
    noticeTitle: "XLEVEN System Intelligence Update",
    noticeBody:
      "The Gemini 2.5 AI engine is now active for high-fidelity football analysis. Enjoy real-time scouting reports and enhanced transfer market predictions.",
    dontShowToday: "Don't show again today",
    emailRequired: "Please enter your email address",
    resetFailed: "Failed to send reset link",
    resendFailed: "Failed to resend email",
    emailNotConfirmedMsg: "Email verification not complete. Check your inbox.",
    resendSuccess: "Transmission Success",
    resendAction: "Resend Verification Intel",
    invalidCredentials: "Invalid email or password.",
    tooManyRequests: "Too many requests. Please try again.",
    fixtures: "Fixtures",
    activeSource: "Selected League",
    updateSectors: "Update Leagues",
    configureIntelSources: "Set up your favorite leagues",
    searchingGlobalDatabase: "Searching...",
    noMatchingSectors: "No matching sectors found",
    majorLeagues: "Major Leagues",
    majorCups: "Major Cups",
    addedSectors: "Added Sectors",
    goToToday: "Go to Today",
    scanningGrid: "Scanning Grid...",
    rating: "Rating",
    goals: "Goals",
    passPercentage: "Pass %",
    dribbles: "Dribbles",
    defense: "Defense",
    captain: "Captain",
    injured: "Injured",
    club: "Club",
    played: "Pl",
    points: "Pts",
    goalDiff: "GD",
    win: "W",
    draw: "D",
    loss: "L",
    ucl: "UCL",
    uel: "UEL",
    uecl: "UECL",
    rel_po: "PO",
    rel: "REL",
    acle: "ACLE",
    acl2: "ACL2",
    noConcludedMatches: "No concluded match records found",
    loadingRecords: "Loading Records...",
    from: "from",
    to: "to",
    transfer: "Transfer",
    openOriginal: "Open original",
    refreshLiveData: "Refresh Live Data",
    syncingMatchIntelDesc: "Syncing Intel...",
    newPassword: "New Password",
    updatePassword: "Update Password",
    passwordChanged: "Password Changed!",
    passwordChangedDesc: "Your password has been successfully updated.",
    passwordMinLength: "Min 8 characters",
    passwordLetters: "Include letters",
    passwordNumbers: "Include numbers",
    passwordSpecial: "Include special characters",
    passwordMatch: "Passwords match",
    passwordSameAsOld: "New password must be different from the old one",
    resetIntel: "Reset Password",
    verifyIdentity: "Verify your identity",
    accountEmail: "Account Email",
    enterRegisteredEmail: "Enter your registered email",
    authorizeReset: "Authorize Reset",
    backToEntry: "Back to Entry",
    nicknameUpdated: "Nickname updated successfully.",
    profileImageUpdated: "Profile picture has been updated.",
    backgroundImageUpdated: "Background cover has been updated.",
    uploadFailed: "Something went wrong with the upload. Please try again.",
    fileSizeError: "The file is too large. Please select a file under 5MB.",
    pointHistory: "Point History",
    pointGuide: "Point Information",
    pointGuideDesc: "You can check your point history earned through activities. Points can be used in various services in the future.",
    noPointHistory: "No point history found.",
    loadingPointHistory: "Loading history...",
    gatheringIntel: "Gathering Intel...",
    syncingPointHistory: "Syncing Point History...",
    reasonDailyAttendance: "Daily Attendance",
    reasonWelcomePoints: "Welcome points for signing up",
    reason7DayBonus: "7-Day Attendance Bonus",
    reasonNewsPost: "News Feed Post",
    reasonNewsDelete: "News Feed Delete",
    reasonCommentPost: "News Comment Post",
    reasonCommentDelete: "News Comment Delete",
    reasonAiReport: "AI Intelligence Report",
    reasonRegularEarn: "Regular Earn",
    reasonAdminSpecialReward: "Admin Special Reward",
    reasonNeonPitch: "Play Game: NEON PITCH",
    reasonTripleBetMultiple: "Triple Bet Multiple Selection",
    reasonTripleBetAi: "Triple Bet AI Analysis",
    reasonFootyMaster: "Play Game: FOOTY MASTER",
    pointEarned: "Point earned!",
    pointDeducted: "Point deducted.",
    commentPosted: "Comment posted!",
    commentDeleted: "Comment deleted.",
    feedPosted: "Feed posted!",
    feedDeleted: "Feed deleted.",
    attendanceComplete: "Attendance complete!",
    firstLoginToday: "First login today!",
    deleteCancel: "Cancel Delete",
    deleteConfirmDesc: "This action cannot be undone. Are you sure?",
    editCancel: "Cancel Edit",
    editCancelDesc: "Changes will not be saved. Are you sure you want to exit?",
    postCancel: "Cancel Post",
    postCancelDesc: "Content will not be saved. Are you sure you want to exit?",
    errorLoadingImages: "Could not load images.",
    errorProcessingAttendance: "Error processing attendance.",
    errorAnalysis: "Error during analysis.",
    aiErrorTitle: "Analysis Service Error",
    aiErrorDesc: "Please try again later.",
    errorReport: "Report failed.",
    errorDelete: "Delete failed.",
    loginRequired: "Login required.",
    enterTitleAndContent: "Please enter title and content.",
    inquirySubmitted: "Inquiry submitted successfully.",
    errorInquiry: "Failed to submit inquiry.",
    category: "Category",
    title: "Title",
    content: "Content",
    inquiryPlaceholder: "Describe your inquiry in detail",
    titlePlaceholder: "Enter inquiry title",
    inquiryNote: "Your inquiry will be answered sequentially. Responses may be delayed on weekends and public holidays.",
    submitInquiry: "Submit Inquiry",
    attendanceStreak: "Attendance Streak",
    attendanceNote: "Check in daily for bigger rewards",
    attendanceCompleted: "Attendance Completed",
    checkAttendanceNow: "Check Attendance Now",
    weeklyProgress: "Weekly Progress",
    baseReward: "Base Reward",
    streakBonus: "Streak Bonus",
    attendanceResetNote: "Check-in resets daily at midnight (00:00).",
    present: "Present",
    frame: "Frame",
    searchPlaceholder: "Search by reason, reporter or content...",
    playerAndTransferManagement: "Player & Transfer Management",
    playerManagementDesc: "Manage transfer market data and player groups",
    latestTransfers: "Latest Transfers",
    groupList: "Group List",
    playerSearchPlaceholder: "Search by player or club...",
    addItem: "Add Item",
    playerIntel: "Player Intel",
    movement: "Movement",
    valueFee: "Value/Fee",
    noItemsFound: "No personnel assets found",
    createGroup: "Create Group",
    editGroup: "Edit Group",
    addPersonnel: "Add Personnel",
    editPersonnel: "Edit Personnel",
    deleteItem: "DeleteItem",
    deleteGroupConfirmDesc:
      "Are you sure you want to delete this group? All personnel data within this group will also be permanently removed.",
    deleteItemConfirmDesc: "Are you sure you want to remove this personnel asset? This action cannot be undone.",
    systemSettingsDesc: "Manage system core engine and network policies",
    awardPoints: "Award Points",
    awardPointsDesc: "Award points to this user.",
    award: "Award",
    awardSuccess: "Points awarded successfully.",
    amount: "Amount",
    reason: "Reason",
    auditIntelligenceDesc: "Review and manage community shared intel",
    auditReportsDesc: "Review and manage all incident reports",
    noResultsFound: "No results found",
    noTrendingData: "No trending data",
    pointDeduction: "Point Deduction",
    insufficientPoints: "Insufficient Points",
    rechargeRequired: "Recharge Required",
    allMatchFixtures: "All Match Fixtures",
    leagueMatchFixtures: "Match Fixtures",
    allMatchFixturesDesc: "Check live scores, schedules and results of major leagues worldwide.",
    playerStatsDesc: "Check detailed data, season stats, transfer history and recent form.",
    newsFeedDesc: "Check latest football news and real-time transfer rumors by date.",
    shortsDesc: "Enjoy the hottest football highlights and shorts videos seamlessly.",
    maintenanceResumes: "Resume at KST 09:00 (UTC 00:00)",
    swipeGuide: "Swipe left or right",
    swipeDateGuide: "to see news by date",
    apiInfoDesc1:
      "XLEVEN receives all real-time match results, player statistics, lineups, and transfer information from API-Sports (API-Football). The original rights to this data belong to the provider and each league federation.",
    apiInfoDesc2:
      "Transfer prediction analysis and news summary services are generated through the Google Gemini AI engine. All analysis reports generated by artificial intelligence are for reference only and have no legal effect.",
    apiInfoDesc3:
      "Video highlights and shorts content are provided in an embedded format through the YouTube Data API. All copyrights to the videos belong to the respective platform channel owners.",
    apiInfoDesc4:
      "Key visual materials and background images used in news feeds and articles utilize royalty-free license resources provided by BBC Sport RSS and Pexels.",
    apiInfoDesc5:
      "The copyright for all visual materials such as club logos, league emblems, and actual player photos used within this service belongs to each original copyright holder (club, league federation, news agency, etc.).",
    apiInfoDesc6:
      "XLEVEN utilizes these materials only for the purposes of public interest reporting, statistics, and data analysis, and under no circumstances will images be altered without authorization or resold for commercial purposes. If a copyright infringement report is received, immediate action will be taken after internal review.",
    apiSportsData: "Sports Data API",
    apiAiIntelligence: "AI Analysis",
    apiMediaVideo: "Media & Video",
    apiNewsAssets: "News Assets",
    apiBbcSource: "BBC Sport News Sources",
    apiCopyrightDisclaimer: "Copyright Disclaimer",
    privacyDesc1:
      'XLEVEN (hereinafter "this site") values the user\'s personal information and complies with relevant laws and regulations. This privacy policy explains what information is collected and how it is used when the user uses this site.',
    privacySection1Title: "1. Personal Information Items Collected",
    privacySection1Desc:
      "This site basically does not collect personal information directly. However, the following information may be automatically collected during the service use process.",
    privacySection2Title: "2. Purpose of Use of Personal Information",
    privacySection2Desc: "The collected information is used for the following purposes.",
    privacySection3Title: "3. Information on Cookie Usage",
    privacySection3Desc1:
      "This site may use cookies. Cookies are a small amount of data stored in the user's browser, and are used by the site to remember user preferences and provide better service.",
    privacySection3Desc2:
      "Users can refuse to store cookies through browser settings, and if cookies are refused, there may be restrictions on using some services.",
    privacySection4Title: "4. Google AdSense and Third-Party Advertising",
    privacySection4Desc1: "This site uses third-party advertising services, including Google AdSense.",
    privacySection4Desc2:
      "Third-party advertising providers, such as Google, use cookies to serve ads based on a user's previous visits.",
    privacySection4Desc3:
      "Google's advertising cookie (DART cookie) provides personalized advertisements when users visit this site and other sites.",
    privacySection4Desc4: "Users can disable personalized advertisement on the Google Ad settings page.",
    privacySection4Link: "Check Google Privacy Policy",
    privacySection5Title: "5. Provision of Personal Information to Third Parties",
    privacySection5Desc:
      "This site does not sell or share user's personal information with third parties. However, exceptions are made when required by law.",
    privacySection6Title: "6. External Links",
    privacySection6Desc:
      "This site may contain links to external websites. This site is not responsible for the privacy policies and content of external sites.",
    privacyContactEmail: "Email",
    privacyContactSite: "Site Name",
    privacyEffectiveDate: "Effective Date: January 20, 2026",
    privacyItemIP: "IP Address",
    privacyItemBrowser: "Browser Type",
    privacyItemDate: "Visit Date/Time",
    privacyItemPage: "Visited Pages",
    privacyItemCookie: "Cookies",
    privacyUsageStats: "Site usage statistics analysis",
    privacyUsageImprove: "Content and user experience improvement",
    privacyUsageAds: "Ad service provision and optimization",
    privacySection5Desc1: "This site uses 'cookies' to provide optimized services and display advertisements. Cookies are small text files that a website stores on the user's browser.",
    privacySection5Desc2: "Third-party vendors, including Google, use cookies to serve ads based on a user's prior visits to your website or other websites. Google's use of advertising cookies enables it and its partners to serve ads to your users based on their visit to your sites and/or other sites on the Internet.",
    privacySection5Desc3: "Users may opt out of personalized advertising by visiting Ads Settings (https://www.google.com/settings/ads). Alternatively, you can opt out of a third-party vendor's use of cookies for personalized advertising by visiting www.aboutads.info.",
    termsSection1Title: "Article 1 (Purpose)",
    termsSection1Desc: "These Terms of Service aim to define the conditions and procedures for using all services provided by XLEVEN (hereinafter 'Site'), and the rights, obligations, and responsibilities of the user and the Site.",
    termsSection2Title: "Article 2 (Definition of Terms)",
    termsSection2Desc: "1. 'User' refers to members and non-members who access the site and use services in accordance with these terms.\n2. 'Content' refers to football news, data, analysis reports, etc., provided by the site.",
    termsSection3Title: "Article 3 (Effect and Revision of Terms)",
    termsSection3Desc: "The Site may revise these terms within the scope of not violating relevant laws, and the revised terms take effect by being posted through notices within the site.",
    termsSection4Title: "Article 4 (Service Contents)",
    termsSection4Desc: "The Site provides real-time football scores, news feeds, AI data analysis, and community services. Service contents may change depending on technical specification changes.",
    termsSection5Title: "Article 5 (Post and Data Copyright)",
    termsSection5Desc: "1. All news and data provided by the Site are protected by copyright law.\n2. Users shall not use the information obtained through the service for commercial purposes or allow third parties to use it by reproduction, transmission, publication, distribution, broadcasting, or other methods without prior approval from the Site.",
    termsSection6Title: "Article 6 (Advertisement Placement)",
    termsSection6Desc: "The Site may place advertisements on service screens in connection with the operation of services. This is an essential part of continuing to provide the best content services.",
    dailyAttendance: "Daily Attendance",
    pointHistoryDesc:
      "Check your points earned through activities. Points can be used for various services in the future.",
    inquiryHistory: "Inquiry History",
    myInquiryHistory: "My Inquiry History",
    emailSupport: "Email Support",
    myHistory: "My History",
    newInquiry: "New Inquiry",
    noInquiryHistory: "No inquiry history found.",
    pending: "Pending",
    completed: "Completed",
    response: "Response",
    inquiryGeneral: "General",
    inquiryAccount: "Account/Login",
    inquiryContent: "Content/Correction",
    inquiryError: "Error Report",
    inquirySuggestion: "Feature Suggestion",
    clearLocalStorage: "Clear Local Storage",
    clearLocalStorageConfirm:
      "Are you sure you want to clear all local data except your user info? This will reset your preferences and temporary data.",
    attendance: "Attendance",
    attendanceDesc: "Get daily bonuses",
    favoriteTeams: "Favorite Teams",
    favoriteTeamsDesc: "Football teams I follow",
    matchPredictions: "Match Predictions",
    matchPredictionsDesc: "My AI match tactical reports",
    pointHistoryTitle: "My Point History",
    pointHistorySub: "Check your earn and usage history",
    english: "English (UK)",
    korean: "Korean (KR)",
    clearingData: "Clearing data...",
    logoutConfirm: "Are you sure you want to log out?",
    teamDetails: "Team Details",
    teamNotFound: "Team info not found.",
    homeStadium: "Home Stadium",
    recentMatches: "Recent Matches",
    squad: "Squad",
    goalkeeper: "Goalkeeper",
    defender: "Defender",
    midfielder: "Midfielder",
    attacker: "Attacker",
    languageSaveSuccess: "Language settings saved.",
    languageAiNote: "AI-generated news summaries and analysis will be provided in your selected language.",
    "Shots on Goal": "Shots on Goal",
    "Shots off Goal": "Shots off Goal",
    "Total Shots": "Total Shots",
    "Blocked Shots": "Blocked Shots",
    "Shots insidebox": "Shots Inside Box",
    "Shots outsidebox": "Shots Outside Box",
    "Fouls": "Fouls",
    "Corner Kicks": "Corner Kicks",
    "Offsides": "Offsides",
    "Ball Possession": "Ball Possession",
    "Yellow Cards": "Yellow Cards",
    "Red Cards": "Red Cards",
    "Goalkeeper Saves": "Goalkeeper Saves",
    "Total passes": "Total Passes",
    "Passes accurate": "Passes Accurate",
    "Passes %": "Passes %",
    "Expected Goals": "Expected Goals",
    expected_goals: "Expected Goals (xG)",
    goals_prevented: "Goals Prevented",
    noContentFound: "No Content Found",
    noContentDesc: "There is no data to display at the moment. Would you like to check other menus?",
    emptyStateIntelligence: "XLEVEN analyzes and provides real-time data from major leagues around the world. Data matching your current criteria might not have been collected yet or is being updated. Please try again in a moment or explore other league information.",
    unlockFullIntel: "Unlock full intel",
    careerIntelNotAvailable: "Career intel not available",
    capturingImage: "Generating image...",
    classicGround: "Classic Ground",
    realStadium: "Real Stadium",
    imageUploadFailed: "Failed to upload image.",
    captureFailed: "Capture failed.",
    noFavoriteTeams: "No Favorite Teams",
    noFavoriteTeamsDesc: "Tap the heart icon on match detail pages to add your favorite teams.",
    removeFavoriteTeam: "Remove Favorite Team",
    removeFavoriteTeamConfirm: "Are you sure you want to remove this team from your favorites?",
    setDefaultTeamTitle: "Set as Default Team?",
    setDefaultTeamDesc: "Would you like to set this team as your default team? Only one team can be set as default.",
    defaultTeam: "Default Team",
    selectDefaultTeam: "Select as default team",
    contactSupport: "Contact Support",
    contactSupportDesc: "Contact XLEVEN support for any questions or issues.",
    mySupportHistory: "My Support History",
    mySupportHistoryDesc: "Check your support history and responses.",
    myPageDesc: "Manage your profile, check attendance, view point history, and AI match prediction reports on XLEVEN My Page.",
    attendanceDescSEO: "Check in daily and earn bonus points.",
    pointHistoryDescSEO: "Check your point earn and usage history.",
    playerAge: "Age",
    playerHeight: "Height",
    playerWeight: "Weight",
    matchPredictionsDescSEO: "Check your AI-analyzed match prediction data and tactical reports.",
    recentActivityDescSEO: "Check your comments and community activity history.",
    favoriteLeaguesDescSEO: "Select leagues to follow and get customized football information.",
    favoriteTeamsDescSEO: "Check your list of favorite football teams you follow.",
    languageDescSEO: "Change your service language.",
    copySuccess: "Link copied to clipboard",
    copyFailed: "Copy failed",
    allMatchFixturesSeoTitle: "All Match Fixtures",
    allMatchFixturesSeoDesc: "Check live scores, schedules and results of major leagues worldwide.",
    leagueMatchFixturesSeoTitle: "Match Fixtures",
    leagueMatchFixturesSeoDesc: "Check live scores, schedules and results of {{leagueName}}.",
    noticeUpdate: "Notice Update",
    checkNow: "Check Now",
    deleteFailed: "Failed to delete.",
    reportFailed: "Report failed.",
    scanningSectorData: "Scanning Sector Data...",
    searchResults: "Search Results",
    analysisFailed: "Analysis failed",
    feedPostPointEarned: "Feed posted! +{{amount}}P earned",
    failedToPostNews: "Failed to post news feed",
    feedDeletePointDeducted: "10P deducted for deleting feed.",
    failedToDelete: "Delete failed",
    seoDefaultDescription: "Global football news, real-time transfer rumors, match highlights, and AI data analysis reports. Get the fastest updates on Premier League, La Liga, Champions League, and more at XLEVEN.",
    seoDefaultKeywords: "football news, transfer rumors, live scores, football analysis, Premier League, La Liga, Champions League, AI football prediction",
    seoHomeTitle: "Global Football News & Real-time Transfer Rumors AI Analysis",
    topTransfersSeoDesc: "Analyze major transfers with the highest transfer fees of all time and their details.",
    latestMovementsSeoDesc: "Get the latest real-time transfer status and official announcements in football as fast as possible.",
    playerDetailSeoDesc: "Check out {{playerName}}'s detailed data, season stats, transfer history, and recent form.",
    playerDetailSeoTitle: "{{playerName}} - {{position}} ({{team}})",
    synchronizingIntelligence: "Synchronizing Intelligence...",
    summer: "Summer",
    winter: "Winter",
    dataProvidedBy: "Data provided by",
    leagueHighlightsSeoDesc: "Check out the latest football match highlights of {{leagueName}}.",
    matches: "Matches",
    gameStoreTitle: "Football Games",
    newGamePreparing: "New Games Coming Soon",
    newGamePreparingDesc: "Special football games exclusive to XLEVEN will be released soon. Please stay tuned!",
    ranking: "Ranking",
    play: "Play",
    gameRanking: "Game Ranking",
    fetchingRankings: "Fetching Rankings...",
    noRankingsYet: "No rankings yet",
    preparing: "Preparing...",
    toto_history: "Prediction History",
    toto_submit: "Submit",
    toto_check_predictions: "Check Predictions",
    toto_round_format: "Round {{n}}",
    toto_finished: "Finished",
    toto_in_progress: "In Progress",
    toto_success_count: "Successful Predictions",
    toto_submitted_at: "Submitted At",
    toto_not_participated: "You did not participate in this round.",
    toto_detailed_results: "Detailed Prediction Results",
    toto_correct: "Correct",
    toto_incorrect: "Incorrect",
    toto_my_pick: "(My Pick)",
    toto_result: "(Result)",
    toto_win: "W",
    toto_draw: "D",
    toto_loss: "L",
    toto_ai_winner: "Winner",
    toto_ai_score: "Score",
    toto_ai_win_rate: "Win Rate",
    toto_ai_tactical: "Tactical Analysis",
    toto_save_failed: "Failed to save.",
    toto_predictions_status: "Predictions Status",
    toto_view_analysis: "View Analysis",
    toto_ai_analysis: "AI Analysis",
    toto_predict_title: "Predict 14 matches",
    toto_win_points: "and win points!",
    toto_challenge_win: "Challenge & Win",
    toto_players_joined: "{{count}} players joined",
    toto_rules_title: "Game Rules",
    toto_rules_policy: "TRIPLE BET Game Policy",
    toto_rules_1: "Only one result can be selected per match.",
    toto_rules_2: "Earn 10 points and 10 score per correct prediction.",
    toto_rules_3: "10p deduction for AI analysis.",
    toto_rules_4: "Multiple picks allowed up to 20.",
    toto_rules_5: "No deduction up to 14. 15(10p), 16(20p), 17(30p) deduction. Total 210p for 20 picks.",
    toto_rules_6: "* Limited access if points are insufficient.",
    toto_login_required: "Login Required",
    toto_login_desc: "Please login to participate in the TOTO game.",
    toto_login_button: "Login Now",
    toto_no_round_title: "No Active Rounds",
    toto_no_round_desc: "A new round will start soon. Please wait!",
    toto_already_participated: "You have already participated.",
    webtoonHeroTitle: "Football, and Beyond",
    webtoonHeroTitleColor: "XLEVEN Webtoon",
    webtoonHeroDesc: "Original football webtoon series updated weekly. Discover special stories you won't find anywhere else.",
    noWebtoons: "No webtoons registered yet.",
    webtoonSeoTitle: "Football Webtoon Collection",
    webtoonSeoDesc: "Discover the latest football webtoons at XLEVEN. Enjoy original football stories and series updated weekly.",
    toto_round_expired: "This round has ended.",
    toto_submit_expired: "Purchase is not available as the deadline has passed.",
    toto_predict_all: "Please predict all matches.",
    toto_insufficient_points: "Insufficient points. (Required: {{amount}}p)",
    toto_saved_with_deduction: "Saved! ({{amount}}p deducted)",
    toto_saved_success: "Saved successfully!",
    toto_ai_completed: "AI Analysis completed!",
    toto_ai_error: "Error during analysis.",
    toto_exit_title: "Exit game?",
    toto_exit_desc: "Your predictions will not be saved.",
    toto_exit_confirm: "Exit",
    toto_exit_cancel: "Cancel",
    toto_seo_title: "Triple Bet Challenge - Weekly Football Prediction Game",
    toto_seo_description: "Predict the outcomes of football matches from leagues worldwide updated every week and earn points. Increase your win probability with AI analysis data.",
    toto_seo_keywords: "Triple Bet, Football Prediction, Toto, XLEVEN, Sports Betting, Football Analysis",
    toto_result_seo_title: "My Triple Bet History - Football Prediction Game Results",
    toto_result_seo_description: "Check your weekly football match prediction results and earned points. Analyze your accuracy with detailed match reports.",
    toto_result_seo_keywords: "Triple Bet Results, Football Prediction History, Soccer Toto, XLEVEN, Match Accuracy",
    neon_pitch_seo_title: "NEON PITCH - Retro Football Arcade Game",
    neon_pitch_seo_description: "Experience the thrill of retro football arcade. Control the neon ball, dodge obstacles, and aim for the high score in NEON PITCH.",
    neon_pitch_seo_keywords: "Neon Pitch, Football Game, Arcade Game, Retro Soccer, XLEVEN Games, HTML5 Game",
    neon_pitch_score: "Score",
    neon_pitch_best: "BEST",
    neon_pitch_time_left: "Time Left",
    neon_pitch_streak: "STREAK!",
    neon_pitch_fever_unleashed: "GOAL FEVER UNLEASHED!",
    neon_pitch_adrenaline_gauge: "ADRENALINE GAUGE",
    neon_pitch_instructions: "Score as many points as you can!",
    neon_pitch_exit: "EXIT TO STORE",
    neon_pitch_full_time: "Full Time",
    neon_pitch_total_score: "Total Score",
    neon_pitch_max_combo: "MAX COMBO",
    neon_pitch_rematch: "PLAY REMATCH",
    neon_pitch_deduction_toast: "10P Deducted",
    neon_pitch_kickoff: "KICK OFF",
    neon_pitch_insufficient_points: "Insufficient points.",
    viewTranslation: "See Translation",
    viewOriginal: "See Original",
    selectPostType: "Select Post Type",
    overallStrength: "Overall Strength",
    attackPower: "Attack Power",
    defensePower: "Defense Power",
    winProbability: "Win Probability",
    strength: "Strength",
    attackingPotential: "Attacking Potential",
    defensivePotential: "Defensive Potential",
    poissonDistribution: "Poisson Distribution",
    strengthH2h: "Strength H2H",
    goalsH2h: "Goals H2H",
    winsTheGame: "Wins The Game",
    headToHead: "Head to Head",
    last10Matches: "Last 10 Matches",
    lastNMatches: "Last {n} Matches",
    viewH2HDetail: "View detailed H2H record",
    footy_master_preparing_arena: "Preparing Arena...",
    footy_master_trivia_quiz: "Football Trivia Quiz",
    footy_master_high_score: "High Score",
    footy_master_start_desc: "Show off your football knowledge and earn points!",
    footy_master_questions: "Questions",
    footy_master_random: "10 Random",
    footy_master_time_limit: "Time Limit",
    footy_master_time_s_q: "15s / Q",
    footy_master_get_started: "GET STARTED",
    footy_master_back_to_store: "Exit",
    footy_master_back_to_start: "Back to Start",
    footy_master_question_n_of_m: "Question {{n}} of {{m}}",
    confirmDelete: "Are you sure you want to delete this highlight?",
    footy_master_mission_complete: "Mission Complete",
    footy_master_total_score: "Total Score",
    footy_master_accuracy: "Accuracy",
    footy_master_play_again: "PLAY AGAIN",
    footy_master_exit_to_store: "EXIT TO STORE",
    footy_master_cat_worldcup: "World Cup",
    footy_master_cat_epl: "EPL",
    footy_master_cat_laliga: "La Liga",
    footy_master_cat_ucl: "UCL",
    footy_master_cat_kleague: "K-League",
    footy_master_commentary_perfect: "Perfect! You're a walking football encyclopedia! 🏆⚽️",
    footy_master_commentary_great: "Great job! You're almost an expert! 🔥👏",
    footy_master_commentary_good: "Not bad! Just a little more to become a master! 💪✨",
    footy_master_commentary_average: "You might need a bit more study! Shall we try again? 📚⚽️",
    footy_master_commentary_poor: "It's okay! The road to becoming a master is always tough! 🏃‍♂️🌟",
    footy_master_seo_title: "FOOTY MASTER - Global Football Trivia Quiz Game",
    footy_master_seo_description: "Show off your football knowledge! Solve trivia quizzes about World Cup, EPL, La Liga, and UCL to earn points and become a Footy Master.",
    footy_master_seo_keywords: "Footy Master, Football Quiz, Soccer Trivia, Football Game, World Cup Quiz, EPL Quiz, XLEVEN Games",
    noCommentsYet: "No comments yet",
    addAComment: "Add a comment...",
    deleteCommentConfirm: "Delete this comment?",
    matchTalk: "Match Talk",
    phantomStadium: "Phantom Stadium",
    matchAnalysis: "Match Analysis",
    noPostsFound: "No posts found",
    beTheFirstToPost: "Be the first to post!",
    noAnalysisFound: "No analysis found",
    beTheFirstToAnalyze: "Be the first to analyze!",
    viewMore: "See more",
    deleteConfirm: "Confirm Deletion",
    deleteConfirmMessage: "Are you sure you want to delete this content? This action cannot be undone.",
    viewReplies: "View Replies",
    hideReplies: "Hide Replies",
    failedToLoadQuizzes: "Failed to load quizzes",
    quizCreatedSuccessfully: "Quiz created successfully",
    quizDeleted: "Quiz deleted",
    deleteSuccess: "Deleted successfully",
    reportSubmitted: "Report submitted",
    failedToDeductPoints: "Failed to deduct points",
    failedToUpdatePassword: "Failed to update password",
    failedToUpdateNickname: "Failed to update nickname",
    fileSizeUnder5MB: "File size must be under 5MB",
    saveFailed: "Save failed",
    supportXlevenService: "Support XLEVEN service",
    setFavoriteTeamFirst: "Please set as a favorite team first.",
    aiTacticalInsight: "AI Tactical Insight",
    strategicAnalysisReport: "Strategic Analysis Report",
    winProbabilityDistribution: "Win Probability Distribution",
    aiConfidence: "AI Confidence",
    hotPost: "Hot Post",
    syncingActivities: "Syncing Activities...",
    intelligenceReport: "Intelligence Report",
    matchIntel: "Match Intel",
    koreanFeed: "Korean Feed",
    englishFeed: "English Feed",
  },
    ko: {
      popularFavoriteTeams: '인기 관심 팀',
      stadiumPostTitle: "스타디움 게시물 작성",
      stadiumPostPlaceholder: "팀의 팬들과 나누고 싶은 이야기를 적어주세요.",      
      awaitingData: "경기 데이터를 기다리는 중...",
      awaitingDataDesc: "경기가 시작되었으나 아직 실시간 정보가 제공되지 않고 있습니다. 잠시만 기다려 주세요.",
      injuryList: "부상자",
      injuryReason_Injury: "부상",
      injuryReason_RedCard: "퇴장",
      injuryReason_Internationalduty: "국가대표 소집",
      injuryReason_YellowCards: "경고 누적",
      injuryReason_LowerBackInjury: "허리 부상",
      injuryReason_ChestInjury: "가슴 부상",
      injuryReason_Jumpersknee: "점퍼즈 니(무릎 인대염)",
      injuryReason_ToeInjury: "발가락 부상",
      injuryReason_Inactive: "명단 제외",
      injuryReason_KneeInjury: "무릎 부상",
      injuryReason_AnkleInjury: "발목 부상",
      injuryReason_HamstringInjury: "햄스트링 부상",
      injuryReason_ThighInjury: "허벅지 부상",
      injuryReason_CalfInjury: "종아리 부상",
      injuryReason_GroinInjury: "사타구니 부상",
      injuryReason_MuscleInjury: "근육 부상",
      injuryReason_FootInjury: "발 부상",
      injuryReason_LegInjury: "다리 부상",
      injuryReason_BrokenLeg: "다리 골절",
      injuryReason_ACLInjury: "십자인대 부상",
      injuryReason_MCLInjury: "내측인대 부상",
      injuryReason_ShoulderInjury: "어깨 부상",
      injuryReason_BackInjury: "등/허리 부상",
      injuryReason_HipInjury: "고관절 부상",
      injuryReason_HeadInjury: "머리 부상",
      injuryReason_Concussion: "뇌진탕",
      injuryReason_WristInjury: "손목 부상",
      injuryReason_HandInjury: "손 부상",
      injuryReason_BrokenHand: "손 골절",
      injuryReason_BrokenArm: "팔 골절",
      injuryReason_ArmInjury: "팔 부상",
      injuryReason_Sick: "질병",
      injuryReason_Illness: "질병",
      injuryReason_Fever: "발열",
      injuryReason_Virus: "바이러스",
      injuryReason_Infection: "감염",
      injuryReason_Knock: "타박상",
      injuryReason_Bruise: "멍/타박상",
      injuryReason_Strain: "긴장/염좌",
      injuryReason_Sprain: "염좌",
      injuryReason_Tear: "파열",
      injuryReason_Surgery: "수술",
      injuryReason_PhysicalCondition: "컨디션 난조",
      injuryReason_Rest: "휴식",
      injuryReason_PersonalReasons: "개인 사정",
      injuryReason_Suspended: "징계 중",
      injuryReason_Doubtful: "출전 불투명",
      injuryReason_Achillestendonproblems: "아킬레스건 부상",
      injuryReason_fitness: "피트니스 문제",
      injuryReason_Injurytotheankle: "발목 부상",
      injuryReason_injured: "부상 중",
      injuryReason_InjuredDoubtful: "부상/출전 불투명",
      injuryReason_Suspension: "징계 중",
      injuryReason_RedcardSuspended: "퇴장 징계 중",
      injuryReason_Muscularproblems: "근육 문제",
      injuryReason_Thighproblems: "허벅지 부상",
      injuryReason_KneeSurgery: "무릎 수술",
      injuryReason_Outerligamenttear: "외측인대 파열",
      injuryReason_Kneeinjury: "무릎 부상",
      injuryReason_Rupturedcruciateligament: "십자인대 파열",
      injuryReason_FracturedFinger: "손가락 골절",
      injuryReason_Sprainedankle: "발목 염좌",
      injuryReason_UnknownInjury: "미상의 부상",
      sponsorshipTitle: "XLEVEN 후원하기",
      sponsorshipDesc: "가장 빠른 축구 인텔리전스와 AI 분석 서비스를 지속할 수 있도록 힘을 보태주세요. 여러분의 응원이 큰 힘이 됩니다!",
      supportSmallCoffee: "작은 커피 한 잔 후원하기",
      qrDonation: "QR 코드 후원",
      qrDonationDesc: "QR 코드를 스캔하여 간편하게 마음을 전하세요",
      sponsorshipWhy: "왜 후원이 필요한가요?",
      sponsorshipWhyDesc: "보내주시는 소중한 후원금은 서버 유지비와 AI API 비용으로 사용되며, 더 혁신적인 축구 분석 기능을 개발하는 데 큰 도움이 됩니다.",
      magazineArchive: "아카이브",
    magazineCollection: "컬렉션",
    magazineDiscover: "새로운 축구",
    magazineDeepStories: "인텔리전스",
    magazineHeroDesc: "엄선된 인사이트, 독점 인터뷰 및 전술적 정수를 만나보세요.",
    notices: "공지사항",
    noNotices: "공지사항이 없습니다",
    noNoticesDesc: "새로운 소식이 올라오면 알려드릴게요",
    allLeagues: "모든 리그",
    home: "홈",
    news: "피드",
    player: "선수",
    games: "경기",
    shorts: "숏츠",
    settings: "설정",
    mypage: "마이페이지",
    gamestore: "게임",
    community: "커뮤니티",
    realTimeMatchTalk: "실시간 경기 톡",
    recommendedForYou: "최신 피드",
    latestTransferNews: "이적 시장 동향",
    helpCenter: "고객 센터",
    contactUs: "문의하기",
    privacyPolicy: "개인정보 처리방침",
    termsOfService: "이용약관",
    aboutUs: "사이트 소개",
    aboutXleven: "XLEVEN 소개",
    aboutXlevenDesc:
      "XLEVEN은 AI 기술을 활용하여 가장 빠른 축구 소식을 제공합니다. 실시간 뉴스, 이적 루머, 데이터 기반의 예측 서비스를 경험해 보세요.",
    sponsorship: "후원하기",
    marketWatch: "이적 시장",
    topTransfers: "주요 이적",
    latestHeadlines: "최신 뉴스",
    verifiedSources: "검증된 출처",
    stats: "통계",
    playingCareer: "선수 경력",
    fanZone: "팬 존",
    trendingTopic: "인기 토픽",
    analyze: "이적 예측 분석",
    analyzing: "분석 중...",
    undisclosed: "비공개",
    unknown: "알 수 없음",
    noTransfers: "이적 정보를 찾을 수 없습니다: ",
    comingSoon: "v2.0 출시 예정",
    language: "언어",
    loginRequired: "로그인이 필요한 서비스입니다.",
    selectLanguage: "언어 선택",
    clearCache: "데이터 캐시 삭제",
    cacheCleared: "캐시 삭제됨",
    all: "전체",
    global: "전체",
    epl: "EPL",
    laliga: "라리가",
    seriea: "세리에A",
    bundesliga: "분데스리가",
    ligue1: "리그1",
    uefa: "UEFA",
    live: "라이브",
    replay: "다시보기",
    latest: "최신",
    worldCup: "월드컵",
    leagues: "리그",
    weeklyMagazine: "매거진",
    magazine: "매거진",
    read: "읽음",
    welcome: "다시 오신 것을 환영합니다",
    enterCredentials: "로그인을 위해 정보를 입력해주세요.",
    continueWithGoogle: "Google 계정으로 계속하기",
    continueWithKakao: "카카오 계정으로 계속하기",
    continueWithNaver: "네이버 계정으로 계속하기",
    or: "또는",
    emailAddress: "이메일 주소",
    password: "비밀번호",
    signInAccount: "로그인",
    noAccount: "계정이 없으신가요?",
    createAccount: "회원가입",
    fullName: "닉네임",
    confirmPassword: "비밀번호 확인",
    startExploration: "탐색 시작하기",
    joinNow: "가입하기",
    recentActivity: "최근 활동",
    recentActivityDesc: "최근 활동 기록",
    followedPlayers: "팔로우한 선수",
    followedPlayersDesc: "관심 선수 목록 관리",
    favoriteClubs: "관심 구단",
    favoriteClubsDesc: "팀 업데이트 및 알림",
    pushNotifications: "푸시 알림",
    pushNotificationsDesc: "실시간 이적 시장 알림",
    darkMode: "다크 모드",
    supportLegal: "지원 및 약관",
    storagePrivacy: "저장소 및 개인정보",
    storagePrivacyDesc: "로컬 저장 공간 비우기",
    logOutAccount: "계정 로그아웃",
    verifiedProfile: "인증된 프로필",
    proMember: "프로 멤버",
    activity: "활동",
    applicationSettings: "애플리케이션 설정",
    back: "뒤로가기",
    forgotPassword: "비밀번호를 잊으셨나요?",
    secureSSL: "보안 연결됨",
    alreadyMember: "이미 계정이 있으신가요?",
    signIn: "로그인",
    authenticating: "인증 중...",
    securingData: "데이터 동기화 중...",
    accessGranted: "접속 성공!",
    scoutingProfileSync: "스카우팅 프로필이 안전하게 동기화되었습니다.",
    dataLinkActive: "데이터 연결 활성화됨",
    redirecting: "대시보드로 이동 중...",
    editNickname: "닉네임 변경",
    save: "저장",
    cancel: "취소",
    nicknameError: "닉네임은 2자에서 20자 사이여야 합니다.",
    favoriteLeagues: "관심 리그",
    favoriteLeaguesDesc: "내가 팔로우한 경기 카테고리",
    manageLeagues: "관심 리그 선택",
    saveChanges: "설정 저장",
    selectLeaguesToFollow: "팔로우하고 싶은 리그를 선택하세요",
    syncSuccess: "설정이 성공적으로 저장되었습니다",
    today: "오늘",
    dailyAttendance: "일일 출석",
    reasonWelcomePoints: "회원가입 환영 포인트",
    last7Days: "최근 7일",
    last30Days: "최근 30일",
    allTime: "전체 기간",
    activityStats: "리그 순위 및 기록",
    totalInteractions: "총 활동량",
    loadingLeagues: "리그 목록을 불러오는 중...",
    following: "팔로잉",
    views: "조회",
    comments: "댓글",
    discussionHub: "댓글 토론",
    reasonDailyAttendance: "일일 출석",
    syncingHub: "댓글 동기화 중...",
    firstIntelligenceReport: "첫 번째 댓글을 남겨보세요",
    relatedIntelligence: "관련 뉴스",
    relatedNews: "관련 뉴스",
    reply: "답글",
    report: "신고",
    delete: "삭제",
    replyingTo: "답글 작성 중",
    typeIntelligenceUpdate: "댓글을 입력하세요...",
    establishReport: "의견을 나눠보세요...",
    unauthorizedLogin: "로그인이 필요한 서비스입니다.",
    deleteCommentTitle: "댓글을 삭제하시겠습니까?",
    loginRequiredTitle: "지금 로그인하고 축구에 참여하세요",
    signInLabel: "로그인", 
    changingLanguage: "시스템 언어 변경 중...",
    intelligenceAudio: "AI 음성 리포트",
    mergeFailed: "오디오 로드 실패",
    keyBriefing: "핵심 요약",
    loadingIntelligence: "상세 페이지 로드 중…",
    articleNotFound: "기사를 찾을 수 없습니다",
    goBack: "뒤로 가기",
    joinConversation: "대화에 참여하세요...",
    loginParticipate: "로그인 후 참여 가능합니다",
    leagueSelectionDescLoggedIn: "팔로우할 리그를 선택하세요. 선택한 리그는 계정에 저장됩니다.",
    leagueSelectionDescGuest: "팔로우할 리그를 선택하세요. 비회원 정보는 3분간 유지됩니다.",
    leagueStage: "리그 단계",
    knockoutStage: "녹아웃 단계",
    scenariosTab: "경우의 수",
    loadMoreNews: "더 보기",
    syncSelectedFeed: "선택한 리그 저장",
    selectAtLeastOneLeague: "최소 한 개 이상의 리그를 선택해주세요.",
    syncFailedTryAgain: "동기화에 실패했습니다. 다시 시도해주세요.",
    yourLeagues: "나의 리그",
    edit: "편집",
    loadMore: "더 보기",
    latestMovements: "최근 이적 현황",
    syncingMarketIntel: "최신 데이터를 동기화 중...",
    loadingNewsFeed: "뉴스 피드 구성 중...",
    analyzingTalent: "데이터 분석 중...",
    syncingFixtures: "경기 일정 동기화 중...",
    syncingMatchDetail: "경기 상세 정보 동기화 중...",
    curatingShorts: "하이라이트 큐레이팅 중...",
    postingComment: "댓글 등록 중...",
    searchingFor: "검색 중:",
    matchStats: "기록",
    lineUp: "라인업",
    timeline: "타임라인",
    talk: "토크",
    matchHighlights: "경기 하이라이트",
    latestTeamNews: "최신 팀 뉴스",
    close: "닫기",
    fullTime: "종료",
    startingXI: "선발 명단",
    substitutes: "교체 명단",
    injuries: "부상자 명단",
    coach: "감독",
    ownGoal: "자책골",
    waitingKickoff: "경기 시작 대기 중",
    matchStarted: "경기 시작",
    lineupAnnouncement: "경기 시작 약 60분 전 라인업이 공개됩니다",
    noStatsSynced: "통계 데이터가 없습니다",
    post: "게시",
    discoverMore: "더 보기",
    shareSuccess: "링크가 클립보드에 복사되었습니다",
    consultingGrid: "데이터 조회 중...",
    matchesFound: "검색 결과",
    zeroIntel: "정보 없음",
    refineSearch: "검색 조건을 확인해주세요",
    awaitingPersonnel: "선수 정보 대기 중",
    scanningFrequency: "뉴스 검색 대기 중",
    searchNewsPlaceholder: "뉴스 검색",
    searchAllLeagues: "리그 검색",
    searchPlayerPlaceholder: "선수 검색은 영어로 입력해 주세요.",
    searchGamePlaceholder: "경기 검색...",
    searchShortsPlaceholder: "하이라이트 검색...",
    deleteAccount: "회원탈퇴",
    deleteAccountConfirm: "정말 탈퇴하시겠습니까? 탈퇴 시 모든 활동 데이터와 스카우팅 기록이 영구적으로 삭제됩니다.",
    confirm: "확인",
    yes: "예",
    no: "아니오",
    closingAccount: "회원 탈퇴 처리 중...",
    joined: "가입일",
    agentTools: "요원 도구",
    supportInfo: "지원 및 정보",
    accountActions: "계정 설정",
    marketHotspots: "급상승 핫토픽",
    trendingIntel: "핫토픽",
    squadBuilderTitle: "예상 라인업 분석",
    squadBuilderSub: "전술 스쿼드 시뮬레이터",
    forwards: "공격수",
    midfielders: "미드필더",
    defenders: "수비수",
    goalkeepers: "골키퍼",
    selectPersonnel: "선수 선택",
    personnelFound: "해당 포지션의 선수가 없습니다",
    selectFormation: "포메이션 선택",
    searchingSector: "데이터 조회 중...",
    move: "이동",
    clear: "삭제",
    squadTheme: "그라운드 테마",
    themeGrass: "그린 필드",
    themeBlueprint: "전술 블루프린트",
    themeStealth: "나이트 스텔스",
    themePremium: "프리미엄 골드",
    themeGlass: "글래스 모피즘",
    themePaper: "클래식 페이퍼",
    themeCyber: "사이버 네온",
    themeRetroMud: "레트로 머드",
    themeNeonFuture: "네온 퓨처",
    ftResult: "최종 결과",
    scheduled: "경기 예정",
    stadiumCap: "명 수용",
    syncingIntel: "데이터 동기화 중...",
    standings: "순위표",
    scorers: "득점 순위",
    assists: "도움 순위",
    assistsFor: "도움",
    managerialCareer: "매니저 경력",
    singleMatchPerformance: "이 경기 퍼포먼스 분석",
    seasonIntelPerformance: "시즌 누적 퍼포먼스",
    retrievingIntel: "조회 중...",
    saveImage: "이미지 저장",
    shareToFeed: "공유",
    aiMatchPrediction: "AI 정밀 분석 리포트",
    simulatingScenarios: "정밀 시뮬레이션 가동 중...",
    runSimulation: "전략 리포트 생성하기",
    predictedWinner: "데이터 기반 우세 팀",
    expectedScore: "시뮬레이션 스코어",
    tacticalInsight: "분석 리포트",
    aiSimulationDesc: "AI 스카우트가 선수들의 최신 폼, 역사적 통계, 전술 데이터를 기반으로 경기를 시뮬레이션합니다.",
    noSectorActivity: "경기 데이터 없음",
    noSectorActivityDesc: "이 날짜에 예정된 경기 정보가 없습니다.",
    season2526: "시즌 25/26",
    momentumEfficiency: "모멘텀 및 효율성",
    avgGoals: "평균 득점",
    perMatch: "경기당",
    goalBalance: "득점 밸런스",
    goalsFor: "득점",
    goalsAgainst: "실점",
    offensiveDominance: "공격 우세",
    defensiveLeakage: "수비 불안",
    teamDNAIndices: "팀 주요 지표",
    matchOutcomeDistribution: "경기 결과 분포",
    cleanSheets: "클린시트",
    failedToScore: "무득점 경기",
    scoredPenalties: "PK 성공",
    missedPenalties: "PK 실축",
    bigWins: "대승",
    toughLosses: "참패",
    noVerifiedTransfers: "최근 1년 내 확인된 이적 기록이 없습니다",
    reportTitle: "댓글 신고",
    reportDesc: "신고 사유를 선택해주세요",
    reportReasonSpam: "Spam 또는 홍보성",
    reportReasonHarassment: "괴롭힘 또는 혐오 발언",
    reportReasonInappropriate: "부적절한 콘텐츠",
    reportReasonViolence: "폭력 또는 위험한 행동",
    reportReasonOther: "기타",
    reportOtherPlaceholder: "상세 사유를 입력해주세요...",
    submitReport: "신고 제출",
    maxLeaguesReached: "리그 선택은 최대 10개까지 가능합니다.",
    maxLeaguesReachedGuest: "비회원은 최대 3개까지만 선택 가능합니다.",
    maintenanceTitle: "시스템 점검 중",
    maintenanceDesc: "잠시 후 새로운 하이라이트가 업데이트됩니다.\n이용에 불편을 드려 죄송합니다.",
    maintenanceUntil: "점검 종료 예정: KST 09:00 (UTC 00:00)",
    shareIntelligence: "피드 작성",
    whatsHappening: "축구계의 새로운 소식을 알려주세요.",
    postSuccess: "피드가 성공적으로 공유되었습니다",
    uploadingIntel: "업로드 중...",
    addLink: "링크 추가",
    linkPlaceholder: "링크 주소를 입력하세요 (예: https://...)",
    linkValidationError: "링크는 https://로 시작해야 합니다.",
    urlRestricted: "해당 사이트의 정책으로 인해 접근이 제한된 링크입니다.",
    urlPaywall: "이 기사는 유료 구독이 필요할 수 있습니다.",
    urlDynamicWarning: "복잡한 콘텐츠가 포함된 사이트입니다. 분석이 제한될 수 있습니다.",
    aiAnalyzing: "분석 중...",
    aiWaitNote: "정밀 검증을 위해 약 20-40초가 소요됩니다.",
    scoutingStatus1: "현지 스카우팅 네트워크 연결 중...",
    scoutingStatus2: "시장 가치 데이터 대조 중...",
    scoutingStatus3: "전술적 통찰력 합성 중...",
    scoutingStatus4: "최종 리포트 생성 중...",
    aiTimeout: "분석 시간이 너무 오래 걸립니다(60초 초과). 다시 시도하거나 링크를 확인해주세요.",
    aiNotFootball: "축구계의 새로운 소식을 알려주세요.",
    aiDraftTitle: "AI 뉴스 초안",
    aiDraftSubtitle: "피드에 즉시 적용할 수 있습니다",
    extractedTitle: "추출된 제목",
    generatedContent: "생성된 본문",
    aiDraftDisclaimer: "이 초안은 참고용입니다. '적용하기'를 눌러 내용을 에디터로 가져온 후 자유롭게 수정하세요.",
    applyToEditor: "에디터에 적용하기",
    imageSourceLabel: "출처",
    selectionDone: "완료",
    inquiryHistory: "나의 문의 내역",
    emailSupport: "이메일 문의",
    myHistory: "내 문의 내역",
    newInquiry: "문의 접수",
    noInquiryHistory: "접수된 문의 내역이 없습니다.",
    completed: "답변완료",
    response: "답변",
    inquiryGeneral: "일반 문의",
    inquiryAccount: "계정/로그인",
    inquiryContent: "콘텐츠 제보/수정",
    inquiryError: "오류 신고",
    inquirySuggestion: "기능 제안",
    clearLocalStorage: "로컬 데이터 초기화",
    clearLocalStorageConfirm: "사용자 정보를 제외한 모든 로컬 데이터를 삭제하시겠습니까? 설정 및 임시 데이터가 초기화됩니다.",
    attendance: "출석 체크",
    attendanceDesc: "매일 출석하고 보너스 받기",
    favoriteTeams: "관심 팀",
    favoriteTeamsDesc: "내가 팔로우하는 축구 팀",
    matchPredictions: "매치 예측 리포트",
    matchPredictionsDesc: "AI가 분석한 나의 경기 예측 리포트",
    pointHistoryTitle: "내 포인트 내역",
    pointHistorySub: "적립 및 사용 내역을 확인하세요",
    english: "영어 (UK)",
    korean: "한국어 (KR)",
    clearingData: "데이터 초기화 중...",
    logoutConfirm: "정말 로그아웃 하시겠습니까?",
    teamDetails: "팀 상세 정보",
    teamNotFound: "팀 정보를 찾을 수 없습니다.",
    homeStadium: "홈 스타디움",
    recentMatches: "최근 경기",
    squad: "스쿼드",
    goalkeeper: "골키퍼",
    defender: "수비수",
    midfielder: "미드필더",
    attacker: "공격수",
    languageSaveSuccess: "언어 설정이 저장되었습니다.",
    languageAiNote: "선택한 언어에 따라 AI가 생성하는 뉴스 요약과 분석 내용이 해당 언어로 제공됩니다.",
    "Shots on Goal": "유효 슈팅",
    "Shots off Goal": "빗나간 슈팅",
    "Total Shots": "전체 슈팅",
    "Blocked Shots": "차단된 슈팅",
    "Shots insidebox": "박스 안 슈팅",
    "Shots outsidebox": "박스 밖 슈팅",
    "Fouls": "파울",
    "Corner Kicks": "코너킥",
    "Offsides": "오프사이드",
    "Ball Possession": "점유율",
    "Yellow Cards": "경고",
    "Red Cards": "퇴장",
    "Goalkeeper Saves": "골키퍼 선방",
    "Total passes": "전체 패스",
    "Passes accurate": "정확한 패스",
    "Passes %": "패스 성공률",
    "Expected Goals": "기대 득점(xG)",
    expected_goals: "기대 득점(xG)",
    goals_prevented: "실점 저지(xGP)",
    noIntelTitle: "뉴스 없음",
    noIntelDesc: "이 날짜의 피드가 없습니다.",
    noSectorIntel: "해당 섹터의 정보를 불러올 수 없습니다",
    noContentFound: "콘텐츠를 찾을 수 없습니다",
    performanceHistory: "시즌별 퍼포먼스",
    detailedSeasonBreakdown: "시즌 상세 정보",
    recentForm: "최근 경기 기록",
    noContentDesc: "현재 표시할 데이터가 없습니다. 다른 메뉴를 확인해 보시겠어요?",
    emptyStateIntelligence: "XLEVEN은 전세계 주요 리그의 실시간 데이터를 분석하여 제공합니다. 현재 선택하신 조건에 맞는 데이터가 아직 수집되지 않았거나 업데이트 중일 수 있습니다. 잠시 후 다시 시도하시거나, 다른 리그 정보를 확인해보세요.",
    unlockFullIntel: "정찰 기능 잠금 해제",
    careerIntelNotAvailable: "경력 정보를 불러올 수 없습니다",
    transferHistory: "이적 히스토리",
    freeAgent: "자유 계약",
    capturingImage: "3D 이미지 캡쳐 중...",
    classicGround: "클래식 그라운드",
    realStadium: "리얼 스타디움",
    imageUploadFailed: "이미지 업로드에 실패했습니다.",
    captureFailed: "캡쳐에 실패했습니다.",
    noFavoriteTeams: "관심 팀이 없습니다",
    noFavoriteTeamsDesc: "경기 상세 페이지에서 좋아하는 팀의 하트 아이콘을 눌러 추가해보세요.",
    removeFavoriteTeam: "관심 팀 삭제",
    removeFavoriteTeamConfirm: "정말 관심 팀에서 삭제하시겠습니까?",
    setDefaultTeamTitle: "기본 팀으로 설정하시겠습니까?",
    setDefaultTeamDesc: "이 팀을 기본 팀으로 설정하시겠습니까? 기본 팀은 하나만 설정 가능합니다.",
    defaultTeam: "기본 팀",
    selectDefaultTeam: "기본 팀으로 설정",
    contactSupport: "1:1 문의하기",
    contactSupportDesc: "XLEVEN 서비스 이용 중 궁금한 점이나 불편한 사항을 문의하세요.",
    mySupportHistory: "문의 내역 확인",
    mySupportHistoryDesc: "접수하신 문의 내역과 답변을 확인하실 수 있습니다.",
    myPageDesc: "XLEVEN 마이페이지에서 프로필 관리, 출석 체크, 포인트 내역 및 AI 매치 예측 리포트를 확인하세요.",
    attendanceDescSEO: "매일 출석하고 보너스 포인트를 받으세요.",
    pointHistoryDescSEO: "나의 포인트 적립 및 사용 내역을 확인하세요.",
    playerAge: "나이",
    playerHeight: "키",
    playerWeight: "몸무게",
    matchPredictionsDescSEO: "AI가 분석한 나의 경기 예측 데이터와 전술 리포트를 확인하세요.",
    recentActivityDescSEO: "내가 작성한 댓글과 커뮤니티 활동 내역을 확인하세요.",
    favoriteLeaguesDescSEO: "팔로우할 리그를 선택하고 맞춤형 축구 정보를 받아보세요.",
    favoriteTeamsDescSEO: "내가 팔로우하는 관심 팀 목록을 확인하세요.",
    languageDescSEO: "서비스 이용 언어를 변경하세요.",
    allMatchFixturesSeoTitle: "전체 경기 일정",
    allMatchFixturesSeoDesc: "전 세계 주요 리그의 실시간 스코어, 경기 일정 및 결과를 확인하세요.",
    leagueMatchFixturesSeoTitle: "경기 일정",
    leagueMatchFixturesSeoDesc: "{{leagueName}}의 실시간 스코어, 경기 일정 및 결과를 확인하세요.",
    noticeUpdate: "공지 업데이트",
    checkNow: "지금 확인하기",
    loading: "불러오는 중...",
    loadingMore: "더 불러오는 중...",
    noPredictionsYet: "예측 내역이 없습니다",
    analyzeMatchesDesc: "경기를 분석하고 AI 리포트를 받아보세요.",
    exploreMatches: "경기 목록 보러가기",
    predictionAccuracy: "예측 정확도",
    analysisStatistics: "분석 통계",
    totalAnalysis: "전체 분석",
    searchByTeam: "팀 이름으로 검색...",
    lastWeek: "최근 1주",
    lastMonth: "최근 1달",
    myAiTacticalReports: "나의 AI 분석 리포트",
    formation: "포메이션",
    theme: "테마",
    swapTip: "끌어서 위치 변경",
    squadAnalysis: "스쿼드 분석",
    newsTitle: "제목",
    translateToEn: "영문 번역",
    translateToKo: "국문 번역",
    translating: "번역 중...",
    addSource: "출처 추가",
    sourcePlaceholder: "출처명을 입력하세요 (예: 파브리지오 로마노)",
    apiAndCopyright: "API 및 저작권 정보",
    noMajorGamesToday: "관심 리그에서 오늘 예정된 주요 경기가 없습니다.",
    adminTools: "관리자 도구",
    adminControlCenter: "관리자 컨트롤 센터",
    adminControlCenterDesc: "사용자, 게시물 및 시스템 프로토콜 관리",
    addFavoriteLeaguesTitle: "관심 리그를 팔로우하세요",
    addFavoriteLeaguesDesc: "좋아하는 리그를 선택하고 홈 피드에서 실시간 스코어와 맞춤형 인텔리전스를 받아보세요.",
    setupNow: "지금 설정하기",
    addFavoriteLeaguesButton: "관심 리그 추가",
    deleteFeedConfirm: "정말 이 피드를 삭제하시겠습니까? 삭제 후에는 복구할 수 없습니다.",
    reportFeedTitle: "피드 신고",
    editFeed: "피드 수정",
    deleteFeed: "피드 삭제",
    reportFeed: "피드 신고",
    alreadyReported: "이미 신고한 콘텐츠입니다.",
    reportCompleted: "신고가 성공적으로 접수되었습니다.",
    externalSourceReportError: "외부 뉴스 소스는 직접 신고할 수 없습니다.",
    postDeletedSuccess: "피드가 성공적으로 삭제되었습니다.",
    scanningSectorData: "섹터 데이터 스캔 중...",
    searchResults: "검색 결과",
    analysisFailed: "분석 실패",
    feedPostPointEarned: "피드 등록! +{{amount}}P 적립",
    failedToPostNews: "피드 등록에 실패했습니다.",
    feedDeletePointDeducted: "피드 삭제로 10P가 차감되었습니다.",
    failedToDelete: "삭제 실패",
    seoDefaultDescription: "해외 축구 뉴스, 실시간 이적 루머, 경기 하이라이트 및 AI 데이터 분석 리포트. 프리미어리그, 라리가, 챔피언스리그 등 전 세계 축구 소식을 XLEVEN에서 가장 빠르게 만나보세요.",
    seoDefaultKeywords: "해외축구, 축구 뉴스, 이적 루머, 실시간 스코어, 경기 하이라이트, 축구 분석, 프리미어리그, 라리가, 챔피언스리그, AI 축구 예측",
    seoHomeTitle: "해외 축구 뉴스 & 실시간 이적 루머 AI 분석",
    topTransfersSeoDesc: "역대 최고 이적료를 기록한 주요 이적 현황과 상세 정보를 분석합니다.",
    latestMovementsSeoDesc: "Get the latest real-time transfer status and official announcements in football as fast as possible.",
    playerDetailSeoDesc: "{{playerName}}의 상세 데이터, 시즌 성적, 이적 히스토리 및 최근 경기 폼을 확인하세요.",
    playerDetailSeoTitle: "{{playerName}} - {{position}} ({{team}})",
    synchronizingIntelligence: "데이터 동기화 중...",
    summer: "여름",
    winter: "겨울",
    dataProvidedBy: "자료제공",
    leagueHighlightsSeoDesc: "{{leagueName}}의 최신 축구 경기 하이라이트 영상을 확인하세요.",
    matches: "경기",
    awaitingMarketIntel: "이적 시장 정보 대기 중...",
    scanningSectorIntel: "섹터 스캐닝 중...",
    noticeTitle: "XLEVEN 시스템 업데이트",
    noticeBody:
      "고정밀 축구 분석을 위해 Gemini 2.5 AI 엔진이 활성화되었습니다. 이제 실시간 스카우팅 리포트와 강화된 이적 시장 예측 서비스를 이용하실 수 있습니다.",
    dontShowToday: "오늘 하루 보지 않기",
    emailRequired: "이메일 주소를 입력해주세요",
    resetFailed: "재설정 링크 전송에 실패했습니다",
    resendFailed: "이메일 재전송에 실패했습니다",
    emailNotConfirmedMsg: "이메일 인증이 완료되지 않았습니다. 메일함을 확인해주세요.",
    resendSuccess: "전송 성공",
    resendAction: "인증 메일 재전송",
    invalidCredentials: "이메일 또는 비밀번호가 일치하지 않습니다.",
    tooManyRequests: "너무 많은 요청이 발생했습니다. 잠시 후 다시 시도해주세요.",
    fixtures: "전적",
    activeSource: "선택된 리그",
    updateSectors: "관심 리그 수정",
    configureIntelSources: "관심 리그 설정",
    searchingGlobalDatabase: "검색 중...",
    noMatchingSectors: "일치하는 섹터를 찾을 수 없습니다",
    majorLeagues: "주요 리그",
    majorCups: "주요 컵",
    addedSectors: "추가된 섹터",
    goToToday: "오늘로 이동",
    scanningGrid: "데이터 스캔 중...",
    rating: "평점",
    goals: "득점",
    passPercentage: "패스 성공률",
    dribbles: "드리블",
    defense: "수비",
    captain: "주장",
    injured: "부상",
    club: "클럽",
    played: "경기",
    points: "승점",
    goalDiff: "GD",
    win: "승",
    draw: "무",
    loss: "패",
    ucl: "UCL",
    uel: "UEL",
    uecl: "UECL",
    rel_po: "PO",
    rel: "강등",
    acle: "ACLE",
    acl2: "ACL2",
    noConcludedMatches: "종료된 경기 기록이 없습니다",
    loadingRecords: "기록 로딩 중...",
    from: "~로부터",
    to: "~로",
    transfer: "이적",
    openOriginal: "원본 보기",
    refreshLiveData: "라이브 데이터 새로고침",
    syncingMatchIntelDesc: "데이터 동기화 중...",
    newPassword: "새 비밀번호",
    updatePassword: "비밀번호 변경",
    passwordChanged: "비밀번호 변경 완료!",
    passwordChangedDesc: "비밀번호가 성공적으로 변경되었습니다.",
    passwordMismatch: "비밀번호가 일치하지 않습니다.",
    fillAllFields: "모든 필드를 채워주세요.",
    passwordMatch: "비밀번호가 일치합니다.",
    passwordSameAsOld: "기존 비밀번호와 다른 새 비밀번호를 입력해주세요.",
    passwordMinLength: "최소 8자 이상",
    passwordLetters: "영문 포함",
    passwordNumbers: "숫자 포함",
    passwordSpecial: "특수문자 포함",
    resetIntel: "비밀번호 재설정",
    verifyIdentity: "본인 확인이 필요합니다",
    accountEmail: "계정 이메일",
    enterRegisteredEmail: "가입된 이메일 주소를 입력하세요",
    authorizeReset: "인증 메일 전송",
    backToEntry: "로그인으로 돌아가기",
    nicknameUpdated: "닉네임이 성공적으로 변경되었습니다.",
    profileImageUpdated: "프로필 사진이 교체되었습니다.",
    backgroundImageUpdated: "배경 이미지가 교체되었습니다.",
    uploadFailed: "업로드 중에 문제가 발생했습니다. 다시 시도해주세요.",
    fileSizeError: "파일 용량이 너무 큽니다. 5MB 이하의 파일을 선택해주세요.",
    pointHistory: "포인트 내역",
    pointGuide: "포인트 안내",
    pointGuideDesc: "활동을 통해 획득한 포인트 내역을 확인할 수 있습니다. 포인트는 향후 다양한 서비스에서 사용 가능합니다.",
    noPointHistory: "포인트 내역이 없습니다.",
    loadingPointHistory: "포인트 내역 로딩 중...",
    gatheringIntel: "정보 수집 중...",
    syncingPointHistory: "포인트 내역 동기화 중...",
    reason7DayBonus: "7일 연속 출석 보너스",
    reasonNewsPost: "피드 등록",
    reasonNewsDelete: "피드 삭제",
    reasonCommentPost: "뉴스 댓글 등록",
    reasonCommentDelete: "뉴스 댓글 삭제",
    reasonAiReport: "AI 정밀 분석 리포트",
    reasonRegularEarn: "일반 적립",
    reasonAdminSpecialReward: "관리자 특별 보상",
    reasonNeonPitch: "게임 플레이: NEON PITCH",
    reasonTripleBetMultiple: "트리플벳 중복 선택",
    reasonTripleBetAi: "트리플벳 AI 분석",
    reasonFootyMaster: "게임 플레이: FOOTY MASTER",
    pointEarned: "포인트 적립!",
    pointDeducted: "포인트 차감.",
    commentPosted: "댓글 등록!",
    commentDeleted: "댓글 삭제.",
    feedPosted: "피드 등록!",
    feedDeleted: "피드 삭제.",
    attendanceComplete: "출석 완료!",
    firstLoginToday: "오늘 첫 로그인!",
    deleteCancel: "삭제 취소",
    deleteConfirmDesc: "삭제된 내용은 복구할 수 없습니다. 정말 삭제하시겠습니까?",
    editCancel: "수정 취소",
    editCancelDesc: "수정된 내용이 저장되지 않습니다. 정말 나가시겠습니까?",
    postCancel: "작성 취소",
    postCancelDesc: "내용이 저장되지 않습니다. 정말 나가시겠습니까?",
    errorLoadingImages: "이미지를 불러올 수 없습니다.",
    errorProcessingAttendance: "출석 체크 중 오류가 발생했습니다.",
    errorAnalysis: "분석 중 오류가 발생했습니다.",
    aiErrorTitle: "분석 서비스 오류",
    aiErrorDesc: "잠시 후에 다시 시도해 주세요.",
    errorReport: "신고에 실패했습니다.",
    errorDelete: "삭제에 실패했습니다.",
    enterTitleAndContent: "제목과 내용을 입력해주세요.",
    inquirySubmitted: "문의가 접수되었습니다.",
    errorInquiry: "접수 중 오류가 발생했습니다.",
    category: "문의 유형",
    title: "제목",
    content: "상세 내용",
    inquiryPlaceholder: "문의하실 내용을 상세히 적어주세요",
    titlePlaceholder: "문의 제목을 입력해주세요",
    inquiryNote: "문의하신 내용은 순차적으로 확인 후 답변해 드립니다. 주말 및 공휴일에는 답변이 지연될 수 있습니다.",
    submitInquiry: "문의 접수하기",
    attendanceStreak: "출석 스트릭",
    attendanceNote: "매일 출석하고 더 많은 혜택을 받으세요",
    attendanceCompleted: "오늘 출석 완료",
    checkAttendanceNow: "지금 출석 체크",
    weeklyProgress: "주간 진행도",
    baseReward: "기본 보상",
    streakBonus: "연속 보상",
    attendanceResetNote: "자정(00:00)을 기준으로 새로운 출석 체크가 가능해집니다.",
    present: "현재",
    frame: "프레임",
    searchPlaceholder: "사유, 신고자 또는 내용 검색...",
    playerAndTransferManagement: "회원 및 이적 관리",
    playerManagementDesc: "이적 시장 데이터 및 선수 그룹 관리",
    latestTransfers: "최근 이적",
    groupList: "그룹 목록",
    playerSearchPlaceholder: "선수 또는 클럽으로 검색...",
    addItem: "아이템 추가",
    playerIntel: "선수 인텔",
    movement: "이적 경로",
    valueFee: "가치/이적료",
    noItemsFound: "인적 자산을 찾을 수 없습니다",
    createGroup: "그룹 생성",
    editGroup: "그룹 수정",
    addPersonnel: "인원 추가",
    editPersonnel: "인원 수정",
    deleteItem: "아이템 삭제",
    deleteGroupConfirmDesc:
      "정말로 이 그룹을 삭제하시겠습니까? 이 그룹 내의 모든 인적 데이터도 영구적으로 삭제됩니다.",
    deleteItemConfirmDesc: "정말로 이 인적 자산을 삭제하시겠습니까? 이 작업은 되돌릴 수 없습니다.",
    systemSettingsDesc: "시스템 코어 엔진 및 네트워크 정책 관리",
    awardPoints: "포인트 지급",
    awardPointsDesc: "이 사용자에게 포인트를 지급합니다.",
    award: "지급",
    awardSuccess: "포인트가 성공적으로 지급되었습니다.",
    amount: "수량",
    reason: "사유",
    auditIntelligenceDesc: "커뮤니티 공유 인텔 검토 및 관리",
    auditReportsDesc: "모든 사건 리포트 검토 및 관리",
    noResultsFound: "결과를 찾을 수 없습니다",
    noTrendingData: "트렌딩 데이터가 없습니다",
    pointDeduction: "포인트 차감",
    insufficientPoints: "포인트 부족",
    rechargeRequired: "충전 필요",
    allMatchFixtures: "전체 경기 일정",
    leagueMatchFixtures: "리그 경기 일정",
    allMatchFixturesDesc: "전 세계 주요 리그의 실시간 스코어, 일정 및 결과를 확인하세요.",
    playerStatsDesc: "상세 데이터, 시즌 통계, 이적 기록 및 최근 폼을 확인하세요.",
    newsFeedDesc: "최신 축구 뉴스와 실시간 이적 루머를 날짜별로 확인하세요.",
    shortsDesc: "가장 핫한 축구 하이라이트와 쇼츠 영상을 끊김 없이 즐기세요.",
    maintenanceResumes: "KST 09:00 (UTC 00:00)에 재개됩니다.",
    swipeGuide: "왼쪽 또는 오른쪽으로 스와이프",
    swipeDateGuide: "하여 날짜별 뉴스를 확인하세요",
    apiInfoDesc1:
      "XLEVEN은 API-Sports(API-Football)로부터 모든 실시간 경기 결과, 선수 통계, 라인업 및 이적 정보를 제공받습니다. 이 데이터의 원천 권리는 제공자와 각 리그 연맹에 있습니다.",
    apiInfoDesc2:
      "이적 예측 분석 및 뉴스 요약 서비스는 Google Gemini AI 엔진을 통해 생성됩니다. 인공지능이 생성한 모든 분석 리포트는 참고용일 뿐이며 법적 효력이 없습니다.",
    apiInfoDesc3:
      "영상 하이라이트 및 쇼츠 콘텐츠는 YouTube Data API를 통해 임베드 형식으로 제공됩니다. 영상에 대한 모든 저작권은 해당 플랫폼 채널 소유자에게 있습니다.",
    apiInfoDesc4:
      "뉴스 피드 및 기사에 사용된 주요 시각 자료 및 배경 이미지는 BBC Sport RSS 및 Pexels에서 제공하는 로열티 프리 라이선스 리소스를 활용합니다.",
    apiInfoDesc5:
      "본 서비스 내에서 사용되는 클럽 로고, 리그 엠블럼, 실제 선수 사진 등 모든 시각 자료의 저작권은 각 원저작권자(클럽, 리그 연맹, 뉴스 대행사 등)에게 있습니다.",
    apiInfoDesc6:
      "XLEVEN은 이러한 자료를 공익 보도, 통계 및 데이터 분석의 목적으로만 활용하며, 어떠한 경우에도 무단으로 이미지를 변형하거나 상업적 목적으로 재판매하지 않습니다. 저작권 침해 신고가 접수될 경우 내부 검토 후 즉시 조치하겠습니다.",
    apiSportsData: "스포츠 데이터 API",
    apiAiIntelligence: "AI 분석",
    apiMediaVideo: "미디어 및 영상",
    apiNewsAssets: "뉴스 에셋",
    apiBbcSource: "BBC 스포츠 뉴스 소스",
    apiCopyrightDisclaimer: "저작권 고지사항",
    privacyDesc1:
      'XLEVEN(이하 "본 사이트")은 이용자의 개인정보를 소중히 여기며 관련 법령을 준수합니다. 본 개인정보 처리방침은 이용자가 본 사이트를 이용할 때 어떤 정보가 수집되고 어떻게 사용되는지 설명합니다.',
    privacySection1Title: "1. 수집하는 개인정보 항목",
    privacySection1Desc:
      "본 사이트는 기본적으로 개인정보를 직접 수집하지 않습니다. 다만 서비스 이용 과정에서 다음과 같은 정보가 자동으로 수집될 수 있습니다.",
    privacySection2Title: "2. 개인정보의 이용 목적",
    privacySection2Desc: "수집된 정보는 다음의 목적을 위해 사용됩니다.",
    privacySection3Title: "3. 쿠키 사용에 대한 정보",
    privacySection3Desc1:
      "본 사이트는 쿠키를 사용할 수 있습니다. 쿠키는 이용자의 브라우저에 저장되는 소량의 데이터이며, 사이트에서 이용자의 선호도를 기억하고 더 나은 서비스를 제공하는 데 사용됩니다.",
    privacySection3Desc2:
      "이용자는 브라우저 설정을 통해 쿠키 저장을 거부할 수 있으며, 쿠키 거부 시 일부 서비스 이용에 제한이 있을 수 있습니다.",
    privacySection4Title: "4. Google 애드센스 및 제3자 광고",
    privacySection4Desc1: "본 사이트는 Google 애드센스를 포함한 제3자 광고 서비스를 사용합니다.",
    privacySection4Desc2:
      "Google과 같은 제3자 광고 제공업체는 쿠키를 사용하여 이용자의 이전 방문을 기반으로 광고를 게재합니다.",
    privacySection4Desc3:
      "Google의 광고 쿠키(DART 쿠키)를 통해 이용자가 본 사이트 및 기타 사이트를 방문할 때 맞춤형 광고를 제공합니다.",
    privacySection4Desc4: "이용자는 Google 광고 설정 페이지에서 맞춤형 광고를 비활성화할 수 있습니다.",
    privacySection4Link: "Google 개인정보 처리방침 확인",
    privacySection5Title: "5. 제3자에 대한 개인정보 제공",
    privacySection5Desc:
      "본 사이트는 이용자의 개인정보를 제3자에게 판매하거나 공유하지 않습니다. 다만 법률에서 요구하는 경우는 예외로 합니다.",
    privacySection6Title: "6. 외부 링크",
    privacySection6Desc:
      "본 사이트에는 외부 웹사이트로의 링크가 포함될 수 있습니다. 본 사이트는 외부 사이트의 개인정보 처리방침 및 콘텐츠에 대해 책임을 지지 않습니다.",
    privacyContactEmail: "이메일",
    privacyContactSite: "사이트 이름",
    privacyEffectiveDate: "시행일: 2026년 1월 20일",
    privacyItemIP: "IP 주소",
    privacyItemBrowser: "브라우저 유형",
    privacyItemDate: "방문 날짜/시간",
    privacyItemPage: "방문한 페이지",
    privacyItemCookie: "쿠키",
    privacyUsageStats: "사이트 이용 통계 분석",
    privacyUsageImprove: "콘텐츠 및 사용자 경험 개선",
    privacyUsageAds: "광고 서비스 제공 및 최적화",
    privacySection5Desc1: "본 사이트는 최적화된 서비스를 제공하고 광고를 게재하기 위해 '쿠키'를 사용합니다. 쿠키는 웹사이트가 사용자의 브라우저에 저장하는 작은 텍스트 파일입니다.",
    privacySection5Desc2: "Google을 포함한 제3자 제공업체는 쿠키를 사용하여 이용자의 이전 방문을 기반으로 본 사이트 또는 기타 웹사이트에 광고를 게재합니다. Google의 광고 쿠키 사용을 통해 Google과 그 파트너는 이용자의 본 사이트 및/또는 인터넷상의 다른 사이운 방문을 기반으로 이용자에게 광고를 게재할 수 있습니다.",
    privacySection5Desc3: "이용자는 광고 설정(https://www.google.com/settings/ads)을 방문하여 맞춤형 광고를 옵트아웃할 수 있습니다. 또는 www.aboutads.info를 방문하여 맞춤형 광고를 위한 제3자 제공업체의 쿠키 사용을 옵트아웃할 수 있습니다.",
    termsSection1Title: "제1조 (목적)",
    termsSection1Desc: "본 이용약관은 XLEVEN(이하 '사이트')에서 제공하는 모든 서비스의 이용 조건 및 절차, 이용자와 사이트의 권리, 의무 및 책임 사항을 정의하는 것을 목적으로 합니다.",
    termsSection2Title: "제2조 (용어의 정의)",
    termsSection2Desc: "1. '이용자'란 사이트에 접속하여 본 약관에 따라 서비스를 이용하는 회원 및 비회원을 말합니다.\n2. '콘텐츠'란 사이트에서 제공하는 축구 뉴스, 데이터, 분석 리포트 등을 말합니다.",
    termsSection3Title: "제3조 (약관의 효력 및 개정)",
    termsSection3Desc: "사이트는 관련 법령을 위반하지 않는 범위 내에서 본 약관을 개정할 수 있으며, 개정된 약관은 사이트 내 공지사항을 통해 게시함으로써 효력이 발생합니다.",
    termsSection4Title: "제4조 (서비스 내용)",
    termsSection4Desc: "사이트는 실시간 축구 스코어, 뉴스 피드, AI 데이터 분석 및 커뮤니티 서비스를 제공합니다. 서비스 내용은 기술적 사양 변경에 따라 달라질 수 있습니다.",
    termsSection5Title: "제5조 (게시물 및 데이터 저작권)",
    termsSection5Desc: "1. 사이트에서 제공하는 모든 뉴스 및 데이터는 저작권법의 보호를 받습니다.\n2. 이용자는 서비스 이용을 통해 얻은 정보를 사이트의 사전 승인 없이 복제, 전송, 출판, 배포, 방송 기타 방법에 의하여 영리 목적으로 이용하거나 제3자에게 이용하게 해서는 안 됩니다.",
    termsSection6Title: "제6조 (광고 게재)",
    termsSection6Desc: "사이트는 서비스 운영과 관련하여 서비스 화면에 광고를 게재할 수 있습니다. 이는 최상의 콘텐츠 서비스를 지속적으로 제공하기 위한 필수적인 부분입니다.",
    copyFailed: "복사에 실패했습니다.",
    newsFeedSeoTitle: "축구 피드",
    newsFeedSeoDesc: "전 세계 주요 리그의 최신 축구 소식과 실시간 이적 루머를 날짜별로 확인하세요.",
    pexelsGallery: "Pexels 갤러리",
    highFidelityAssets: "고품질 축구 에셋",
    tapToPlayWithSound: "눌러서 소리와 함께 재생",
    videoUnavailable: "해당 영상은 현재 지역에서 재생할 수 없습니다.",
    shortsPreparingTitle: "쇼츠 영상을 준비 중입니다",
    shortsPreparingDesc: "현재 최신 영상을 수집하고 있습니다. 잠시 후 다시 확인해 주세요!",
    shortsSeoTitle: "축구 하이라이트 & 쇼츠 | XLEVEN",
    shortsSeoDesc: "가장 핫한 전 세계 축구 하이라이트와 쇼츠 영상을 끊김 없이 즐기세요. AI가 추천하는 최고의 축구 순간을 경험할 수 있습니다.",
    gameStoreTitle: "축구 게임",
    newGamePreparing: "새로운 게임을 준비 중입니다",
    newGamePreparingDesc: "XLEVEN에서만 즐길 수 있는 특별한 축구 게임들이 곧 공개됩니다. 조금만 기다려 주세요!",
    ranking: "순위",
    play: "플레이",
    gameRanking: "게임 순위",
    fetchingRankings: "순위 정보를 가져오는 중...",
    noRankingsYet: "아직 순위 데이터가 없습니다",
    preparing: "준비중...",
    toto_history: "예측 내역",
    toto_submit: "완료",
    toto_check_predictions: "예측 내역 확인",
    toto_round_format: "제 {{n}}회차",
    toto_finished: "종료",
    toto_in_progress: "진행중",
    toto_success_count: "예측 성공",
    toto_submitted_at: "제출 일시",
    toto_not_participated: "이 회차에 참여하지 않았습니다.",
    toto_detailed_results: "상세 예측 결과",
    toto_correct: "적중",
    toto_incorrect: "미적중",
    toto_my_pick: "(나의 선택)",
    toto_result: "(결과)",
    toto_win: "승",
    toto_draw: "무",
    toto_loss: "패",
    toto_ai_winner: "승리 예상",
    toto_ai_score: "예상 스코어",
    toto_ai_win_rate: "승률",
    toto_ai_tactical: "전술 분석",
    toto_save_failed: "저장에 실패했습니다.",
    toto_predictions_status: "예측 현황",
    toto_view_analysis: "분석 확인",
    toto_ai_analysis: "AI 분석",
    toto_predict_title: "14경기 결과를 예측하고",
    toto_win_points: "포인트를 획득하세요!",
    toto_challenge_win: "도전하고 승리하세요",
    toto_players_joined: "현재 {{count}}명이 참여 중",
    toto_rules_title: "게임 이용 안내",
    toto_rules_policy: "트리플벳 게임 정책",
    toto_rules_1: "각 경기당 하나의 결과만 선택할 수 있습니다.",
    toto_rules_2: "예측이 적중한 경기당 10포인트와 10점의 스코어를 획득합니다.",
    toto_rules_3: "AI 분석 이용 시 10p가 차감됩니다.",
    toto_rules_4: "중복 선택은 최대 20개까지 가능합니다.",
    toto_rules_5: "14개까지 차감 없음, 15개(10p), 16개(20p), 17개(30p) 차감되며 20개 선택 시 총 210p가 차감됩니다.",
    toto_rules_6: "* 포인트 부족 시 참여가 제한됩니다.",
    toto_login_required: "로그인이 필요합니다",
    toto_login_desc: "토토 게임에 참여하려면 로그인이 필요합니다.",
    toto_login_button: "로그인하기",
    toto_no_round_title: "진행 중인 회차가 없습니다",
    toto_no_round_desc: "새로운 승무패 회차가 곧 시작될 예정입니다. 잠시만 기다려주세요!",
    toto_already_participated: "이미 참여한 유저입니다.",
    webtoonHeroTitle: "축구 그 이상의 감동,",
    webtoonHeroTitleColor: "XLEVEN 웹툰",
    webtoonHeroDesc: "매주 업데이트되는 오리지널 축구 웹툰 시리즈. 어디서도 볼 수 없는 특별한 이야기를 만나보세요.",
    noWebtoons: "아직 등록된 웹툰이 없습니다.",
    webtoonSeoTitle: "축구 웹툰 컬렉션",
    webtoonSeoDesc: "XLEVEN에서만 볼 수 있는 최신 축구 웹툰을 만나보세요. 매주 업데이트되는 오리지널 축구 이야기와 시리즈를 즐길 수 있습니다.",
    toto_round_expired: "마감된 회차입니다.",
    toto_submit_expired: "마감 시간이 지나 구매할 수 없습니다.",
    toto_predict_all: "모든 경기의 결과를 예측해주세요.",
    toto_insufficient_points: "포인트가 부족합니다. (필요: {{amount}}p)",
    toto_saved_with_deduction: "예측이 저장되었습니다! ({{amount}}p 차감)",
    toto_saved_success: "예측이 성공적으로 저장되었습니다!",
    toto_ai_completed: "AI 분석이 완료되었습니다!",
    toto_ai_error: "분석 중 오류가 발생했습니다.",
    toto_exit_title: "게임을 종료하시겠습니까?",
    toto_exit_desc: "선택하신 예측 내역이 저장되지 않습니다.",
    toto_exit_confirm: "종료",
    toto_exit_cancel: "계속하기",
    toto_seo_title: "승무패 챌린지 - 매주 열리는 축구 예측 게임",
    toto_seo_description: "매주 업데이트되는 전 세계 축구 리그 경기의 결과를 예측하고 포인트를 획득하세요. AI 분석 데이터와 함께 승리 확률을 높여보세요.",
    toto_seo_keywords: "승무패, 축구예측, 토토, XLEVEN, 스포츠베팅, 축구분석",
    toto_result_seo_title: "나의 승무패 내역 - 축구 예측 게임 결과 확인",
    toto_result_seo_description: "매주 참여한 축구 경기 예측 결과와 획득 포인트를 확인하세요. 상세 경기 리포트를 통해 적중률을 분석할 수 있습니다.",
    toto_result_seo_keywords: "승무패결과, 축구예측내역, 토토결과, XLEVEN, 적중확인",
    neon_pitch_seo_title: "네온 피치(NEON PITCH) - 레트로 축구 아케이드 게임",
    neon_pitch_seo_description: "레트로 감성의 축구 아케이드 게임을 즐겨보세요. 네온 공을 조절하여 장애물을 피하고 최고 점수에 도전하세요.",
    neon_pitch_seo_keywords: "네온피치, 축구게임, 아케이드게임, 레트로게임, XLEVEN게임, 미니게임",
    neon_pitch_score: "점수",
    neon_pitch_best: "최고 점수",
    neon_pitch_time_left: "남은 시간",
    neon_pitch_streak: "연속 득점!",
    neon_pitch_fever_unleashed: "골 피버 모드!",
    neon_pitch_adrenaline_gauge: "아드레날린 게이지",
    neon_pitch_instructions: "최대한 많은 점수를 획득하세요!",
    neon_pitch_exit: "게임 나가기",
    neon_pitch_full_time: "경기 종료",
    neon_pitch_total_score: "최종 점수",
    neon_pitch_max_combo: "최대 콤보",
    neon_pitch_rematch: "다시 하기",
    neon_pitch_deduction_toast: "10P 차감",
    neon_pitch_kickoff: "킥오프",
    neon_pitch_insufficient_points: "포인트가 부족합니다.",
    viewTranslation: "번역 보기",
    viewOriginal: "원문 보기",
    selectPostType: "게시물 타입 선택",
    overallStrength: "전력 비교",
    attackPower: "공격력",
    defensePower: "수비력",
    winProbability: "승부 예측",
    strength: "전력",
    attackingPotential: "공격 잠재력",
    defensivePotential: "수비 잠재력",
    poissonDistribution: "포아송 분포",
    strengthH2h: "상대 전적 우세",
    goalsH2h: "상대 전적 득점",
    winsTheGame: "승리 확률",
    headToHead: "상대 전적",
    last10Matches: "최근 10경기",
    lastNMatches: "최근 {n}경기",
    viewH2HDetail: "상대전적 상세 보기",
    footy_master_preparing_arena: "경기장 준비 중...",
    footy_master_trivia_quiz: "축구 상식 퀴즈",
    footy_master_high_score: "최고 점수",
    footy_master_start_desc: "전 세계 축구 지식을 뽐내고 포인트를 획득하세요!",
    footy_master_questions: "문제",
    footy_master_random: "무작위 10문제",
    footy_master_time_limit: "제한 시간",
    footy_master_time_s_q: "문제당 15초",
    footy_master_get_started: "시작하기",
    footy_master_back_to_store: "나가기",
    footy_master_back_to_start: "처음으로 돌아가기",
      footy_master_question_n_of_m: "문제 {{n}} / {{m}}",
      confirmDelete: "정말 이 하이라이트를 삭제하시겠습니까?",
      footy_master_mission_complete: "미션 완료",
    footy_master_total_score: "최종 점수",
    footy_master_accuracy: "정확도",
    footy_master_play_again: "다시 하기",
    footy_master_exit_to_store: "상점으로 나가기",
    footy_master_cat_worldcup: "월드컵",
    footy_master_cat_epl: "EPL",
    footy_master_cat_laliga: "라리가",
    footy_master_cat_ucl: "챔스",
    footy_master_cat_kleague: "K리그",
    footy_master_commentary_perfect: "완벽합니다! 당신은 살아있는 축구 백과사전! 🏆⚽️",
    footy_master_commentary_great: "대단한 실력입니다! 거의 전문가 수준이시군요! 🔥👏",
    footy_master_commentary_good: "나쁘지 않은 성적이에요! 조금만 더 하면 마스터! 💪✨",
    footy_master_commentary_average: "축구 공부가 조금 더 필요할 것 같아요! 다시 도전해볼까요? 📚⚽️",
    footy_master_commentary_poor: "괜찮아요! 원래 마스터가 되는 길은 험난한 법이죠! 🏃‍♂️🌟",
    footy_master_seo_title: "푸티 마스터(FOOTY MASTER) - 글로벌 축구 상식 퀴즈 게임",
    footy_master_seo_description: "당신의 축구 지식을 뽐내보세요! 월드컵, EPL, 라리가, 챔스 등 다양한 축구 퀴즈를 풀고 포인트를 획득하여 푸티 마스터가 되어보세요.",
    footy_master_seo_keywords: "푸티마스터, 축구퀴즈, 축구상식, 축구게임, 월드컵퀴즈, EPL퀴즈, XLEVEN게임",
    noCommentsYet: "아직 댓글이 없습니다",
    addAComment: "댓글을 입력하세요...",
    deleteCommentConfirm: "이 댓글을 삭제하시겠습니까?",
    matchTalk: "경기 토크",
    phantomStadium: "팬텀 스타디움",
    matchAnalysis: "경기 분석",
    noPostsFound: "게시글이 없습니다",
    beTheFirstToPost: "첫 번째로 글을 작성해보세요!",
    noAnalysisFound: "분석 글이 없습니다",
    beTheFirstToAnalyze: "첫 번째로 분석을 작성해보세요!",
    viewMore: "더 보기",
    deleteConfirm: "삭제 확인",
    deleteConfirmMessage: "정말 삭제하시겠습니까? 삭제된 내용은 복구할 수 없습니다.",
    viewReplies: "답글 보기",
    hideReplies: "답글 숨기기",
    failedToLoadQuizzes: "퀴즈를 불러오지 못했습니다",
    quizCreatedSuccessfully: "퀴즈가 성공적으로 생성되었습니다",
    quizDeleted: "퀴즈가 삭제되었습니다",
    deleteFailed: "삭제에 실패했습니다",
    deleteSuccess: "성공적으로 삭제되었습니다",
    reportSubmitted: "신고가 접수되었습니다",
    failedToDeductPoints: "포인트 차감에 실패했습니다",
    failedToUpdatePassword: "비밀번호 업데이트에 실패했습니다",
    failedToUpdateNickname: "닉네임 업데이트에 실패했습니다",
    fileSizeUnder5MB: "파일 크기는 5MB 이하이어야 합니다",
    saveFailed: "저장에 실패했습니다",
    supportXlevenService: "XLEVEN 서비스 지원",
    copySuccess: "링크가 클립보드에 복사되었습니다",
    setFavoriteTeamFirst: "먼저 좋아하는 팀으로 설정해주세요",
    aiTacticalInsight: "AI 전술 인사이트",
    strategicAnalysisReport: "전략 분석 리포트",
    winProbabilityDistribution: "승리 확률 분포",
    aiConfidence: "AI 신뢰도",
    viewAll: "모두 보기",
    viewDetails: "상세 보기",
    hotPost: "인기 게시물",
    syncingActivities: "활동 내역 동기화 중...",
    intelligenceReport: "인텔리전스 리포트",
    matchIntel: "경기 인텔",
    koreanFeed: "한국어 피드",
    englishFeed: "영어 피드",
  },
  ja: {
    popularFavoriteTeams: '人気のお気に入りチーム',
    stadiumPostTitle: "スタジアムに投稿",
    stadiumPostPlaceholder: "このチームの他のファンとあなたの考えを共有しましょう。",
    awaitingData: "試合データを待機中...",
    awaitingDataDesc: "試合は開始されましたが、まだリアルタイム情報が提供されていません。少々お待ちください。",
    injuryList: "負傷者",
    injuryReason_Injury: "負傷",
    injuryReason_RedCard: "レッドカード",
    injuryReason_Internationalduty: "代表招集",
    injuryReason_YellowCards: "イエローカード累計",
    injuryReason_LowerBackInjury: "腰の怪我",
    injuryReason_ChestInjury: "胸の怪我",
    injuryReason_Jumpersknee: "ジャンパー膝",
    injuryReason_ToeInjury: "足指の怪我",
    injuryReason_Inactive: "登録外",
    injuryReason_KneeInjury: "膝の怪我",
    injuryReason_AnkleInjury: "足首の怪我",
    injuryReason_HamstringInjury: "ハムストリングの怪我",
    injuryReason_ThighInjury: "太ももの怪我",
    injuryReason_CalfInjury: "ふくらはぎの怪我",
    injuryReason_GroinInjury: "鼠径部の怪我",
    injuryReason_MuscleInjury: "筋肉の怪我",
    injuryReason_FootInjury: "足の怪我",
    injuryReason_LegInjury: "足の怪我",
    injuryReason_BrokenLeg: "足の骨折",
    injuryReason_ACLInjury: "前十字靭帯損傷",
    injuryReason_MCLInjury: "内側側副靭帯損傷",
    injuryReason_ShoulderInjury: "肩の怪我",
    injuryReason_BackInjury: "背中/腰の怪我",
    injuryReason_HipInjury: "股関節の怪我",
    injuryReason_HeadInjury: "頭部の怪我",
    injuryReason_Concussion: "脳震盪",
    injuryReason_WristInjury: "手首の怪我",
    injuryReason_HandInjury: "手の怪我",
    injuryReason_BrokenHand: "手の骨折",
    injuryReason_BrokenArm: "腕の骨折",
    injuryReason_ArmInjury: "腕の怪我",
    injuryReason_Sick: "病気",
    injuryReason_Illness: "病気",
    injuryReason_Fever: "発熱",
    injuryReason_Virus: "ウイルス",
    injuryReason_Infection: "感染症",
    injuryReason_Knock: "打撲",
    injuryReason_Bruise: "打撲傷",
    injuryReason_Strain: "筋肉の張り",
    injuryReason_Sprain: "捻挫",
    injuryReason_Tear: "断裂",
    injuryReason_Surgery: "手術",
    injuryReason_PhysicalCondition: "コンディション不良",
    injuryReason_Rest: "休養",
    injuryReason_PersonalReasons: "個人的な理由",
    injuryReason_Suspended: "出場停止",
    injuryReason_Doubtful: "出場不透明",
    injuryReason_Achillestendonproblems: "アキレス腱の怪我",
    injuryReason_fitness: "コンディション不足",
    injuryReason_Injurytotheankle: "足首の怪我",
    injuryReason_injured: "負傷中",
    injuryReason_InjuredDoubtful: "負傷/出場不透明",
    injuryReason_Suspension: "出場停止",
    injuryReason_RedcardSuspended: "退場処分による出場停止",
    injuryReason_Muscularproblems: "筋肉系のトラブル",
    injuryReason_Thighproblems: "太ももの怪我",
    injuryReason_KneeSurgery: "膝の手術",
    injuryReason_Outerligamenttear: "外側側副靭帯断裂",
    injuryReason_Kneeinjury: "膝の怪我",
    injuryReason_Rupturedcruciateligament: "前十字靭帯断裂",
    injuryReason_FracturedFinger: "指の骨折",
    injuryReason_Sprainedankle: "足首の捻挫",
    injuryReason_UnknownInjury: "原因不明の負傷",
    sponsorshipTitle: "XLEVENをサポート",
    sponsorshipDesc: "最速のサッカーインサイトとAI分析を提供し続けるために、皆様のご支援をお願いいたします。皆様の応援が大きな力になります！",
    supportSmallCoffee: "コーヒー一杯をサポート",
    qrDonation: "QRコードで寄付",
    qrDonationDesc: "QRコードをスキャンして直接送金でサポート",
    sponsorshipWhy: "なぜサポートが必要なのですか？",
    sponsorshipWhyDesc: "皆様からのご支援は、サーバー維持費やAI API費用に充てられ、サッカーコミュニティのための革新的な機能開発を継続するために役立てられます。",
    magazineArchive: "アーカイブ",
    magazineCollection: "コレクション",
    magazineDiscover: "新しいサッカー",
    magazineDeepStories: "インテリジェンス",
    magazineHeroDesc: "厳選されたインサイト、独占インタビュー、戦術的なエッセンスをご覧ください。",
    notices: "お知らせ",
    noNotices: "お知らせはありません",
    noNoticesDesc: "新しいニュースが入り次第お知らせします",
    allLeagues: "すべてのリーグ",
    home: "ホーム",
    news: "フィード",
    player: "選手",
    games: "試合",
    shorts: "ショーツ",
    settings: "設定",
    mypage: "マイページ",
    gamestore: "ゲーム",
    community: "コミュニティ",
    realTimeMatchTalk: "リアルタイム試合トーク",
    recommendedForYou: "最新フィード",
    latestTransferNews: "移籍市場の動向",
    helpCenter: "ヘルプセンター",
    contactUs: "お問い合わせ",
    privacyPolicy: "プライバシーポリシー",
    termsOfService: "利用規約",
    aboutUs: "サイト紹介",
    aboutXleven: "XLEVEN紹介",
    aboutXlevenDesc: "XLEVENはAI技術を活用して、最速のサッカーニュースを提供します。リアルタイムニュース、移籍の噂、データに基づく予測サービスを体験してください。",
    sponsorship: "スポンサーシップ",
    marketWatch: "移籍市場",
    topTransfers: "主な移籍",
    latestHeadlines: "最新ニュース",
    verifiedSources: "検証済みのソース",
    stats: "統計",
    playingCareer: "選手経歴",
    fanZone: "ファンゾーン",
    trendingTopic: "人気トピック",
    analyze: "移籍予測分析",
    analyzing: "分析中...",
    undisclosed: "非公開",
    unknown: "不明",
    noTransfers: "移籍情報が見つかりません: ",
    comingSoon: "v2.0 リリース予定",
    language: "言語",
    selectLanguage: "言語を選択",
    clearCache: "キャッシュ削除",
    cacheCleared: "キャッシュ削除済み",
    all: "すべて",
    global: "グローバル",
    epl: "EPL",
    laliga: "ラ・リーガ",
    seriea: "セリエA",
    bundesliga: "ブンデスリーガ",
    ligue1: "リーグ・アン",
    uefa: "UEFA",
    live: "ライブ",
    replay: "見逃し配信",
    latest: "最新",
    worldCup: "ワールドカップ",
    leagues: "リーグ",
    weeklyMagazine: "マガジン",
    magazine: "マガジン",
    read: "既読",
    welcome: "おかえりなさい",
    loginRequired: "ログインが必要です",
    enterCredentials: "ログイン情報を入力してください。",
    continueWithGoogle: "Googleでログイン",
    continueWithKakao: "Kakaoでログイン",
    continueWithNaver: "Naverでログイン",
    or: "または",
    emailAddress: "メールアドレス",
    password: "パスワード",
    signInAccount: "ログイン",
    noAccount: "アカウントをお持ちでないですか？",
    createAccount: "新規登録",
    fullName: "ニックネーム",
    confirmPassword: "パスワードの確認",
    startExploration: "探索を開始する",
    joinNow: "今すぐ参加",
    recentActivity: "最近のアクティビティ",
    recentActivityDesc: "最近の活動履歴",
    followedPlayers: "フォロー中の選手",
    followedPlayersDesc: "注目選手リストの管理",
    favoriteClubs: "お気に入りクラブ",
    favoriteClubsDesc: "チームのアップデートと通知",
    pushNotifications: "プッシュ通知",
    pushNotificationsDesc: "リアルタイム移籍市場アラート",
    darkMode: "ダークモード",
    supportLegal: "サポートと規約",
    storagePrivacy: "ストレージとプライバシー",
    storagePrivacyDesc: "ローカルストレージの空き容量を増やす",
    logOutAccount: "ログアウト",
    verifiedProfile: "認証済みプロフィール",
    proMember: "プロメンバー",
    activity: "アクティビティ",
    applicationSettings: "アプリ設定",
    back: "戻る",
    forgotPassword: "パスワードをお忘れですか？",
    secureSSL: "安全な接続",
    alreadyMember: "すでにアカウントをお持ちですか？",
    signIn: "サインイン",
    authenticating: "認証中...",
    securingData: "データ同期中...",
    accessGranted: "アクセス成功！",
    scoutingProfileSync: "スカウティングプロフィールが正常に同期されました。",
    dataLinkActive: "データリンク有効",
    redirecting: "ダッシュボードへ移動中...",
    editNickname: "ニックネーム編集",
    save: "保存",
    cancel: "キャンセル",
    nicknameError: "ニックネームは2文字から20文字の間で入力してください。",
    favoriteLeagues: "お気に入りリーグ",
    favoriteLeaguesDesc: "フォロー中の試合カテゴリー",
    manageLeagues: "お気に入りリーグを選択",
    saveChanges: "設定を保存",
    selectLeaguesToFollow: "フォローしたいリーグを選択してください",
    syncSuccess: "設定が正常に保存されました",
    today: "今日",
    dailyAttendance: "ログインボーナス",
    reasonWelcomePoints: "新規登録特典ポイント",
    last7Days: "最近7日間",
    last30Days: "最近30日間",
    allTime: "全期間",
    activityStats: "リーグ順位と記録",
    totalInteractions: "総アクティビティ",
    loadingLeagues: "リーグリストを読み込み中...",
    following: "フォロー中",
    views: "閲覧数",
    comments: "コメント",
    discussionHub: "ディスカッションハブ",
    syncingHub: "コメント同期中...",
    firstIntelligenceReport: "最初のコメントを残しましょう",
    relatedIntelligence: "関連ニュース",
    relatedNews: "関連ニュース",
    reply: "返信",
    report: "報告",
    delete: "削除",
    replyingTo: "返信中",
    typeIntelligenceUpdate: "コメントを入力...",
    establishReport: "意見を共有しましょう...",
    unauthorizedLogin: "ログインが必要です。",
    deleteCommentTitle: "コメントを削除しますか？",
    loginRequiredTitle: "今すぐログインしてサッカーに参加しましょう",
    signInLabel: "ログイン",
    changingLanguage: "システム言語を変更中...",
    intelligenceAudio: "AI音声レポート",
    mergeFailed: "オーディオの読み込みに失敗しました",
    keyBriefing: "キーブリーフィング",
    loadingIntelligence: "ニュース詳細ページを読み込み中...",
    articleNotFound: "記事が見つかりません",
    goBack: "戻る",
    joinConversation: "会話に参加しましょう...",
    loginParticipate: "ログイン後に参加可能です",
    leagueSelectionDescLoggedIn: "フォローするリーグを選択してください。選択内容はアカウントに保存されます。",
    leagueSelectionDescGuest: "フォローするリーグを選択してください。ゲスト情報は3分間維持されます。",
    leagueStage: "リーグステージ",
    knockoutStage: "ノックアウトステージ",
    scenariosTab: "シナリオ",
    loadMoreNews: "もっと見る",
    syncSelectedFeed: "選択したリーグを保存",
    selectAtLeastOneLeague: "少なくとも1つのリーグを選択してください。",
    syncFailedTryAgain: "同期に失敗しました。もう一度お試しください。",
    yourLeagues: "マイリーグ",
    edit: "編集",
    loadMore: "もっと見る",
    latestMovements: "最近の移籍状況",
    syncingMarketIntel: "最新データを同期中...",
    loadingNewsFeed: "ニュースフィードを構成中...",
    analyzingTalent: "データ分析中...",
    syncingFixtures: "試合日程を同期中...",
    syncingMatchDetail: "試合詳細情報を同期中...",
    curatingShorts: "ハイライトを収集中...",
    postingComment: "コメント投稿中...",
    searchingFor: "検索中:",
    matchStats: "スタッツ",
    lineUp: "ラインアップ",
    timeline: "タイムライン",
    talk: "トーク",
    matchHighlights: "試合ハイライト",
    latestTeamNews: "最新チームニュース",
    close: "閉じる",
    fullTime: "終了",
    startingXI: "スタメン",
    substitutes: "ベンチ入り",
    injuries: "負傷者リスト",
    coach: "監督",
    ownGoal: "オウンゴール",
    waitingKickoff: "キックオフ待機中",
    matchStarted: "試合開始",
    lineupAnnouncement: "キックオフの約60分前にラインアップが公開されます",
    noStatsSynced: "スタッツデータがありません",
    post: "投稿",
    discoverMore: "もっと見る",
    shareSuccess: "リンクをクリップボードにコピーしました",
    consultingGrid: "データを照会中...",
    matchesFound: "検索結果",
    zeroIntel: "情報なし",
    refineSearch: "検索条件を確認してください",
    awaitingPersonnel: "選手情報待機中",
    scanningFrequency: "ニュース検索待機中",
    searchNewsPlaceholder: "ニュース検索",
    searchAllLeagues: "リーグ検索",
    searchPlayerPlaceholder: "選手検索",
    searchGamePlaceholder: "試合を検索...",
    searchShortsPlaceholder: "ハイライトを検索...",
    deleteAccount: "退会する",
    deleteAccountConfirm: "本当に退会しますか？退会すると、すべての活動データとスカ우ティング記録が永久に削除されます。",
    confirm: "確認",
    yes: "はい",
    no: "いいえ",
    closingAccount: "退会処理中...",
    joined: "入会日",
    agentTools: "エージェントツール",
    supportInfo: "サポートと情報",
    accountActions: "アカウント設定",
    marketHotspots: "急上昇ホットトピック",
    trendingIntel: "ホットトピック",
    squadBuilderTitle: "予想ラインアップ分析",
    squadBuilderSub: "戦術分隊シミュレーター",
    forwards: "フォワード",
    midfielders: "ミッドフィルダー",
    defenders: "ディフェンダー",
    goalkeepers: "ゴールキーパー",
    selectPersonnel: "選手を選択",
    personnelFound: "該当するポジションの選手がいません",
    selectFormation: "フォーメーションを選択",
    searchingSector: "データを照会中...",
    move: "移動",
    clear: "クリア",
    squadTheme: "グラウンドテーマ",
    themeGrass: "グリーンフィールド",
    themeBlueprint: "タクティカル・ブループリント",
    themeStealth: "ナイト・ステルス",
    themePremium: "プレミアム・ゴールド",
    themeGlass: "グラスモーフィズム",
    themePaper: "クラシック・ペーパー",
    themeCyber: "サイバー・ネオン",
    themeRetroMud: "レトロ・マッド",
    themeNeonFuture: "ネオン・フューチャー",
    ftResult: "最終結果",
    scheduled: "試合予定",
    stadiumCap: "人収容",
    syncingIntel: "データ同期中...",
    standings: "順位表",
    scorers: "得点ランキング",
    assists: "アシストランキング",
    assistsFor: "アシスト",
    managerialCareer: "監督経歴",
    singleMatchPerformance: "この試合のパフォーマンス分析",
    seasonIntelPerformance: "シーズン累積パフォーマンス",
    retrievingIntel: "照会中...",
    saveImage: "画像を保存",
    shareToFeed: "共有",
    aiMatchPrediction: "AI精密分析レポート",
    simulatingScenarios: "精密シミュレーション実行中...",
    runSimulation: "戦略レポートを生成する",
    predictedWinner: "データに基づく優勢チーム",
    expectedScore: "シミュレーションスコア",
    tacticalInsight: "分析レポート",
    aiSimulationDesc: "AIスカウトが選手の最新フォーム、歴史的な統計、戦術データに基づいて試合をシミュレーションします。",
    noSectorActivity: "試合データなし",
    noSectorActivityDesc: "この日付に予定されている試合情報はありません。",
    season2526: "シーズン 25/26",
    momentumEfficiency: "モーメンタムと効率性",
    avgGoals: "平均得点",
    perMatch: "試合当たり",
    goalBalance: "得点バランス",
    goalsFor: "得点",
    goalsAgainst: "失点",
    offensiveDominance: "攻撃優勢",
    defensiveLeakage: "守備不安",
    teamDNAIndices: "チーム主要指標",
    matchOutcomeDistribution: "試合結果の分布",
    cleanSheets: "クリーンシート",
    failedToScore: "無得点試合",
    scoredPenalties: "PK成功",
    missedPenalties: "PK失敗",
    bigWins: "大勝",
    toughLosses: "大敗",
    noVerifiedTransfers: "過去1年間に確認された移籍記録はありません",
    reportTitle: "コメントの報告",
    reportDesc: "報告の理由を選択してください",
    reportReasonSpam: "スパムまたは宣伝目的",
    reportReasonHarassment: "嫌がらせまたはヘイトスピーチ",
    reportReasonInappropriate: "不適切なコンテンツ",
    reportReasonViolence: "暴力または危険な行為",
    reportReasonOther: "その他",
    reportOtherPlaceholder: "詳細な理由を入力してください...",
    submitReport: "報告を送信",
    maintenanceTitle: "システムメンテナンス中",
    maintenanceDesc: "まもなく新しいハイライトがアップデートされます。\nご不便をおかけして申し訳ありません。",
    maintenanceUntil: "メンテナンス終了予定: KST 09:00 (UTC 00:00)",
    shareIntelligence: "フィードを作成",
    whatsHappening: "サッカー界の最新ニュースを教えてください。",
    postSuccess: "フィードが正常に共有されました",
    uploadingIntel: "アップロード中...",
    addLink: "リンクを追加",
    linkPlaceholder: "リンクを入力 (例: https://...)",
    linkValidationError: "リンクは https:// で始まる必要があります。",
    urlRestricted: "該当サイトのポリシーによりアクセスが制限されているリンクです。",
    urlPaywall: "この記事は有料購読が必要な場合があります。",
    urlDynamicWarning: "複雑なコンテンツを含むサイトです。分析が制限される場合があります。",
    aiAnalyzing: "分析中...",
    aiWaitNote: "精密検証のために約20〜40秒かかります。",
    scoutingStatus1: "現地のスカウティングネットワークに接続中...",
    scoutingStatus2: "市場価値データを照合中...",
    scoutingStatus3: "戦術的な洞察を合成中...",
    scoutingStatus4: "最終レポートを生成中...",
    aiTimeout: "分析に時間がかかりすぎています（60秒超過）。もう一度試すか、リンクを確認してください。",
    aiNotFootball: "サッカー界の最新ニュースを教えてください。",
    aiDraftTitle: "AIニュース下書き",
    aiDraftSubtitle: "フィードにすぐに適用できます",
    extractedTitle: "抽出されたタイトル",
    generatedContent: "生成された本文",
    aiDraftDisclaimer: "この下書きは参考用です。「適用する」を押して内容をエディタに取り込んだ後、自由に編集してください。",
    applyToEditor: "エディタに適用する",
    imageSourceLabel: "出典",
    selectionDone: "完了",
    inquiryHistory: "お問い合わせ履歴",
    emailSupport: "メールでお問い合わせ",
    myHistory: "マイお問い合わせ履歴",
    newInquiry: "お問い合わせ受付",
    noInquiryHistory: "お問い合わせ履歴はありません。",
    completed: "回答済み",
    response: "回答",
    inquiryGeneral: "一般のお問い合わせ",
    inquiryAccount: "アカウント/ログイン",
    inquiryContent: "コンテンツの報告/修正",
    inquiryError: "エラー報告",
    inquirySuggestion: "機能の提案",
    clearLocalStorage: "ローカルデータの初期化",
    clearLocalStorageConfirm: "ユーザー情報を除くすべてのローカルデータを削除しますか？設定や一時データが初期化されます。",
    attendance: "出席チェック",
    attendanceDesc: "毎日出席してボーナスをゲット",
    favoriteTeams: "お気に入りチーム",
    favoriteTeamsDesc: "フォロー中のサッカーチーム",
    matchPredictions: "試合予測レポート",
    matchPredictionsDesc: "AIが分析した私の試合予測レポート",
    pointHistoryTitle: "マイポイント履歴",
    pointHistorySub: "獲得および使用履歴を確認してください",
    english: "英語 (UK)",
    korean: "韓国語 (KR)",
    clearingData: "データを初期化中...",
    logoutConfirm: "本当にログアウトしますか？",
    teamDetails: "チーム詳細情報",
    teamNotFound: "チーム情報が見つかりません。",
    homeStadium: "ホームスタジアム",
    recentMatches: "最近の試合",
    squad: "分隊",
    goalkeeper: "ゴールキーパー",
    defender: "ディフェンダー",
    midfielder: "ミッドフィルダー",
    attacker: "アタッカー",
    languageSaveSuccess: "言語設定が保存されました。",
    languageAiNote: "選択した言語に応じて、AIが生成するニュースの要約や分析内容がその言語で提供されます。",
    "Shots on Goal": "枠内シュート",
    "Shots off Goal": "枠外シュート",
    "Total Shots": "シュート数",
    "Blocked Shots": "ブロックされたシュート",
    "Shots insidebox": "ボックス内シュート",
    "Shots outsidebox": "ボックス外シュート",
    "Fouls": "ファウル",
    "Corner Kicks": "コーナーキック",
    "Offsides": "オフサイド",
    "Ball Possession": "ポゼッション",
    "Yellow Cards": "警告",
    "Red Cards": "退場",
    "Goalkeeper Saves": "セーブ数",
    "Total passes": "パス数",
    "Passes accurate": "成功したパス",
    "Passes %": "パス成功率",
    "Expected Goals": "期待得点(xG)",
    expected_goals: "期待得点(xG)",
    goals_prevented: "失点阻止(xGP)",
    noIntelTitle: "ニュースなし",
    noIntelDesc: "この日付のフィードはありません。",
    noSectorIntel: "このセクターの情報は取得できません",
    noContentFound: "コンテンツが見つかりません",
    performanceHistory: "シーズン別パフォーマンス",
    detailedSeasonBreakdown: "シーズン詳細情報",
    recentForm: "最近の試合記録",
    noContentDesc: "現在表示できるデータがありません。他のメニューを確認してみませんか？",
    unlockFullIntel: "フルインテリジェンスをアンロック",
    careerIntelNotAvailable: "経歴情報を取得できません",
    transferHistory: "移籍履歴",
    freeAgent: "フリーエージェント",
    capturingImage: "3D画像キャプチャ中...",
    classicGround: "クラシックグラウンド",
    realStadium: "リアルスタジアム",
    imageUploadFailed: "画像のアップロードに失敗しました。",
    captureFailed: "キャプチャに失敗しました。",
    noFavoriteTeams: "お気に入りチームがありません",
    noFavoriteTeamsDesc: "試合詳細ページでお気に入りチームのハートアイコンを押して追加してみてください。",
    removeFavoriteTeam: "お気に入りから削除",
    removeFavoriteTeamConfirm: "本当にお気に入りから削除しますか？",
    setDefaultTeamTitle: "デフォルトチームに設定しますか？",
    setDefaultTeamDesc: "このチームをデフォルトチームに設定しますか？デフォルトチームは1つだけ設定可能です。",
    defaultTeam: "デフォルトチーム",
    selectDefaultTeam: "デフォルトチームに設定",
    contactSupport: "1:1 お問い合わせ",
    contactSupportDesc: "XLEVENサービスの利用に関する質問や不便な点をお問い合わせください。",
    mySupportHistory: "お問い合わせ履歴の確認",
    mySupportHistoryDesc: "受付したお問い合わせの内容と回答を確認できます。",
    myPageDesc: "XLEVENマイページでプロフィールの管理、出席チェック、ポイント履歴、AI試合予測レポートを確認してください。",
    attendanceDescSEO: "毎日出席してボーナスポイントを獲得しましょう。",
    pointHistoryDescSEO: "マイポイントの獲得および使用履歴を確認してください。",
    playerAge: "年齢",
    playerHeight: "身長",
    playerWeight: "体重",
    matchPredictionsDescSEO: "AIが分析した私の試合予測データと戦術レポートを確認してください。",
    recentActivityDescSEO: "作成したコメントとコミュニティ活動履歴を確認してください。",
    favoriteLeaguesDescSEO: "フォローするリーグを選択して、カスタマイズされたサッカー情報を受け取ってください。",
    favoriteTeamsDescSEO: "フォロー中のサッカーチームリストを確認してください。",
    languageDescSEO: "サービスの利用言語を変更してください。",
    allMatchFixturesSeoTitle: "すべての試合日程",
    allMatchFixturesSeoDesc: "世界中の主要リーグのリアルタイムスコア、試合日程、結果を確認してください。",
    leagueMatchFixturesSeoTitle: "試合日程",
    leagueMatchFixturesSeoDesc: "{{leagueName}}のリアルタイムスコア、試合日程、結果を確認してください。",
    noticeUpdate: "お知らせ更新",
    reasonDailyAttendance: "毎日の出席チェック",
    checkNow: "今すぐ確認",
    loading: "読み込み中...",
    loadingMore: "さらに読み込み中...",
    noPredictionsYet: "予測履歴がありません",
    analyzeMatchesDesc: "試合を分析してAIレポートを受け取りましょう。",
    exploreMatches: "試合リストを見に行く",
    predictionAccuracy: "予測精度",
    analysisStatistics: "分析統計",
    totalAnalysis: "総分析数",
    searchByTeam: "チーム名で検索...",
    lastWeek: "最近1週間",
    lastMonth: "最近1ヶ月",
    myAiTacticalReports: "マイAI分析レポート",
    formation: "フォーメーション",
    theme: "テーマ",
    swapTip: "ドラッグして位置を変更",
    squadAnalysis: "分隊分析",
    newsTitle: "タイトル",
    translateToEn: "英語に翻訳",
    translateToKo: "韓国語に翻訳",
    translating: "翻訳中...",
    addSource: "出典を追加",
    sourcePlaceholder: "出典名を入力 (例: bbc)",
    apiAndCopyright: "APIおよび著作権情報",
    noMajorGamesToday: "お気に入りリーグで本日予定されている主要な試合はありません。",
    adminTools: "管理者ツール",
    adminControlCenter: "管理者コントロールセンター",
    adminControlCenterDesc: "ユーザー、投稿、システムプロトコルの管理",
    addFavoriteLeaguesTitle: "お気に入りリーグをフォローしてください",
    addFavoriteLeaguesDesc: "好きなリーグを選択して、ホームフィードでリアルタイムスコアとカスタマイズされたインテリジェンスを受け取りましょう。",
    setupNow: "今すぐ設定する",
    addFavoriteLeaguesButton: "お気に入りリーグを追加",
    deleteFeedConfirm: "本当にこのフィードを削除しますか？削除後は復旧できません。",
    reportFeedTitle: "フィードの報告",
    editFeed: "フィード編集",
    deleteFeed: "フィード削除",
    reportFeed: "フィード報告",
    alreadyReported: "すでに報告済みのコンテンツです。",
    reportCompleted: "報告が正常に受理されました。",
    externalSourceReportError: "外部ニュースソースは直接報告できません。",
    postDeletedSuccess: "フィードが正常に削除されました。",
    scanningSectorData: "セクターデータスキャン中...",
    searchResults: "検索結果",
    analysisFailed: "分析失敗",
    feedPostPointEarned: "フィード登録完了！ +{{amount}}P 獲得",
    failedToPostNews: "フィードの投稿に失敗しました。",
    feedDeletePointDeducted: "フィードの削除により10Pが差し引かれました。",
    failedToDelete: "삭제 실패",
    seoDefaultDescription: "世界のサッカーニュース、リアルタイムの移籍の噂、試合のハイライト、AIデータ分析レポート。プレミアリーグ、ラ・リーガ、チャンピオンズリーグなどの最新情報をXLEVENで最速チェック.",
    seoDefaultKeywords: "サッカーニュース, 移籍の噂, ライブスコア, サッカー分析, プレミアリーグ, ラ・リーガ, チャンピオンズリーグ, AIサッカー予測",
    seoHomeTitle: "グローバルサッカーニュース＆リアルタイム移籍の噂 AI分析",
    topTransfersSeoDesc: "歴代最高移籍金を記録した主な移籍状況と詳細情報を分析します。",
    latestMovementsSeoDesc: "サッカー界の最新のリアルタイム移籍状況と公式発表をどこよりも早くお届けします。",
    playerDetailSeoDesc: "{{playerName}}の詳細データ、シーズン成績、移籍履歴、最近のパフォーマンスをチェックしてください。",
    playerDetailSeoTitle: "{{playerName}} - {{position}} ({{team}})",
    synchronizingIntelligence: "データ同期中...",
    summer: "夏",
    winter: "冬",
    dataProvidedBy: "データ提供",
    leagueHighlightsSeoDesc: "{{leagueName}}の最新サッカー試合ハイライト映像をチェックしてください。",
    matches: "試合",
    awaitingMarketIntel: "移籍市場情報待機中...",
    scanningSectorIntel: "セクタースキャン中...",
    noticeTitle: "XLEVENシステムアップデート",
    noticeBody: "高精度なサッカー分析のためにGemini 2.5 AIエンジンが有効化されました。リアルタイムのスカウティングレポートと強化された移籍市場予測サービスをご利用いただけます。",
    dontShowToday: "今日は表示しない",
    emailRequired: "メールアドレスを入力してください",
    resetFailed: "再設定リンクの送信に失敗しました",
    resendFailed: "メールの再送信に失敗しました",
    emailNotConfirmedMsg: "メール認証が完了していません。メールボックスを確認してください。",
    resendSuccess: "送信成功",
    resendAction: "認証メールを再送信",
    invalidCredentials: "メールアドレスまたはパスワードが正しくありません。",
    tooManyRequests: "リクエストが多すぎます.しばらくしてからもう一度お試しください.",
    fixtures: "対戦成績",
    activeSource: "選択されたリーグ",
    updateSectors: "お気に入りリーグの修正",
    configureIntelSources: "お気に入りリーグの設定",
    searchingGlobalDatabase: "検索中...",
    noMatchingSectors: "一致するセクターが見つかりません",
    majorLeagues: "主要リーグ",
    majorCups: "主要カップ",
    addedSectors: "追加されたセクター",
    goToToday: "今日へ移動",
    scanningGrid: "データスキャン中...",
    rating: "評価",
    goals: "得点",
    passPercentage: "パス成功率",
    dribbles: "ドリブル",
    defense: "守備",
    captain: "キャプテン",
    injured: "負傷",
    club: "クラブ",
    played: "試合数",
    points: "勝点",
    goalDiff: "GD",
    win: "勝",
    draw: "分",
    loss: "敗",
    ucl: "UCL",
    uel: "UEL",
    rel: "降格圏",
    noConcludedMatches: "終了した試合の記録はありません",
    loadingRecords: "記録を読み込み中...",
    from: "から",
    to: "へ",
    transfer: "移籍",
    openOriginal: "元記事を見る",
    refreshLiveData: "ライブデータを更新",
    syncingMatchIntelDesc: "データを同期中...",
    newPassword: "新しいパスワード",
    updatePassword: "パスワードを更新",
    passwordChanged: "パスワード変更完了！",
    passwordChangedDesc: "パスワードが正常に更新されました。",
    passwordMismatch: "パスワードが一致しません。",
    fillAllFields: "すべての項目を入力してください。",
    passwordMatch: "パスワードが一致しました。",
    passwordSameAsOld: "新しいパスワードは現在のパスワードと異なる必要があります。",
    passwordMinLength: "最少8文字以上",
    passwordLetters: "英字を含む",
    passwordNumbers: "数字を含む",
    passwordSpecial: "特殊文字を含む",
    resetIntel: "パスワード再設定",
    verifyIdentity: "本人確認が必要です",
    accountEmail: "アカウントメール",
    enterRegisteredEmail: "登録済みのメールアドレスを入力してください",
    authorizeReset: "認証メールを送信",
    backToEntry: "ログイン画面に戻る",
    nicknameUpdated: "ニックネームが正常に変更されました。",
    profileImageUpdated: "プロフィール写真が変更されました。",
    backgroundImageUpdated: "背景画像が変更されました。",
    uploadFailed: "アップロード中に問題が発生しました。もう一度お試しください。",
    fileSizeError: "ファイル容量が大きすぎます。5MB以下のファイルを選択してください。",
    pointHistory: "ポイント履歴",
    pointGuide: "ポイント案内",
    pointGuideDesc: "活動を通じて獲得したポイント履歴を確認できます。ポイントは今後様々なサービスで使用可能です。",
    noPointHistory: "ポイント履歴がありません。",
    loadingPointHistory: "ポイント履歴を読み込み中...",
    gatheringIntel: "情報収集中...",
    syncingPointHistory: "ポイント履歴を同期中...",
    reason7DayBonus: "7日間連続ログインボーナス",
    reasonNewsPost: "フィード投稿",
    reasonNewsDelete: "フィード削除",
    reasonCommentPost: "ニュースコメント投稿",
    reasonCommentDelete: "ニュースコメント削除",
    reasonAiReport: "AI精密分析レポート",
    reasonRegularEarn: "通常獲得",
    reasonAdminSpecialReward: "管理者特別報酬",
    reasonNeonPitch: "ゲームプレイ: NEON PITCH",
    reasonTripleBetMultiple: "トリプルベット重複選択",
    reasonTripleBetAi: "トリプルベットAI分析",
    reasonFootyMaster: "ゲームプレイ: FOOTY MASTER",
    pointEarned: "ポイント獲得！",
    pointDeducted: "ポイント差し引き。",
    commentPosted: "コメント投稿！",
    commentDeleted: "コメント削除。",
    feedPosted: "フィード投稿！",
    feedDeleted: "フィード削除。",
    attendanceComplete: "ログイン完了！",
    firstLoginToday: "今日の初ログイン！",
    deleteCancel: "削除キャンセル",
    deleteConfirmDesc: "削除された内容は復旧できません.本当に削除しますか?",
    editCancel: "編集キャンセル",
    editCancelDesc: "編集内容は保存されません。本当に終了しますか？",
    postCancel: "作成キャンセル",
    postCancelDesc: "内容は保存されません. 本当に終了しますか？",
    errorLoadingImages: "画像を読み込めませんでした。",
    errorProcessingAttendance: "ログインチェック中にエラーが発生しました。",
    errorAnalysis: "分析中にエラーが発生しました。",
    errorReport: "報告에 실패했습니다.",
    errorDelete: "削除に失敗しました。",
    enterTitleAndContent: "タイトルと内容を入力してください。",
    inquirySubmitted: "お問い合わせが受け付けられました。",
    errorInquiry: "受付中にエラーが発生しました。",
    category: "お問い合わせタイプ",
    title: "タイトル",
    content: "詳細内容",
    inquiryPlaceholder: "お問い合わせ内容を詳細にご記入ください",
    titlePlaceholder: "お問い合わせタイトルを入力してください",
    inquiryNote: "お問い合わせいただいた内容は順次確認後、回答いたします.土日祝日は回答が遅れる場合があります。",
    submitInquiry: "お問い合わせを送信",
    attendanceStreak: "ログインストリー크",
    attendanceNote: "毎日ログインしてより多くの特典をゲット",
    attendanceCompleted: "今日のログイン完了",
    checkAttendanceNow: "今すぐログインチェック",
    weeklyProgress: "週間進捗",
    baseReward: "基本報酬",
    streakBonus: "連続ボーナス",
    attendanceResetNote: "深夜(00:00)を基準に新しいログインチェックが可能になります.",
    present: "現在",
    frame: "フレーム",
    searchPlaceholder: "理由、報告者または内容で検索...",
    playerAndTransferManagement: "会員および移籍管理",
    playerManagementDesc: "移籍市場データおよび選手グループ管理",
    latestTransfers: "最新の移籍",
    groupList: "グループリスト",
    playerSearchPlaceholder: "選手またはクラブで検索...",
    addItem: "アイテム追加",
    playerIntel: "選手インテル",
    movement: "移籍ルート",
    valueFee: "価値/移籍金",
    noItemsFound: "人的資産が見つかりません",
    createGroup: "グループ作成",
    editGroup: "グループ編集",
    addPersonnel: "人員追加",
    editPersonnel: "人員編集",
    deleteItem: "アイテム削除",
    deleteGroupConfirmDesc:
      "本当にこのグループを削除しますか?このグループ内のすべての人的データも永久に削除されます.",
    deleteItemConfirmDesc: "本当にこの人的資産を削除しますか？この操作は取り消せません.",
    systemSettingsDesc: "システムコアエンジンおよびネットワークポリシー管理",
    awardPoints: "ポイント付与",
    awardPointsDesc: "このユーザーにポイントを付与します.",
    award: "付与",
    awardSuccess: "ポイントが正常に付与されました.",
    amount: "数量",
    reason: "理由",
    auditIntelligenceDesc: "コミュニティ共有インテルの検討と管理",
    auditReportsDesc: "すべての事件レポートの検討と管理",
    noResultsFound: "結果が見つかりません",
    noTrendingData: "トレンドデータがありません",
    pointDeduction: "ポイント差し引き",
    insufficientPoints: "ポイント不足",
    rechargeRequired: "チャージが必要",
    allMatchFixtures: "すべての試合日程",
    leagueMatchFixtures: "リーグ試合日程",
    allMatchFixturesDesc: "世界中の主要リーグのリアルタイムスコア、日程および結果を確認してください.",
    playerStatsDesc: "詳細データ、シーズン統計、移籍記録および最近のフォームを確認してください.",
    newsFeedDesc: "最新のサッカーニュースとリアルタイムの移籍の噂を日付別に確認してください.",
    shortsDesc: "最もホットなサッカーハイライトとショーツ動画をシームレスにお楽しみください.",
    maintenanceResumes: "KST 09:00 (UTC 00:00)に再開されます.",
    swipeGuide: "左または右にスワイプ",
    swipeDateGuide: "して日付別のニュースを確認してください",
    apiInfoDesc1:
      "XLEVENはAPI-Sports(API-Football)からすべてのリアルタイム試合結果、選手統計、ラインアップおよび移籍情報の提供を受けています.このデータの源泉権利は提供者および各リーグ連盟にあります.",
    apiInfoDesc2:
      "移籍予測分析およびニュース要約サービスはGoogle Gemini AIエンジンを通じて生成されます。人工知能によって生成されたすべての分析レポートは参考用であり、法的効力はありません。",
    apiInfoDesc3:
      "動画ハイライトおよびショーツコンテンツはYouTube Data APIを通じて埋め込み形式で提供されます.動画に関するすべての著作権は該当プラットフォームのチャンネル所有者に帰属します.",
    apiInfoDesc4:
      "ニュースフィードおよび記事に使用される主要な視覚資料および背景画像は、BBC Sport RSSおよびPexelsが提供するロイヤリティフリーのライセンスリソースを活用しています.",
    apiInfoDesc5:
      "本サービス内で使用されるクラブロゴ、リーグエンブレム、実際の選手写真などのすべての視覚資料の著作権は、各原著作者（クラブ、リーグ連盟、ニュース代理店など）に帰属します.",
    apiInfoDesc6:
      "XLEVENはこれらの資料を公報、統計およびデータ分析の目的でのみ活用し、いかなる場合も無断で画像を加工したり商業目的で再販したりしません.著作権侵害の報告を受けた場合、内部検討後直ちに措置を講じます.",
    apiSportsData: "スポーツデータAPI",
    apiAiIntelligence: "AI分析",
    apiMediaVideo: "メディアおよび動画",
    apiNewsAssets: "ニュースアセット",
    apiBbcSource: "BBCスポーツニュースソース",
    apiCopyrightDisclaimer: "著作権に関する告知事項",
    privacyDesc1:
      'XLEVEN（以下「本サイト」）は利用者の個人情報を大切にし、関連法令を遵守します.本個人情報の取り扱い方針は、利用者が本サイトを利用する際にどのような情報が収集され、どのように使用されるかを説明します.',
    privacySection1Title: "1. 収集する個人情報の項目",
    privacySection1Desc:
      "本サイトは基本的に個人情報を直接収集しません.ただし、サービス利用の過程で以下のような情報が自動的に収集される場合があります.",
    privacySection2Title: "2. 個人情報の利用目的",
    privacySection2Desc: "収集された情報は以下の目的のために使用されます.",
    privacySection3Title: "3. クッキーの使用に関する情報",
    privacySection3Desc1:
      "本サイトはクッキーを使用する場合があります.クッキーは利用者のブラウザに保存される少量のデータであり、サイトで利用者の好みを記憶し、より良いサービスを提供するために使用されます.",
    privacySection3Desc2:
      "利用者はブラウザの設定を通じてクッキーの保存を拒否することができ、クッキー拒否時には一部サービスの利用に制限がある場合があります.",
    privacySection4Title: "4. Google アドセンスおよび第三者広告",
    privacySection4Desc1: "本サイトはGoogleアドセンスを含む第三者広告サービスを使用しています.",
    privacySection4Desc2:
      "Googleなどの第三者広告提供事業者は、クッキーを使用して利用者の過去の訪問に基づき広告を掲載します.",
    privacySection4Desc3:
      "Googleの広告クッキー（DARTクッキー）を通じて、利用者が本サイトおよびその他のサイトを訪問した際にパーソナライズされた広告を提供します.",
    privacySection4Desc4: "利用者はGoogle広告設定ページでパーソナライズされた広告を無効にすることができます.",
    privacySection4Link: "Google個人情報の取り扱い方針を確認",
    privacySection5Title: "5. 第三者への個人情報の提供",
    privacySection5Desc:
      "本サイトは利用者の個人情報を第三者に販売したり共有したりしません.ただし、法律で要求される場合は例外とします.",
    privacySection6Title: "6. 外部リンク",
    privacySection6Desc:
      "本サイトには外部ウェブサイトへのリンクが含まれる場合があります.本サイトは外部サイトの個人情報の取り扱い方針およびコンテンツについて責任を負いません.",
    privacyContactEmail: "メール",
    privacyContactSite: "サイト名",
    privacyEffectiveDate: "施行日: 2026년 1월 20일",
    privacyItemIP: "IPアドレス",
    privacyItemBrowser: "ブラウザタイプ",
    privacyItemDate: "訪問日時",
    privacyItemPage: "訪問したページ",
    privacyItemCookie: "クッキー",
    privacyUsageStats: "サイト利用統計分析",
    privacyUsageImprove: "コンテンツおよびユーザー体験の改善",
    privacyUsageAds: "広告サービスの提供および最適化",
    privacySection5Desc1: "本サイトは最適化されたサービスを提供し、広告を掲載するために「クッキー」を使用します.クッキーはウェブサイトがユーザーのブラウザに保存する小さなテキストファイルです.",
    privacySection5Desc2: "Googleを含む第三者配信事業者は、クッキーを使用して、ユーザーがウェブサイトに過去にアクセスした際の情報に基づいて広告を配信します.Googleが広告クッキーを使用することにより、ユーザーがそのサイトや他のサイトにアクセスした際の情報に基づいて、Googleやそのパートナーが適切な広告をユーザーに表示できます.",
    privacySection5Desc3: "利用者は、広告設定（https://www.google.com/settings/ads）でパーソナライズ広告を無効にできます.または、www.aboutads.infoにアクセスして、パーソナライズ広告に使われる第三者配信事業者のクッキーを無効にできます.",
    termsSection1Title: "第1条（目的）",
    termsSection1Desc: "本利用規約は、XLEVEN（以下「サイト」）で提供するすべてのサービスの利用条件および手順、利用者とサイトの権利、義務および責任事項を定義することを目的とします.",
    termsSection2Title: "第2条（用語の定義）",
    termsSection2Desc: "1. 「利用者」とは、サイトにアクセスして本規約に従いサービスを利用する会員および非会員をいいます.\n2. 「コンテンツ」とは、サイトで提供するサッカーニュース、データ、分析レポートなどをいいます.",
    termsSection3Title: "第3条（規約の効力および改定）",
    termsSection3Desc: "サイトは関連法令に違反しない範囲内で本規約を改定することができ、改定された規約はサイト内のお知らせを通じて掲示することで効力が発生します.",
    termsSection4Title: "第4条（サービス内容）",
    termsSection4Desc: "サイトはリアルタイムサッカースコア、ニュースフィード、AIデータ分析およびコミュニティサービスを提供します. サービス内容は技術的仕様の変更により変わる場合があります.",
    termsSection5Title: "第5条（掲示物およびデータの著作権）",
    termsSection5Desc: "1. サイトで提供するすべてのニュースおよびデータは著作権法により保護されます.\n2. 利用者はサービス利用を通じて得た情報を、サイトの事前の承認なしに複製、送信、出版、配布、放送その他の方法によって営利目的で利用したり、第三者に利用させたりしてはなりません.",
    termsSection6Title: "第6条（広告の掲載）",
    termsSection6Desc: "サイトはサービスの運営に関連して、サービス画面に広告を掲載することができます.これは最高のコンテンツサービスを継続的に提供するための必須要素です.",
    copyFailed: "コピーに失敗しました.",
    newsFeedSeoTitle: "サッカーフィード",
    newsFeedSeoDesc: "世界中の主要リーグの最新サッカーニュースとリアルタイムの移籍の噂を日付別にチェックしてください.",
    pexelsGallery: "Pexelsギャラリー",
    highFidelityAssets: "高品質なサッカーアセット",
    tapToPlayWithSound: "タップしてサウンドと共に再生",
    videoUnavailable: "この動画は現在お住まいの地域では再生できません.",
    shortsPreparingTitle: "ショーツ動画を準備中です",
    shortsPreparingDesc: "現在、最新の動画を収集中です.しばらくしてからもう一度ご確認ください！",
    shortsSeoTitle: "サッカーハイライト＆ショーツ | XLEVEN",
    shortsSeoDesc: "世界中の最新サッカーハイライトとショーツ動画をシームレスにお楽しみください.AI가おすすめする最高のサッカーの瞬間を体験できます.",
    gameStoreTitle: "サッカーゲーム",
    newGamePreparing: "新しいゲームを準備中です",
    newGamePreparingDesc: "XLEVENだけで楽しめる特別なサッカーゲームが間もなく公開されます.お楽しみに！",
    ranking: "ランキング",
    play: "プレイ",
    gameRanking: "ゲームランキング",
    fetchingRankings: "ランキングを取得中...",
    noRankingsYet: "ランキングはまだありません",
    preparing: "準備中...",
    toto_history: "予測履歴",
    toto_submit: "完了",
    toto_check_predictions: "予測履歴の確認",
    toto_round_format: "第 {{n}} 回",
    toto_finished: "終了",
    toto_in_progress: "進行中",
    toto_success_count: "予測成功",
    toto_submitted_at: "提出日時",
    toto_not_participated: "この回には参加していません.",
    toto_detailed_results: "詳細な予測結果",
    toto_correct: "的中",
    toto_incorrect: "不的中",
    toto_my_pick: "(自分の選択)",
    toto_result: "(結果)",
    toto_win: "勝",
    toto_draw: "分",
    toto_loss: "敗",
    toto_ai_winner: "勝利予想",
    toto_ai_score: "予想スコア",
    toto_ai_win_rate: "勝率",
    toto_ai_tactical: "戦術分析",
    toto_save_failed: "保存に失敗しました.",
    toto_predictions_status: "予測状況",
    toto_view_analysis: "分析を確認",
    toto_ai_analysis: "AI分析",
    toto_predict_title: "14試合を予測して",
    toto_win_points: "ポイントを獲得しましょう！",
    toto_challenge_win: "挑戦して勝利",
    toto_players_joined: "現在 {{count}} 人が参加中",
    toto_rules_title: "ゲーム利用案内",
    toto_rules_policy: "TRIPLE BETゲームポリシー",
    toto_rules_1: "各試合につき1つの結果のみ選択可能です.",
    toto_rules_2: "的中した試合ごとに10ポイントと10スコアを獲得します.",
    toto_rules_3: "AI分析利用時に10pが差し引かれます.",
    toto_rules_4: "重複選択は最大20個まで可能です.",
    toto_rules_5: "14個まで差し引きなし、15個(10p)、16個(20p)、17個(30p)差し引かれ、20個選択時に合計210pが差し引かれます。",
    toto_rules_6: "* ポイント不足時は参加が制限されます.",
    toto_login_required: "ログインが必要です",
    toto_login_desc: "TOTOゲームに参加するにはログインが必要です.",
    toto_login_button: "ログインする",
    toto_no_round_title: "開催中の回がありません",
    toto_no_round_desc: "新しい回가まもなく開始されます.少々お待ちください！",
    toto_already_participated: "既に参加済みのユーザーです.",
    webtoonHeroTitle: "サッカー、その先の感動を",
    webtoonHeroTitleColor: "XLEVEN ウェブトゥーン",
    webtoonHeroDesc: "毎週更新されるオリジナルサッカーウェブトゥーンシリーズ。他では見られない特別な物語に出会ってください。",
    noWebtoons: "まだ登録されたウェブトゥーン이 없습니다。",
    webtoonSeoTitle: "サッカーウェブトゥーンコレクション",
    webtoonSeoDesc: "XLEVENだけで見られる最新のサッカーウェブトゥーンをチェックしてください。毎週更新されるオリジナルのサッカー物語とシリーズを楽しむことができます。",
    toto_round_expired: "この回は終了しました。",
    toto_submit_expired: "締め切り時間を過ぎたため、購入できません。",
    toto_predict_all: "すべての試合の結果を予測してください。",
    toto_insufficient_points: "ポイントが不足しています。(必要: {{amount}}p)",
    toto_saved_with_deduction: "予測が保存されました！ ({{amount}}p 差し引き)",
    toto_saved_success: "予測が正常に保存されました！",
    toto_ai_completed: "AI分析が完了しました！",
    toto_ai_error: "分析中にエラーが発生しました。",
    toto_exit_title: "ゲームを終了しますか？",
    toto_exit_desc: "選択した予測内容は保存されません。",
    toto_exit_confirm: "終了",
    toto_exit_cancel: "続ける",
    toto_seo_title: "勝敗予想チャレンジ - 毎週開催されるサッカー予想ゲーム",
    toto_seo_description: "毎週更新される世界中のサッカーリーグの試合結果を予想して、ポイントを獲得しましょう。AI分析データと共に勝利の確率を高めてください。",
    toto_seo_keywords: "勝敗予想, サッカー予想, トート, XLEVEN, スポーツベッティング, サッカー分析",
    toto_result_seo_title: "マイ勝敗予想履歴 - サッカー予想ゲームの結果確認",
    toto_result_seo_description: "毎週参加したサッカー試合の予想結果と獲得ポイントを確認しましょう。詳細な試合レポートを通じて的中率を分析できます。",
    toto_result_seo_keywords: "勝敗予想結果, サッカー予想履歴, トート結果, XLEVEN, 的中確認",
    neon_pitch_seo_title: "ネオン・ピッチ(NEON PITCH) - レトロサッカーアーケードゲーム",
    neon_pitch_seo_description: "レトロな感覚のサッカーアーケードゲームを楽しんでください。ネオンボールを操作して障害物を避け、最高スコアに挑戦しましょう。",
    neon_pitch_seo_keywords: "ネオンピッチ, サッカーゲーム, アー케ードゲーム, レトロゲーム, XLEVENゲーム, ミニゲーム",
    "neon_pitch_score": "スコア",
    "neon_pitch_best": "ベスト",
    "neon_pitch_time_left": "残り時間",
    "neon_pitch_streak": "連続ゴール！",
    "neon_pitch_fever_unleashed": "ゴールフィーバー解放！",
    "neon_pitch_adrenaline_gauge": "アドレナリンゲージ",
    "neon_pitch_instructions": "できるだけ多く得点しよう！",
    "neon_pitch_exit": "ストアに戻る",
    "neon_pitch_full_time": "試合終了",
    "neon_pitch_total_score": "合計スコア",
    "neon_pitch_max_combo": "最大コンボ",
    "neon_pitch_rematch": "再試合プレイ",
    "neon_pitch_deduction_toast": "10ポイント減少",
    "neon_pitch_kickoff": "キックオフ",
    neon_pitch_insufficient_points: "ポイント가不足しています。",
    viewTranslation: "翻訳を表示",
    viewOriginal: "原文を表示",
    selectPostType: "投稿タイプの選択",
    viewH2HDetail: "相対的な詳細を見る",
    footy_master_preparing_arena: "アリーナを準備中...",
    footy_master_trivia_quiz: "サッカー雑学クイズ",
    footy_master_high_score: "最高スコア",
    footy_master_start_desc: "サッカーの知識を披露してポイントを獲得しましょう！",
    footy_master_questions: "問題数",
    footy_master_random: "ランダム10問",
    footy_master_time_limit: "制限時間",
    footy_master_time_s_q: "15秒 / 問",
    footy_master_get_started: "スタート",
    footy_master_back_to_store: "出る",
    footy_master_back_to_start: "スタートに戻る",
    footy_master_question_n_of_m: "問題 {{n}} / {{m}}",
    footy_master_mission_complete: "ミッション完了",
    footy_master_total_score: "合計スコア",
    footy_master_accuracy: "正解数",
    footy_master_play_again: "もう一度プレイ",
    footy_master_exit_to_store: "ストアに戻る",
    footy_master_cat_worldcup: "ワールドカップ",
    footy_master_cat_epl: "EPL",
    footy_master_cat_laliga: "ラ・リーガ",
    footy_master_cat_ucl: "CL",
    footy_master_cat_kleague: "Kリーグ",
    footy_master_commentary_perfect: "完璧です！あなたは生けるサッカー百科事典です！🏆⚽️",
    footy_master_commentary_great: "素晴らしい実力です！ほぼ専門家レベルですね！🔥👏",
    footy_master_commentary_good: "悪くない成績です！もう少しでマスターになれます！💪✨",
    footy_master_commentary_average: "もう少しサッカーの勉強が必要かもしれません！もう一度挑戦してみますか？📚⚽️",
    footy_master_commentary_poor: "大丈夫です！マスターへの道はいつも険しいものです！🏃‍♂️🌟",
    footy_master_seo_title: "FOOTY MASTER - グローバルサッカークイズゲーム",
    footy_master_seo_description: "あなたのサッカー知識を披露しましょう！ワールドカップ、EPL、ラ・リーガ、CLなど、様々なサッカートリビアクイズを解いてポイントを獲得し、フーティーマスターを目指しましょう。",
    footy_master_seo_keywords: "フーティーマスター, サッカークイズ, サッカート리ビア, サッカーゲーム, ワールドカップクイズ, EPLクイズ, XLEVENゲーム",
    noCommentsYet: "まだコメントがありません",
    addAComment: "コメントを追加...",
    deleteCommentConfirm: "このコメントを削除しますか？",
    matchTalk: "試合トーク",
    phantomStadium: "ファントムスタジアム",
    matchAnalysis: "試合分析",
    noPostsFound: "投稿が見つかりません",
    beTheFirstToPost: "最初に投稿してみましょう！",
    noAnalysisFound: "分析が見つかりません",
    beTheFirstToAnalyze: "最初に分析してみましょう！",
    viewMore: "もっと見る",
    deleteConfirm: "削除の確認",
    deleteConfirmMessage: "本当に削除しますか？この操作は取り消せません。",
    viewReplies: "返信を表示",
    hideReplies: "返信を非表示",
    failedToLoadQuizzes: "クイズの読み込みに失敗しました",
    quizCreatedSuccessfully: "クイズが正常に作成されました",
    quizDeleted: "クイズが削除されました",
    deleteFailed: "削除に失敗しました",
    deleteSuccess: "正常に削除されました",
    reportSubmitted: "通報が送信されました",
    failedToDeductPoints: "ポイントの差し引きに失敗しました",
    failedToUpdatePassword: "パスワードの更新に失敗しました",
    failedToUpdateNickname: "ニックネームの更新に失敗しました",
    fileSizeUnder5MB: "ファイルサイズは5MB以下である必要があります",
    saveFailed: "保存に失敗しました",
    supportXlevenService: "XLEVENサービスサポート",
    copySuccess: "リンクがクリップボードにコピーされました",
    setFavoriteTeamFirst: "まずお気に入りチームに設定してください",
    aiTacticalInsight: "AI戦術インサイト",
    strategicAnalysisReport: "戦略分析レポート",
    winProbabilityDistribution: "勝率分布",
    aiConfidence: "AI信頼度",
    viewAll: "すべて表示",
    viewDetails: "詳細を見る",
    hotPost: "人気投稿",
    syncingActivities: "アクティビティを同期中...",
    intelligenceReport: "インテリジェンスレポート",
    matchIntel: "試合インテル",
    koreanFeed: "韓国語フィード",
    englishFeed: "英語フィード",
    maxLeaguesReached: "最大10リーグまで選択できます",
    maxLeaguesReachedGuest: "非会員は最大3リーグまで選択できます",
  },
  es: {
    popularFavoriteTeams: 'Equipos favoritos populares',
    stadiumPostTitle: "Publicar en el Estadio",
    stadiumPostPlaceholder: "Comparte tus pensamientos con otros fans de este equipo.",
    injuryList: "Lesionados",
    injuryReason_Injury: "Lesión",
    injuryReason_RedCard: "Tarjeta Roja",
    injuryReason_Internationalduty: "Convocatoria Internacional",
    injuryReason_YellowCards: "Tarjetas Amarillas",
    injuryReason_LowerBackInjury: "Lesión lumbar",
    injuryReason_ChestInjury: "Lesión en el pecho",
    injuryReason_Jumpersknee: "Rodilla de saltador",
    injuryReason_ToeInjury: "Lesión en el dedo del pie",
    injuryReason_Inactive: "Inactivo",
    injuryReason_KneeInjury: "Lesión de rodilla",
    injuryReason_AnkleInjury: "Lesión de tobillo",
    injuryReason_HamstringInjury: "Lesión de isquiotibiales",
    injuryReason_ThighInjury: "Lesión de muslo",
    injuryReason_CalfInjury: "Lesión de pantorrilla",
    injuryReason_GroinInjury: "Lesión de ingle",
    injuryReason_MuscleInjury: "Lesión muscular",
    injuryReason_FootInjury: "Lesión de pie",
    injuryReason_LegInjury: "Lesión de pierna",
    injuryReason_BrokenLeg: "Pierna rota",
    injuryReason_ACLInjury: "Lesión de ligamento cruzado anterior",
    injuryReason_MCLInjury: "Lesión de ligamento lateral interno",
    injuryReason_ShoulderInjury: "Lesión de hombro",
    injuryReason_BackInjury: "Lesión de espalda",
    injuryReason_HipInjury: "Lesión de cadera",
    injuryReason_HeadInjury: "Lesión en la cabeza",
    injuryReason_Concussion: "Conmoción cerebral",
    injuryReason_WristInjury: "Lesión de muñeca",
    injuryReason_HandInjury: "Lesión de mano",
    injuryReason_BrokenHand: "Mano rota",
    injuryReason_BrokenArm: "Brazo roto",
    injuryReason_ArmInjury: "Lesión de brazo",
    injuryReason_Sick: "Enfermedad",
    injuryReason_Illness: "Enfermedad",
    injuryReason_Fever: "Fiebre",
    injuryReason_Virus: "Virus",
    injuryReason_Infection: "Infección",
    injuryReason_Knock: "Golpe",
    injuryReason_Bruise: "Contusión",
    injuryReason_Strain: "Distensión",
    injuryReason_Sprain: "Esguince",
    injuryReason_Tear: "Desgarro",
    injuryReason_Surgery: "Cirugía",
    injuryReason_PhysicalCondition: "Condición física",
    injuryReason_Rest: "Descanso",
    injuryReason_PersonalReasons: "Motivos personales",
    injuryReason_Suspended: "Suspendido",
    injuryReason_Doubtful: "Duda",
    injuryReason_Achillestendonproblems: "Problemas en el tendón de Aquiles",
    injuryReason_fitness: "Estado físico",
    injuryReason_Injurytotheankle: "Lesión de tobillo",
    injuryReason_injured: "Lesionado",
    injuryReason_InjuredDoubtful: "Lesionado / Duda",
    injuryReason_Suspension: "Suspensión",
    injuryReason_RedcardSuspended: "Suspendido por tarjeta roja",
    injuryReason_Muscularproblems: "Problemas musculares",
    injuryReason_Thighproblems: "Problemas en el muslo",
    injuryReason_KneeSurgery: "Cirugía de rodilla",
    injuryReason_Outerligamenttear: "Desgarro del ligamento externo",
    injuryReason_Kneeinjury: "Lesión de rodilla",
    injuryReason_Rupturedcruciateligament: "Rotura del ligamento cruzado",
    injuryReason_FracturedFinger: "Fractura de dedo",
    injuryReason_Sprainedankle: "Esguince de tobillo",
    injuryReason_UnknownInjury: "Lesión desconocida",
    sponsorshipTitle: "Apoya a XLEVEN",
    sponsorshipDesc: "Ayúdanos a seguir brindando los análisis de IA y las perspectivas de fútbol más rápidas. ¡Tu apoyo marca la diferencia!",
    supportSmallCoffee: "Invítanos a un café",
    qrDonation: "Donación QR",
    qrDonationDesc: "Escanea para apoyar mediante transferencia directa",
    sponsorshipWhy: "¿Por qué apoyarnos?",
    sponsorshipWhyDesc: "Sus contribuciones ayudan a cubrir los costos del servidor y las tarifas de la API, lo que nos permite seguir desarrollando funciones innovadoras para la comunidad del fútbol.",
    magazineArchive: "Archivo",
    magazineCollection: "Colección",
    magazineDiscover: "Descubre el",
    magazineDeepStories: "Historias Profundas",
    magazineHeroDesc: "Perspectivas de fútbol seleccionadas, entrevistas exclusivas y obras maestras tácticas.",
    notices: "Avisos",
    noNotices: "No se encontraron avisos",
    noNoticesDesc: "Te notificaremos cuando haya nuevas actualizaciones",
    allLeagues: "Todas las Ligas",
    home: "Inicio",
    news: "Feed",
    player: "Jugador",
    games: "Partidos",
    shorts: "Shorts",
    settings: "Ajustes",
    mypage: "Mi Página",
    gamestore: "Juegos",
    recommendedForYou: "Feed Reciente",
    latestTransferNews: "Movimientos del Mercado",
    helpCenter: "Centro de Ayuda",
    contactUs: "Contáctanos",
    privacyPolicy: "Política de Privacidad",
    termsOfService: "Términos de Servicio",
    aboutUs: "Sobre Nosotros",
    aboutXleven: "Sobre XLEVEN",
    aboutXlevenDesc: "XLEVEN proporciona las noticias de fútbol más rápidas utilizando tecnología de IA. Experimenta noticias en tiempo real, rumores de transferencias y predicciones basadas en datos.",
    sponsorship: "Patrocinio",
    marketWatch: "Mercado",
    topTransfers: "Principales Transferencias",
    latestHeadlines: "Últimos Titulares",
    verifiedSources: "Fuentes Verificadas",
    stats: "Estadísticas",
    playingCareer: "Carrera",
    fanZone: "Zona de Fans",
    trendingTopic: "Tema de Tendencia",
    analyze: "Generar Predicción de Transferencia",
    analyzing: "Analizando estadísticas...",
    undisclosed: "No revelado",
    unknown: "Desconocido",
    noTransfers: "No se encontraron transferencias para",
    comingSoon: "Próximamente en v2.0",
    language: "Idioma",
    selectLanguage: "Seleccionar Idioma",
    clearCache: "Borrar Caché",
    cacheCleared: "Caché borrada",
    all: "Todo",
    global: "Global",
    epl: "EPL",
    laliga: "La Liga",
    seriea: "Serie A",
    bundesliga: "Bundesliga",
    ligue1: "Ligue 1",
    uefa: "UEFA",
    live: "En Vivo",
    replay: "Repetición",
    latest: "Último",
    worldCup: "Copa del Mundo",
    leagues: "Ligas",
    weeklyMagazine: "Revista",
    magazine: "Revista",
    read: "leído",
    welcome: "Bienvenido de nuevo",
    enterCredentials: "Por favor, introduce tus datos para iniciar sesión.",
    continueWithGoogle: "Continuar con Google",
    continueWithKakao: "Continuar con Kakao",
    continueWithNaver: "Continuar con Naver",
    or: "O",
    emailAddress: "Correo Electrónico",
    password: "Contraseña",
    signInAccount: "Iniciar Sesión",
    noAccount: "¿Aún no tienes cuenta?",
    createAccount: "Crear Cuenta",
    fullName: "Nombre Completo",
    confirmPassword: "Confirmar Contraseña",
    startExploration: "Empezar Exploración",
    joinNow: "Únete Ahora",
    recentActivity: "Actividad Reciente",
    recentActivityDesc: "Historial de transferencias vistas",
    followedPlayers: "Jugadores Seguidos",
    followedPlayersDesc: "Gestiona tu lista de seguimiento",
    favoriteClubs: "Clubes Favoritos",
    favoriteClubsDesc: "Actualizaciones y notificaciones de equipos",
    pushNotifications: "Notificaciones Push",
    pushNotificationsDesc: "Alertas de mercado en tiempo real",
    darkMode: "Modo Oscuro",
    supportLegal: "Soporte y Legal",
    storagePrivacy: "Almacenamiento y Privacidad",
    storagePrivacyDesc: "Liberar espacio de almacenamiento local",
    logOutAccount: "Cerrar Sesión",
    verifiedProfile: "Perfil Verificado",
    proMember: "Miembro Pro",
    activity: "Actividad",
    applicationSettings: "Ajustes de la Aplicación",
    back: "Atrás",
    forgotPassword: "¿Olvidaste tu contraseña?",
    secureSSL: "SSL Seguro",
    alreadyMember: "¿Ya eres miembro?",
    signIn: "Iniciar Sesión",
    authenticating: "Autenticando...",
    securingData: "Asegurando Datos...",
    accessGranted: "¡Acceso Concedido!",
    scoutingProfileSync: "Tu perfil de scouting ha sido asegurado con éxito.",
    dataLinkActive: "Enlace de Datos Activo",
    redirecting: "Redirigiendo al Panel...",
    editNickname: "Editar Apodo",
    save: "Guardar",
    cancel: "Cancelar",
    nicknameError: "El apodo debe tener entre 2 y 20 caracteres.",
    favoriteLeagues: "Ligas Favoritas",
    favoriteLeaguesDesc: "Tus categorías de partidos seguidas",
    manageLeagues: "Elegir Ligas Favoritas",
    saveChanges: "Guardar Cambios",
    selectLeaguesToFollow: "Selecciona las ligas que quieres seguir",
    syncSuccess: "Preferencias sincronizadas con éxito",
    today: "Hoy",
    dailyAttendance: "Asistencia Diaria",
    reasonWelcomePoints: "Puntos de bienvenida",
    last7Days: "Últimos 7 Días",
    last30Days: "Últimos 30 Días",
    allTime: "Todo el Tiempo",
    activityStats: "Clasificación y Estadísticas",
    totalInteractions: "Interacciones Totales",
    loadingLeagues: "Cargando ligas...",
    following: "Siguiendo",
    views: "Vistas",
    comments: "Comentarios",
    discussionHub: "Centro de Discusión",
    syncingHub: "Sincronizando...",
    firstIntelligenceReport: "Publica tu primer comentario",
    relatedIntelligence: "Noticias Relacionadas",
    relatedNews: "Noticias Relacionadas",
    reply: "Responder",
    report: "Reportar",
    delete: "Eliminar",
    replyingTo: "Respondiendo a",
    typeIntelligenceUpdate: "Escribe una actualización...",
    establishReport: "Establecer informe...",
    unauthorizedLogin: "No autorizado. Inicia sesión.",
    deleteCommentTitle: "¿Eliminar comentario?",
    loginRequiredTitle: "Inicia sesión ahora y únete a la acción",
    signInLabel: "Iniciar Sesión",
    changingLanguage: "Actualizando Idioma...",
    intelligenceAudio: "Informe de Voz IA",
    mergeFailed: "Error al combinar",
    keyBriefing: "Resumen Clave",
    loadingIntelligence: "Cargando página...",
    articleNotFound: "Artículo no encontrado",
    goBack: "Volver",
    joinConversation: "Únete a la conversación...",
    loginParticipate: "Inicia sesión para participar",
    leagueSelectionDescLoggedIn: "Selecciona ligas. Tus opciones se sincronizan con tu cuenta.",
    leagueSelectionDescGuest: "Selecciona ligas. Las sesiones de invitado expiran en 3 min.",
    leagueStage: "Fase de Liga",
    knockoutStage: "Fase de Eliminatorias",
    scenariosTab: "Escenarios",
    syncSelectedFeed: "Sincronizar Feed Seleccionado",
    selectAtLeastOneLeague: "Por favor, selecciona al menos una liga.",
    syncFailedTryAgain: "Error al sincronizar. Por favor, intenta de nuevo.",
    yourLeagues: "tus ligas",
    edit: "Editar",
    loadMore: "Cargar más",
    latestMovements: "Últimos Movimientos",
    syncingMarketIntel: "Sincronizando datos...",
    loadingNewsFeed: "Organizando tu Feed...",
    analyzingTalent: "Analizando datos...",
    syncingFixtures: "Sincronizando Calendario...",
    syncingMatchDetail: "Sincronizando Información...",
    curatingShorts: "Organizando Highlights...",
    postingComment: "Publicando Comentario...",
    searchingFor: "Buscando",
    matchStats: "Estadísticas",
    lineUp: "Alineación",
    timeline: "Cronología",
    talk: "Chat",
    matchHighlights: "Highlights del Partido",
    latestTeamNews: "Últimas Noticias del Equipo",
    close: "Cerrar",
    fullTime: "Final",
    startingXI: "Once Inicial",
    substitutes: "Suplentes",
    injuries: "Jugadores Lesionados",
    coach: "Entrenador",
    ownGoal: "Autogol",
    waitingKickoff: "Esperando el inicio",
    matchStarted: "Partido Iniciado",
    lineupAnnouncement: "Alineaciones 60 min antes del inicio",
    noStatsSynced: "Sin estadísticas",
    post: "Publicar",
    discoverMore: "Descubrir más",
    shareSuccess: "Enlace copiado al portapapeles",
    consultingGrid: "Consultando datos...",
    matchesFound: "Partidos Encontrados",
    zeroIntel: "Sin Información",
    refineSearch: "Refina tus parámetros de búsqueda",
    awaitingPersonnel: "Esperando identificación",
    scanningFrequency: "Escaneando frecuencia",
    searchNewsPlaceholder: "Buscar noticias",
    searchAllLeagues: "Buscar ligas",
    searchPlayerPlaceholder: "Buscar (usa inglés)",
    searchGamePlaceholder: "Buscar partidos...",
    searchShortsPlaceholder: "Buscar highlights...",
    deleteAccount: "Eliminar Cuenta",
    deleteAccountConfirm: "¿Seguro que quieres eliminar tu cuenta? Esta acción borrará todos tus datos permanentemente.",
    confirm: "Confirmar",
    yes: "Sí",
    no: "No",
    closingAccount: "Cerrando Cuenta...",
    joined: "Unido",
    agentTools: "Herramientas de Agente",
    supportInfo: "Soporte e Info",
    accountActions: "Acciones de Cuenta",
    marketHotspots: "Tendencias del Mercado",
    trendingIntel: "Tema Candente",
    squadBuilderTitle: "Alineación Esperada",
    squadBuilderSub: "Simulador Táctico",
    forwards: "Delanteros",
    midfielders: "Mediocampistas",
    defenders: "Defensas",
    goalkeepers: "Porteros",
    selectPersonnel: "Seleccionar Personal",
    personnelFound: "No se encontró personal coincidente",
    selectFormation: "Seleccionar Formación",
    searchingSector: "Buscando...",
    move: "Mover",
    clear: "Limpiar",
    squadTheme: "Tema del Campo",
    themeGrass: "Césped Fresco",
    themeBlueprint: "Plano Táctico",
    themeStealth: "Sigilo Nocturno",
    themePremium: "Oro Premium",
    themeGlass: "Glass Morph",
    themePaper: "Papel Clásico",
    themeCyber: "Red Cibernética",
    themeRetroMud: "Barro Retro",
    themeNeonFuture: "Futuro Neón",
    ftResult: "Resultado Final",
    scheduled: "Programado",
    stadiumCap: "Cap.",
    syncingIntel: "Sincronizando...",
    standings: "Posiciones",
    scorers: "Goleadores",
    assists: "Asistencias",
    assistsFor: "Asistencias",
    managerialCareer: "Carrera de Entrenador",
    singleMatchPerformance: "Rendimiento del Partido",
    seasonIntelPerformance: "Rendimiento de Temporada",
    retrievingIntel: "Recuperando...",
    saveImage: "Guardar Imagen",
    shareToFeed: "Compartir",
    aiMatchPrediction: "Inteligencia Táctica IA",
    simulatingScenarios: "Ejecutando Simulación...",
    runSimulation: "Generar Informe",
    predictedWinner: "Dominio Esperado",
    expectedScore: "Resultado Proyectado",
    tacticalInsight: "Razón del Análisis",
    aiSimulationDesc: "Scouts IA simulan partidos basados en forma actual, estadísticas y datos tácticos.",
    noSectorActivity: "Sin Actividad",
    noSectorActivityDesc: "Sin partidos programados para hoy.",
    season2526: "Temporada 25/26",
    momentumEfficiency: "Impulso y Eficiencia",
    avgGoals: "Promedio de Goles",
    perMatch: "por partido",
    goalBalance: "Balance de Goles",
    goalsFor: "Goles a Favor",
    goalsAgainst: "Goles en Contra",
    offensiveDominance: "Dominio Ofensivo",
    defensiveLeakage: "Fuga Defensiva",
    teamDNAIndices: "Índices ADN del Equipo",
    matchOutcomeDistribution: "Distribución de Resultados",
    cleanSheets: "Porterías a Cero",
    failedToScore: "Sin Anotar",
    scoredPenalties: "Penaltis Anotados",
    missedPenalties: "Penaltis Fallados",
    bigWins: "Grandes Victorias",
    toughLosses: "Derrotas Duras",
    noVerifiedTransfers: "Sin movimientos de mercado en los últimos 12 meses",
    reportTitle: "Reportar Comentario",
    reportDesc: "Selecciona una razón",
    reportReasonSpam: "Spam o engañoso",
    reportReasonHarassment: "Acoso o discurso de odio",
    reportReasonInappropriate: "Contenido inapropiado",
    reportReasonViolence: "Violencia o daño",
    reportReasonOther: "Otro",
    reportOtherPlaceholder: "Por favor especifica...",
    submitReport: "Enviar Reporte",
    maintenanceTitle: "Refrescando Sistema",
    maintenanceDesc: "Volveremos pronto con nuevos highlights.\nGracias por tu paciencia.",
    maintenanceUntil: "Reanudación a las 09:00 KST (00:00 UTC)",
    shareIntelligence: "Escribir en el Feed",
    whatsHappening: "¿Qué está pasando en el fútbol?",
    postSuccess: "Feed compartido con éxito",
    uploadingIntel: "Subiendo...",
    addLink: "Añadir Enlace",
    linkPlaceholder: "Pega el enlace aquí (ej. https://...)",
    linkValidationError: "El enlace debe empezar por https://",
    urlRestricted: "Acceso restringido por el dueño del sitio.",
    urlPaywall: "Este artículo puede requerir suscripción.",
    urlDynamicWarning: "Sitio complejo. Análisis limitado.",
    aiAnalyzing: "Analizando...",
    aiWaitNote: "Suele tardar entre 20 y 40 segundos.",
    scoutingStatus1: "Contactando red de scouts...",
    scoutingStatus2: "Cruzando valores de mercado...",
    scoutingStatus3: "Sintetizando tácticas...",
    scoutingStatus4: "Finalizando informe...",
    aiTimeout: "Análisis tardío (más de 60s). Reintenta o revisa el enlace.",
    aiNotFootball: "Por favor cuéntanos noticias de fútbol.",
    aiDraftTitle: "Borrador IA",
    aiDraftSubtitle: "Listo para tu feed",
    extractedTitle: "Título Extraído",
    generatedContent: "Contenido Generado",
    aiDraftDisclaimer: "Referencia. 'Aplicar' para editar y publicar.",
    applyToEditor: "Aplicar al Editor",
    imageSourceLabel: "Fuente",
    selectionDone: "Hecho",
    inquiryHistory: "Historial de Consultas",
    emailSupport: "Soporte por Email",
    myHistory: "Mi Historial",
    newInquiry: "Nueva Consulta",
    noInquiryHistory: "Sin historial de consultas.",
    completed: "Completado",
    response: "Respuesta",
    inquiryGeneral: "General",
    inquiryAccount: "Cuenta/Login",
    inquiryContent: "Contenido/Corrección",
    inquiryError: "Error",
    inquirySuggestion: "Sugerencia",
    clearLocalStorage: "Borrar Almacenamiento Local",
    clearLocalStorageConfirm: "¿Seguro que quieres borrar los datos locales excepto info de usuario? Se resetearán tus preferencias.",
    attendance: "Asistencia",
    attendanceDesc: "Obtén bonos diarios",
    favoriteTeams: "Equipos Favoritos",
    favoriteTeamsDesc: "Equipos que sigo",
    matchPredictions: "Predicciones de Partidos",
    matchPredictionsDesc: "AI가 분석한 나의 경기 예측 리포트",
    pointHistoryTitle: "Mi Historial de Puntos",
    pointHistorySub: "Revisa tus ganancias y uso",
    english: "Inglés (UK)",
    korean: "Coreano (KR)",
    clearingData: "Borrando datos...",
    logoutConfirm: "¿Seguro que quieres cerrar sesión?",
    teamDetails: "Detalles del Equipo",
    teamNotFound: "Info de equipo no encontrada.",
    homeStadium: "Estadio Local",
    recentMatches: "Partidos Recientes",
    squad: "Plantilla",
    goalkeeper: "Portero",
    defender: "Defensa",
    midfielder: "Mediocampista",
    attacker: "Atacante",
    languageSaveSuccess: "Ajustes de idioma guardados.",
    languageAiNote: "Resúmenes y análisis IA se darán en el idioma elegido.",
    "Shots on Goal": "Tiros a Puerta",
    "Shots off Goal": "Tiros Fuera",
    "Total Shots": "Tiros Totales",
    "Blocked Shots": "Tiros Bloqueados",
    "Shots insidebox": "Tiros dentro del área",
    "Shots outsidebox": "Tiros fuera del área",
    "Fouls": "Faltas",
    "Corner Kicks": "Córners",
    "Offsides": "Fueras de Juego",
    "Ball Possession": "Posesión",
    "Yellow Cards": "Tarjetas Amarillas",
    "Red Cards": "Tarjetas Rojas",
    "Goalkeeper Saves": "Paradas",
    "Total passes": "Pases Totales",
    "Passes accurate": "Pases Precisos",
    "Passes %": "Pases %",
    "Expected Goals": "Goles Esperados (xG)",
    expected_goals: "Goles Esperados (xG)",
    goals_prevented: "Goles Evitados",
    noIntelTitle: "Feed Vacío",
    noIntelDesc: "Sin noticias para esta fecha.",
    noSectorIntel: "Información no disponible",
    noContentFound: "Contenido no encontrado",
    performanceHistory: "Rendimiento por Temporada",
    detailedSeasonBreakdown: "Desglose Detallado",
    recentForm: "Forma Reciente",
    noContentDesc: "No hay datos para mostrar en este momento. ¿Te gustaría consultar otros menús?",
    unlockFullIntel: "Desbloquear información completa",
    careerIntelNotAvailable: "Info de carrera no disponible",
    transferHistory: "Historial de Transferencias",
    freeAgent: "Agente Libre",
    capturingImage: "Capturando imagen 3D...",
    classicGround: "Campo Clásico",
    realStadium: "Estadio Real",
    imageUploadFailed: "Fallo al subir imagen.",
    captureFailed: "Fallo al capturar.",
    noFavoriteTeams: "Sin Equipos Favoritos",
    noFavoriteTeamsDesc: "Toca el corazón en detalles del partido para añadir equipos.",
    removeFavoriteTeam: "Eliminar Favorito",
    removeFavoriteTeamConfirm: "¿Seguro que quieres eliminar este equipo?",
    setDefaultTeamTitle: "¿Establecer equipo por defecto?",
    setDefaultTeamDesc: "¿Quieres poner este equipo como principal? Solo puede haber uno.",
    defaultTeam: "Equipo por Defecto",
    selectDefaultTeam: "Seleccionar como principal",
    contactSupport: "Soporte 1:1",
    contactSupportDesc: "Contacta con XLEVEN para dudas o problemas.",
    mySupportHistory: "Mi Historial de Soporte",
    mySupportHistoryDesc: "Revisa tus consultas y respuestas.",
    myPageDesc: "Gestiona tu perfil, asistencia, puntos e informes IA en tu página de XLEVEN.",
    attendanceDescSEO: "Regístrate cada día y gana puntos extra.",
    pointHistoryDescSEO: "Revisa tu historial de puntos.",
    playerAge: "Edad",
    playerHeight: "Altura",
    playerWeight: "Peso",
    matchPredictionsDescSEO: "Consulta tus datos de predicción de partidos y informes tácticos analizados por la IA.",
    recentActivityDescSEO: "Revisa tus comentarios y actividad.",
    favoriteLeaguesDescSEO: "Selecciona ligas y recibe información personalizada.",
    favoriteTeamsDescSEO: "Revisa tu lista de equipos seguidos.",
    languageDescSEO: "Cambia el idioma del servicio.",
    allMatchFixturesSeoTitle: "Calendario Completo",
    allMatchFixturesSeoDesc: "Resultados, calendarios y marcadores de las grandes ligas.",
    leagueMatchFixturesSeoTitle: "Calendario de Partidos",
    leagueMatchFixturesSeoDesc: "Resultados, calendarios y marcadores de {{leagueName}}.",
    noticeUpdate: "Actualización de Aviso",
    checkNow: "Revisar Ahora",
    loading: "Cargando...",
    loadingMore: "Cargando más...",
    noPredictionsYet: "Sin predicciones aún",
    analyzeMatchesDesc: "Analiza partidos y recibe informes IA.",
    exploreMatches: "Ir a la lista de partidos",
    predictionAccuracy: "Precisión",
    analysisStatistics: "Estadísticas de Análisis",
    totalAnalysis: "Análisis Totales",
    searchByTeam: "Buscar por equipo...",
    lastWeek: "Última semana",
    lastMonth: "Último mes",
    myAiTacticalReports: "Mis Informes IA",
    formation: "Formación",
    theme: "Tema",
    swapTip: "Arrastra para mover",
    squadAnalysis: "Análisis de Plantilla",
    newsTitle: "Título",
    translateToEn: "Traducir al Inglés",
    translateToKo: "Traducir al Coreano",
    translating: "Traduciendo...",
    addSource: "Añadir Fuente",
    sourcePlaceholder: "Nombre de fuente (ej. bbc)",
    apiAndCopyright: "Info de API y Copyright",
    noMajorGamesToday: "Sin grandes partidos programados hoy en tus ligas.",
    adminTools: "Herramientas de Admin",
    adminControlCenter: "Centro de Control Admin",
    adminControlCenterDesc: "Gestiona usuarios, posts y protocolos",
    addFavoriteLeaguesTitle: "Sigue tus Ligas",
    addFavoriteLeaguesDesc: "Elige ligas para tener marcadores e info personalizada en tu inicio.",
    setupNow: "Configurar Ahora",
    addFavoriteLeaguesButton: "Añadir Ligas",
    deleteFeedConfirm: "¿Seguro que quieres borrar este post? No se puede deshacer.",
    reportFeedTitle: "Reportar Post",
    editFeed: "Editar Feed",
    deleteFeed: "Borrar Feed",
    reportFeed: "Reportar Feed",
    alreadyReported: "Ya has reportado este contenido.",
    reportCompleted: "Reporte enviado con éxito.",
    externalSourceReportError: "No se pueden reportar fuentes externas directamente.",
    postDeletedSuccess: "Feed borrado con éxito",
    scanningSectorData: "Escaneando Datos...",
    searchResults: "Resultados",
    analysisFailed: "Fallo en el análisis",
    feedPostPointEarned: "¡Feed publicado! +{{amount}}P ganados",
    failedToPostNews: "Fallo al publicar feed",
    feedDeletePointDeducted: "10P deducidos por borrar feed.",
    failedToDelete: "Fallo al borrar",
    seoDefaultDescription: "Noticias de fútbol, rumores, highlights y análisis IA. Premier, La Liga, Champions y más en XLEVEN.",
    seoDefaultKeywords: "fútbol, noticias, fichajes, marcadores, análisis, Premier League, La Liga, Champions League, IA",
    seoHomeTitle: "Noticias de Fútbol y Rumores - Análisis IA",
    topTransfersSeoDesc: "Análisis de los mayores fichajes de la historia.",
    latestMovementsSeoDesc: "Estado de fichajes y anuncios oficiales en tiempo real.",
    playerDetailSeoDesc: "Datos, estadísticas, historial y forma de {{playerName}}.",
    playerDetailSeoTitle: "{{playerName}} - {{position}} ({{team}})",
    synchronizingIntelligence: "Sincronizando...",
    summer: "Verano",
    winter: "Invierno",
    dataProvidedBy: "Datos por",
    leagueHighlightsSeoDesc: "Highlights de {{leagueName}}.",
    matches: "Partidos",
    awaitingMarketIntel: "Esperando info de mercado...",
    scanningSectorIntel: "Escaneando sector...",
    noticeTitle: "Actualización XLEVEN",
    noticeBody: "Motor Gemini 2.5 IA activo. Informes de scouting y predicciones mejoradas.",
    dontShowToday: "No mostrar hoy",
    emailRequired: "Introduce tu email",
    resetFailed: "Fallo al enviar enlace",
    resendFailed: "Fallo al reanudar envío",
    emailNotConfirmedMsg: "Verifica tu email. Mira tu bandeja de entrada.",
    resendSuccess: "Envío con éxito",
    resendAction: "Reenviar Verificación",
    invalidCredentials: "Email o contraseña inválidos.",
    tooManyRequests: "Demasiadas peticiones. Reintenta luego.",
    fixtures: "Calendario",
    activeSource: "Liga Seleccionada",
    updateSectors: "Actualizar Ligas",
    configureIntelSources: "Configura tus ligas",
    searchingGlobalDatabase: "Buscando...",
    noMatchingSectors: "Sin sectores coincidentes",
    majorLeagues: "Grandes Ligas",
    majorCups: "Grandes Copas",
    addedSectors: "Sectores Añadidos",
    goToToday: "Ir a Hoy",
    scanningGrid: "Escaneando...",
    rating: "Nota",
    goals: "Goles",
    passPercentage: "Pases %",
    dribbles: "Regates",
    defense: "Defensa",
    captain: "Capitán",
    injured: "Lesionado",
    club: "Club",
    played: "PJ",
    points: "Pts",
    goalDiff: "DG",
    win: "G",
    draw: "E",
    loss: "P",
    ucl: "UCL",
    uel: "UEL",
    rel: "DESC",
    noConcludedMatches: "Sin partidos finalizados",
    loadingRecords: "Cargando...",
    from: "de",
    to: "a",
    transfer: "Fichaje",
    openOriginal: "Abrir original",
    refreshLiveData: "Rafraîchir Datos",
    syncingMatchIntelDesc: "Sincronizando...",
    newPassword: "Nueva Contraseña",
    updatePassword: "Actualizar Contraseña",
    passwordChanged: "¡Contraseña Cambiada!",
    passwordChangedDesc: "Tu contraseña ha sido actualizada.",
    passwordMinLength: "Mín 8 caracteres",
    passwordLetters: "Incluye letras",
    passwordNumbers: "Incluye números",
    passwordSpecial: "Incluye símbolos",
    passwordMatch: "Coinciden",
    passwordSameAsOld: "Debe ser diferente a la anterior",
    resetIntel: "Resetear Contraseña",
    verifyIdentity: "Verifica tu identidad",
    accountEmail: "Email de Cuenta",
    enterRegisteredEmail: "Email registrado",
    authorizeReset: "Autorizar Reset",
    backToEntry: "Volver",
    nicknameUpdated: "Apodo actualizado.",
    profileImageUpdated: "Foto de perfil actualizada.",
    backgroundImageUpdated: "Portada actualizada.",
    uploadFailed: "Fallo al subir. Reintenta.",
    fileSizeError: "Archivo muy grande. Máx 5MB.",
    pointHistory: "Puntos",
    pointGuide: "Info de Puntos",
    pointGuideDesc: "Puntos por actividad. Se usarán para servicios futuros.",
    noPointHistory: "Sin historial de puntos.",
    loadingPointHistory: "Cargando...",
    gatheringIntel: "Recopilando...",
    syncingPointHistory: "Sincronizando...",
    reasonDailyAttendance: "Asistencia Diaria",
    reason7DayBonus: "Bono 7 Días",
    reasonNewsPost: "Post de Feed",
    reasonNewsDelete: "Borrado de Feed",
    reasonCommentPost: "Comentario",
    reasonCommentDelete: "Borrado de Comentario",
    reasonAiReport: "Informe IA",
    reasonRegularEarn: "Ganancia Regular",
    reasonAdminSpecialReward: "Premio Especial Admin",
    reasonNeonPitch: "Jugar Juego: NEON PITCH",
    reasonTripleBetMultiple: "Triple Bet Selección Múltiple",
    reasonTripleBetAi: "Triple Bet Análisis IA",
    reasonFootyMaster: "Jugar Juego: FOOTY MASTER",
    pointEarned: "¡Puntos ganados!",
    pointDeducted: "Puntos deducidos.",
    commentPosted: "¡Comentario publicado!",
    commentDeleted: "Comentario borrado.",
    feedPosted: "¡Feed publicado!",
    feedDeleted: "Feed borrado.",
    attendanceComplete: "¡Asistencia completada!",
    firstLoginToday: "¡Primer login de hoy!",
    deleteCancel: "Cancelar Borrado",
    deleteConfirmDesc: "No se puede deshacer. ¿Seguro?",
    editCancel: "Cancelar Edición",
    editCancelDesc: "No se guardará. ¿Seguro que quieres salir?",
    postCancel: "Cancelar Publicación",
    postCancelDesc: "No se guardará. ¿Seguro que quieres salir?",
    errorLoadingImages: "Error al cargar imágenes.",
    errorProcessingAttendance: "Error en asistencia.",
    errorAnalysis: "Error en análisis.",
    errorReport: "Fallo al reportar.",
    errorDelete: "Fallo al borrar.",
    loginRequired: "Login requerido.",
    enterTitleAndContent: "Introduce título y contenido.",
    inquirySubmitted: "Consulta enviada.",
    errorInquiry: "Fallo al enviar consulta.",
    category: "Categoría",
    title: "Título",
    content: "Contenido",
    inquiryPlaceholder: "Detalla tu consulta",
    titlePlaceholder: "Título de consulta",
    inquiryNote: "Responderemos pronto. Los findes puede tardar.",
    submitInquiry: "Enviar Consulta",
    attendanceStreak: "Racha de Asistencia",
    attendanceNote: "Entra cada día para mejores premios",
    attendanceCompleted: "Asistencia Hecha",
    checkAttendanceNow: "Hacer Asistencia",
    weeklyProgress: "Progreso Semanal",
    baseReward: "Premio Base",
    streakBonus: "Bono Racha",
    attendanceResetNote: "Resetea a medianoche (00:00).",
    present: "Presente",
    frame: "Marco",
    searchPlaceholder: "Buscar por razón, reportero...",
    playerAndTransferManagement: "Gestión de Jugadores",
    playerManagementDesc: "Datos de mercado y grupos",
    latestTransfers: "Últimos Fichajes",
    groupList: "Lista de Grupos",
    playerSearchPlaceholder: "Buscar jugador o club...",
    addItem: "Añadir Item",
    playerIntel: "Info de Jugador",
    movement: "Movimiento",
    valueFee: "Valor/Precio",
    noItemsFound: "Sin activos encontrados",
    createGroup: "Crear Grupo",
    editGroup: "Editar Grupo",
    addPersonnel: "Añadir Personal",
    editPersonnel: "Editar Personal",
    deleteItem: "Borrar Item",
    deleteGroupConfirmDesc: "¿Borrar grupo? Se borrarán sus datos asociados.",
    deleteItemConfirmDesc: "¿Borrar este activo? No se puede deshacer.",
    systemSettingsDesc: "Motor central y políticas",
    awardPoints: "Dar Puntos",
    awardPointsDesc: "Dar puntos a este usuario.",
    award: "Dar",
    awardSuccess: "Puntos dados con éxito.",
    amount: "Cantidad",
    reason: "Razón",
    auditIntelligenceDesc: "Revisar feeds de la comunidad",
    auditReportsDesc: "Revisar reportes de incidentes",
    noResultsFound: "Sin resultados",
    noTrendingData: "Sin tendencias",
    pointDeduction: "Deducción de Puntos",
    insufficientPoints: "Puntos Insuficientes",
    rechargeRequired: "Recarga Necesaria",
    allMatchFixtures: "Todos los Partidos",
    leagueMatchFixtures: "Partidos de Liga",
    allMatchFixturesDesc: "Marcadores, calendarios y resultados.",
    playerStatsDesc: "Datos, estadísticas e historial.",
    newsFeedDesc: "Noticias y rumores por fecha.",
    shortsDesc: "Highlights y shorts sin cortes.",
    maintenanceResumes: "Reanudación 09:00 KST (00:00 UTC)",
    swipeGuide: "Desliza izq/der",
    swipeDateGuide: "para ver por fecha",
    apiInfoDesc1: "Datos de API-Sports (API-Football). Derechos de proveedores y ligas.",
    apiInfoDesc2: "Predicciones y resúmenes por Gemini IA. Solo referencia, sin efecto legal.",
    apiInfoDesc3: "Vídeos vía YouTube API. Derechos de los canales.",
    apiInfoDesc4: "Imágenes de BBC Sport y Pexels (Royalty-free).",
    apiInfoDesc5: "Logos y fotos de sus dueños originales.",
    apiInfoDesc6: "Uso para reporte y estadística. Sin reventa comercial.",
    apiSportsData: "API de Datos",
    apiAiIntelligence: "Análisis IA",
    apiMediaVideo: "Media y Vídeo",
    apiNewsAssets: "Assets de Noticias",
    apiBbcSource: "Fuentes BBC Sport",
    apiCopyrightDisclaimer: "Aviso de Copyright",
    privacyDesc1: "XLEVEN valora tu privacidad. Esta política explica qué recogemos.",
    privacySection1Title: "1. Datos Recogidos",
    privacySection1Desc: "No recogemos datos directamente. Solo auto-recogida por uso.",
    privacySection2Title: "2. Uso de Datos",
    privacySection2Desc: "Para mejora, análisis y anuncios.",
    privacySection3Title: "3. Cookies",
    privacySection3Desc1: "Usamos cookies para preferencias.",
    privacySection3Desc2: "Puedes desactivarlas en tu navegador.",
    privacySection4Title: "4. Google AdSense",
    privacySection4Desc1: "Usamos anuncios de terceros.",
    privacySection4Desc2: "Google usa cookies para anuncios basados en visitas.",
    privacySection4Desc3: "Anuncios personalizados vía cookie DART.",
    privacySection4Desc4: "Desactívalos en ajustes de Google.",
    privacySection4Link: "Política Google",
    privacySection5Title: "5. Terceros",
    privacySection5Desc: "No vendemos datos. Solo por ley.",
    privacySection6Title: "6. Enlaces",
    privacySection6Desc: "No somos responsables de sitios externos.",
    privacyContactEmail: "Email",
    privacyContactSite: "Sitio",
    privacyEffectiveDate: "Efectiva: 20 Ene 2026",
    privacyItemIP: "IP",
    privacyItemBrowser: "Navegador",
    privacyItemDate: "Fecha/Hora",
    privacyItemPage: "Páginas",
    privacyItemCookie: "Cookies",
    privacyUsageStats: "Estadísticas",
    privacyUsageImprove: "Contenido y user exp.",
    privacyUsageAds: "Ads y optimización",
    privacySection5Desc1: "Usamos cookies para servicios y anuncios.",
    privacySection5Desc2: "Google usa cookies para servir anuncios.",
    privacySection5Desc3: "Puedes optar por no ver anuncios personalizados.",
    termsSection1Title: "Art 1 (Propósito)",
    termsSection1Desc: "Define condiciones de uso de XLEVEN.",
    termsSection2Title: "Art 2 (Definiciones)",
    termsSection2Desc: "1. Usuario: miembros y no miembros. 2. Contenido: noticias, datos, etc.",
    termsSection3Title: "Art 3 (Revisiones)",
    termsSection3Desc: "Podemos revisar términos vía avisos.",
    termsSection4Title: "Art 4 (Servicios)",
    termsSection4Desc: "Marcadores, news, IA y comunidad.",
    termsSection5Title: "Art 5 (Copyright)",
    termsSection5Desc: "1. Datos protegidos. 2. Sin uso comercial sin permiso.",
    termsSection6Title: "Art 6 (Anuncios)",
    termsSection6Desc: "Podemos poner anuncios para mantener el servicio.",
    copyFailed: "Fallo al copiar.",
    newsFeedSeoTitle: "Football Feed",
    newsFeedSeoDesc: "Check latest football news and real-time transfer rumors from major leagues around the world by date.",
    pexelsGallery: "Pexels Gallery",
    highFidelityAssets: "High fidelity football assets",
    tapToPlayWithSound: "Tap to Play with Sound",
    videoUnavailable: "This video is unavailable in your region or has been removed.",
    shortsPreparingTitle: "Preparing Shorts Videos",
    shortsPreparingDesc: "We are currently collecting the latest videos. Please check back shortly!",
    shortsSeoTitle: "Football Highlights & Shorts | XLEVEN",
    shortsSeoDesc: "Enjoy the hottest global football highlights and shorts videos seamlessly. Experience the best football moments recommended by AI.",
    gameStoreTitle: "Juegos de Fútbol",
    newGamePreparing: "Nuevos Juegos Próximamente",
    newGamePreparingDesc: "Pronto se lanzarán juegos de fútbol exclusivos de XLEVEN. ¡Mantente atento!",
    ranking: "Ranking",
    play: "Jugar",
    gameRanking: "Ranking del Juego",
    fetchingRankings: "Obteniendo Rankings...",
    noRankingsYet: "Sin rankings aún",
    preparing: "Preparing...",
    toto_history: "Historial de Predicciones",
    toto_submit: "Enviar",
    toto_check_predictions: "Ver Predicciones",
    toto_round_format: "Ronda {{n}}",
    toto_finished: "Finalizado",
    toto_in_progress: "En Progreso",
    toto_success_count: "Predicciones Correctas",
    toto_submitted_at: "Enviado el",
    toto_not_participated: "No participaste en esta ronda.",
    toto_detailed_results: "Resultados Detallados",
    toto_correct: "Correcto",
    toto_incorrect: "Incorrecto",
    toto_my_pick: "(Mi Elección)",
    toto_result: "(Resultado)",
    toto_win: "G",
    toto_draw: "E",
    toto_loss: "P",
    toto_ai_winner: "Winner",
    toto_ai_score: "Resultado",
    toto_ai_win_rate: "Probabilidad",
    toto_ai_tactical: "Análisis Táctico",
    toto_save_failed: "Error al guardar.",
    toto_predictions_status: "Estado de Predicciones",
    toto_view_analysis: "Ver Análisis",
    toto_ai_analysis: "Análisis IA",
    toto_predict_title: "Predice 14 partidos",
    toto_win_points: "¡y gana puntos!",
    toto_challenge_win: "Desafía y Gana",
    toto_players_joined: "{{count}} jugadores unidos",
    toto_rules_title: "Reglas del Juego",
    toto_rules_policy: "Política del Juego TRIPLE BET",
    toto_rules_1: "Solo se puede seleccionar un resultado por partido.",
    toto_rules_2: "Gana 10 puntos y 10 de puntuación por cada predicción correcta.",
    toto_rules_3: "Deducción de 10p por análisis IA.",
    toto_rules_4: "Selección múltiple permitida hasta 20.",
    toto_rules_5: "Sin deducción hasta 14. Deducción en 15(10p), 16(20p), 17(30p). Total 210p por 20 selecciones.",
    toto_rules_6: "* Acceso limitado si los puntos son insuficientes.",
    toto_login_required: "Inicio de Sesión Requerido",
    toto_login_desc: "Por favor, inicia sesión para participar en el juego TOTO.",
    toto_login_button: "Iniciar Sesión Ahora",
    toto_no_round_title: "No hay rondas activas",
    toto_no_round_desc: "¡Una nueva ronda comenzará pronto. Por favor, espera!",
    toto_already_participated: "Ya has participado.",
    webtoonHeroTitle: "Fútbol y mucho más,",
    webtoonHeroTitleColor: "XLEVEN Webtoon",
    webtoonHeroDesc: "Series originales de webtoons de fútbol actualizadas semanalmente. Descubre historias especiales que no encontrarás en ningún otro lugar.",
    noWebtoons: "Aún no hay webtoons registrados.",
    webtoonSeoTitle: "Colección de Webtoons de Fútbol",
    webtoonSeoDesc: "Descubre los últimos webtoons de fútbol en XLEVEN. Disfruta de historias y series de fútbol originales actualizadas semanalmente.",
    toto_round_expired: "Esta ronda ha terminado.",
    toto_submit_expired: "La compra no está disponible ya que el plazo ha vencido.",
    toto_predict_all: "Por favor, predice todos los partidos.",
    toto_insufficient_points: "Puntos insuficientes. (Requerido: {{amount}}p)",
    toto_saved_with_deduction: "¡Guardado! ({{amount}}p deducidos)",
    toto_saved_success: "¡Guardado con éxito!",
    toto_ai_completed: "¡Análisis IA completado!",
    toto_ai_error: "Error durante el análisis.",
    toto_exit_title: "¿Salir del juego?",
    toto_exit_desc: "Tus predicciones no se guardarán.",
    toto_exit_confirm: "Salir",
    toto_exit_cancel: "Continuar",
    toto_seo_title: "Desafío Triple Apuesta - Juego de Predicción de Fútbol Semanal",
    toto_seo_description: "Predice los resultados de los partidos de fútbol de las ligas de todo el mundo actualizados cada semana y gana puntos. Aumenta tu probabilidad de ganar con datos de análisis de IA.",
    toto_seo_keywords: "Triple Apuesta, Predicción de Fútbol, Toto, XLEVEN, Apuestas Deportivas, Análisis de Fútbol",
    toto_result_seo_title: "Mi Historial de Triple Apuesta - Resultados de Predicción de Fútbol",
    toto_result_seo_description: "Consulta tus resultados de predicción de partidos de fútbol semanales y los puntos ganados. Analiza tu precisión con informes detallados.",
    toto_result_seo_keywords: "Resultados Triple Apuesta, Historial de Predicciones, Toto Fútbol, XLEVEN, Precisión de Partidos",
    neon_pitch_seo_title: "NEON PITCH - Juego de Arcade de Fútbol Retro",
    neon_pitch_seo_description: "Vive la emoción del arcade de fútbol retro. Controla el balón de neón, esquiva obstáculos y busca la puntuación más alta en NEON PITCH.",
    neon_pitch_seo_keywords: "Neon Pitch, Juego de Fútbol, Juego de Arcade, Fútbol Retro, Juegos XLEVEN, Juego HTML5",
    "neon_pitch_score": "Puntuación",
    "neon_pitch_best": "Mejor",
    "neon_pitch_time_left": "Tiempo Restante",
    "neon_pitch_streak": "¡Racha!",
    "neon_pitch_fever_unleashed": "¡FIEBRE DE GOLES ACTIVADA!",
    "neon_pitch_adrenaline_gauge": "Medidor de Adrenalina",
    "neon_pitch_instructions": "¡Consigue la mayor puntuación posible!",
    "neon_pitch_exit": "SALIR A LA TIENDA",
    "neon_pitch_full_time": "Final del Partido",
    "neon_pitch_total_score": "Puntuación Total",
    "neon_pitch_max_combo": "Combo Máximo",
    "neon_pitch_rematch": "JUGAR REVANCHA",
    "neon_pitch_deduction_toast": "10 Puntos Deducidos",
    "neon_pitch_kickoff": "SAQUE INICIAL",
    neon_pitch_insufficient_points: "Puntos insuficientes.",
    viewTranslation: "Ver traducción",
    viewOriginal: "Ver original",
    selectPostType: "Seleccionar tipo de publicación",
    overallStrength: "Fuerza General",
    attackPower: "Poder de Ataque",
    defensePower: "Poder de Defensa",
    winProbability: "Probabilidad de Ganar",
    strength: "Fuerza",
    attackingPotential: "Potencial de Ataque",
    defensivePotential: "Potencial de Defensa",
    poissonDistribution: "Distribución de Poisson",
    strengthH2h: "Fuerza H2H",
    goalsH2h: "Goles H2H",
    winsTheGame: "Gana el Juego",
    viewH2HDetail: "Ver detalles",
    footy_master_preparing_arena: "Preparando la Arena...",
    footy_master_trivia_quiz: "Trivia de Fútbol",
    footy_master_high_score: "Puntuación Máxima",
    footy_master_start_desc: "¡Demuestra tus conocimientos de fútbol y gana puntos!",
    footy_master_questions: "Preguntas",
    footy_master_random: "10 Aleatorias",
    footy_master_time_limit: "Tiempo Límite",
    footy_master_time_s_q: "15s / Preg",
    footy_master_get_started: "COMENZAR",
    footy_master_back_to_store: "Salida",
    footy_master_back_to_start: "Volver al Inicio",
    footy_master_question_n_of_m: "Pregunta {{n}} de {{m}}",
    footy_master_mission_complete: "Misión Completada",
    footy_master_total_score: "Puntuación Total",
    footy_master_accuracy: "Precisión",
    footy_master_play_again: "JUGAR DE NUEVO",
    footy_master_exit_to_store: "SALIR A LA TIENDA",
    footy_master_cat_worldcup: "Copa del Mundo",
    footy_master_cat_epl: "EPL",
    footy_master_cat_laliga: "La Liga",
    footy_master_cat_ucl: "UCL",
    footy_master_cat_kleague: "K-League",
    footy_master_commentary_perfect: "¡Perfecto! ¡Eres una enciclopedia de fútbol viviente! 🏆⚽️",
    footy_master_commentary_great: "¡Buen trabajo! ¡Casi eres un experto! 🔥👏",
    footy_master_commentary_good: "¡Nada mal! ¡Solo un poco más para ser un maestro! 💪✨",
    footy_master_commentary_average: "¡Quizás necesites estudiar un poco más! ¿Probamos de nuevo? 📚⚽️",
    footy_master_commentary_poor: "¡Está bien! ¡El camino para ser un maestro siempre es difícil! 🏃‍♂️🌟",
    footy_master_seo_title: "FOOTY MASTER - Juego de Trivia de Fútbol Global",
    footy_master_seo_description: "¡Demuestra tus conocimientos de fútbol! Resuelve trivias sobre la Copa del Mundo, EPL, La Liga y UCL para ganar puntos y convertirte en un Footy Master.",
    footy_master_seo_keywords: "Footy Master, Quiz de Fútbol, Trivia de Fútbol, Juego de Fútbol, Quiz Copa del Mundo, Quiz EPL, Juegos XLEVEN",
    noCommentsYet: "Aún no hay comentarios",
    addAComment: "Añadir un comentario...",
    deleteCommentConfirm: "¿Eliminar este comentario?",
    matchTalk: "Charla del Partido",
    phantomStadium: "Estadio Fantasma",
    matchAnalysis: "Análisis del Partido",
    noPostsFound: "No se encontraron publicaciones",
    beTheFirstToPost: "¡Sé el primero en publicar!",
    noAnalysisFound: "No se encontró ningún análisis",
    beTheFirstToAnalyze: "¡Sé el primero en analizar!",
    viewMore: "Ver más",
    deleteConfirm: "Confirmar Eliminación",
    deleteConfirmMessage: "¿Estás seguro de que quieres eliminar este contenido? Esta acción no se puede deshacer.",
    viewReplies: "Ver respuestas",
    hideReplies: "Ocultar respuestas",
    failedToLoadQuizzes: "No se pudieron cargar los cuestionarios",
    quizCreatedSuccessfully: "El cuestionario se creó correctamente",
    quizDeleted: "El cuestionario ha sido eliminado",
    deleteFailed: "Error al eliminar",
    deleteSuccess: "Eliminado correctamente",
    reportSubmitted: "Reporte enviado",
    failedToDeductPoints: "Error al descontar puntos",
    failedToUpdatePassword: "Error al actualizar la contraseña",
    failedToUpdateNickname: "Error al actualizar el apodo",
    fileSizeUnder5MB: "El tamaño del archivo debe ser inferior a 5MB",
    saveFailed: "Error al guardar",
    supportXlevenService: "Soporte del servicio XLEVEN",
    copySuccess: "Enlace copiado al portapapeles",
    setFavoriteTeamFirst: "Primero configúralo como equipo favorito",
    aiTacticalInsight: "Perspectiva Táctica de IA",
    strategicAnalysisReport: "Informe de Análisis Estratégico",
    winProbabilityDistribution: "Distribución de Probabilidad de Ganar",
    aiConfidence: "Confianza de la IA",
    viewAll: "Ver Todo",
    viewDetails: "Ver detalles",
    hotPost: "Post Popular",
    syncingActivities: "Sincronizando actividades...",
    intelligenceReport: "Informe de Inteligencia",
    matchIntel: "Intel de Partido",
    koreanFeed: "Feed Coreano",
    englishFeed: "Feed Inglés",
    maxLeaguesReached: "Se pueden seleccionar un máximo de 10 ligas",
    maxLeaguesReachedGuest: "Los no miembros pueden seleccionar un máximo de 3 ligas",
  },
  fr: {
    popularFavoriteTeams: 'Équipes favorites populaires',
    stadiumPostTitle: "Publier dans le Stade",
    stadiumPostPlaceholder: "Partagez vos pensées avec les autres fans de cette équipe.",
    injuryList: "Blessés",
    injuryReason_Injury: "Blessure",
    injuryReason_RedCard: "Carton Rouge",
    injuryReason_Internationalduty: "Devoir International",
    injuryReason_YellowCards: "Cartons Jaunes",
    injuryReason_LowerBackInjury: "Blessure au bas du dos",
    injuryReason_ChestInjury: "Blessure à la poitrine",
    injuryReason_Jumpersknee: "Genou du sauteur",
    injuryReason_ToeInjury: "Blessure à l'orteil",
    injuryReason_Inactive: "Inactif",
    injuryReason_KneeInjury: "Blessure au genou",
    injuryReason_AnkleInjury: "Blessure à la cheville",
    injuryReason_HamstringInjury: "Blessure aux ischio-jambiers",
    injuryReason_ThighInjury: "Blessure à la cuisse",
    injuryReason_CalfInjury: "Blessure au mollet",
    injuryReason_GroinInjury: "Blessure à l'aine",
    injuryReason_MuscleInjury: "Blessure musculaire",
    injuryReason_FootInjury: "Blessure au pied",
    injuryReason_LegInjury: "Blessure à la jambe",
    injuryReason_BrokenLeg: "Jambe cassée",
    injuryReason_ACLInjury: "Rupture des ligaments croisés",
    injuryReason_MCLInjury: "Lésion du ligament collatéral",
    injuryReason_ShoulderInjury: "Blessure à l'épaule",
    injuryReason_BackInjury: "Blessure au dos",
    injuryReason_HipInjury: "Blessure à la hanche",
    injuryReason_HeadInjury: "Blessure à la tête",
    injuryReason_Concussion: "Commotion cérébrale",
    injuryReason_WristInjury: "Blessure au poignet",
    injuryReason_HandInjury: "Blessure à la main",
    injuryReason_BrokenHand: "Main cassée",
    injuryReason_BrokenArm: "Bras cassé",
    injuryReason_ArmInjury: "Blessure au bras",
    injuryReason_Sick: "Maladie",
    injuryReason_Illness: "Maladie",
    injuryReason_Fever: "Fièvre",
    injuryReason_Virus: "Virus",
    injuryReason_Infection: "Infection",
    injuryReason_Knock: "Coup",
    injuryReason_Bruise: "Contusion",
    injuryReason_Strain: "Élongation",
    injuryReason_Sprain: "Entorse",
    injuryReason_Tear: "Déchirure",
    injuryReason_Surgery: "Chirurgie",
    injuryReason_PhysicalCondition: "Condition physique",
    injuryReason_Rest: "Repos",
    injuryReason_PersonalReasons: "Raisons personnelles",
    injuryReason_Suspended: "Suspendu",
    injuryReason_Doubtful: "Incertain",
    injuryReason_Achillestendonproblems: "Problèmes au tendon d'Achille",
    injuryReason_fitness: "Condition physique",
    injuryReason_Injurytotheankle: "Blessure à la cheville",
    injuryReason_injured: "Blessé",
    injuryReason_InjuredDoubtful: "Blessé / Incertain",
    injuryReason_Suspension: "Suspension",
    injuryReason_RedcardSuspended: "Suspendu (carton rouge)",
    injuryReason_Muscularproblems: "Problèmes musculaires",
    injuryReason_Thighproblems: "Problèmes à la cuisse",
    injuryReason_KneeSurgery: "Chirurgie du genou",
    injuryReason_Outerligamenttear: "Lésion du ligament externe",
    injuryReason_Kneeinjury: "Blessure au genou",
    injuryReason_Rupturedcruciateligament: "Rupture du ligament croisé",
    injuryReason_FracturedFinger: "Fracture du doigt",
    injuryReason_Sprainedankle: "Entorse de la cheville",
    injuryReason_UnknownInjury: "Blessure inconnue",
    sponsorshipTitle: "Soutenir XLEVEN",
    sponsorshipDesc: "Aidez-nous à continuer de fournir les analyses IA et les informations sur le football les plus rapides. Votre soutien fait la différence !",
    supportSmallCoffee: "Offrez-nous un petit café",
    qrDonation: "Donation par QR Code",
    qrDonationDesc: "Scannez pour nous soutenir par transfert direct",
    sponsorshipWhy: "Pourquoi nous soutenir ?",
    sponsorshipWhyDesc: "Vos contributions aident à couvrir les coûts des serveurs et les frais d'API, nous permettant de continuer à développer des fonctionnalités innovantes pour la communauté du football.",
    magazineArchive: "Archives",
    magazineCollection: "Collection",
    magazineDiscover: "Découvrez le",
    magazineDeepStories: "Histoires Profondes",
    magazineHeroDesc: "Aperçus de football sélectionnés, interviews exclusives et chefs-d'œuvre tactiques.",
    notices: "Avis",
    noNotices: "Aucun avis trouvé",
    noNoticesDesc: "Nous vous informerons lors des nouvelles mises à jour",
    allLeagues: "Toutes les Ligues",
    home: "Accueil",
    news: "Fil d'actualité",
    player: "Joueur",
    games: "Matchs",
    shorts: "Shorts",
    settings: "Paramètres",
    mypage: "Ma Page",
    gamestore: "Jeux",
    recommendedForYou: "Dernier Flux",
    latestTransferNews: "Mouvements du Marché",
    helpCenter: "Centre d'Aide",
    contactUs: "Contactez-nous",
    privacyPolicy: "Politique de Confidentialité",
    termsOfService: "Conditions d'Utilisation",
    aboutUs: "À Propos",
    aboutXleven: "À propos de XLEVEN",
    aboutXlevenDesc: "XLEVEN fournit les nouvelles de football les plus rapides grâce à l'IA. Découvrez l'actualité en temps réel, les rumeurs de transfert et les prédictions basées sur les données.",
    sponsorship: "Sponsorship",
    marketWatch: "Marché des Transferts",
    topTransfers: "Principaux Transferts",
    latestHeadlines: "Dernières Actualités",
    verifiedSources: "Sources Vérifiées",
    stats: "Statistiques",
    playingCareer: "Carrière",
    fanZone: "Zone Fan",
    trendingTopic: "Sujets Tendances",
    analyze: "Générer Prédiction Transfert",
    analyzing: "Analyse des stats...",
    undisclosed: "Non divulgué",
    unknown: "Inconnu",
    noTransfers: "Aucun transfert trouvé pour",
    comingSoon: "Bientôt dans la v2.0",
    language: "Langue",
    selectLanguage: "Choisir la Langue",
    clearCache: "Effacer le Cache",
    cacheCleared: "Cache effacé",
    all: "Tout",
    global: "Global",
    epl: "EPL",
    laliga: "La Liga",
    seriea: "Serie A",
    bundesliga: "Bundesliga",
    ligue1: "Ligue 1",
    uefa: "UEFA",
    live: "En Direct",
    replay: "Replay",
    latest: "Dernier",
    worldCup: "Coupe du Monde",
    leagues: "Ligues",
    weeklyMagazine: "Magazine",
    magazine: "Magazine",
    read: "lu",
    welcome: "Bon retour",
    enterCredentials: "Veuillez entrer vos coordonnées pour vous connecter.",
    continueWithGoogle: "Continuer avec Google",
    continueWithKakao: "Continuer avec Kakao",
    continueWithNaver: "Continuer avec Naver",
    or: "Ou",
    emailAddress: "Adresse E-mail",
    password: "Mot de Passe",
    signInAccount: "Se Connecter",
    noAccount: "Pas encore de compte ?",
    createAccount: "Créer un Compte",
    fullName: "Nom Complet",
    confirmPassword: "Confirmer le Mot de Passe",
    startExploration: "Commencer l'Exploration",
    joinNow: "Rejoindre",
    recentActivity: "Activité Récente",
    recentActivityDesc: "Historique des transferts consultés",
    followedPlayers: "Joueurs Suivis",
    followedPlayersDesc: "Gérer votre liste de suivi",
    favoriteClubs: "Clubs Favoris",
    favoriteClubsDesc: "Mises à jour et notifications d'équipe",
    pushNotifications: "Notifications Push",
    pushNotificationsDesc: "Alertes marché en temps réel",
    darkMode: "Mode Sombre",
    supportLegal: "Support & Légal",
    storagePrivacy: "Stockage & Confidentialité",
    storagePrivacyDesc: "Libérer de l'espace de stockage local",
    logOutAccount: "Déconnexion",
    verifiedProfile: "Profil Vérifié",
    proMember: "Membre Pro",
    activity: "Activité",
    applicationSettings: "Paramètres de l'Application",
    back: "Retour",
    forgotPassword: "Mot de passe oublié ?",
    secureSSL: "SSL Sécurisé",
    alreadyMember: "Déjà membre ?",
    signIn: "Se Connecter",
    authenticating: "Authentification...",
    securingData: "Sécurisation des Données...",
    accessGranted: "Accès Autorisé !",
    scoutingProfileSync: "Votre profil de scouting ha été sécurisé avec succès.",
    dataLinkActive: "Lien de Données Actif",
    redirecting: "Redirection vers le Tableau de Bord...",
    editNickname: "Modifier le Pseudo",
    save: "Enregistrer",
    cancel: "Annuler",
    nicknameError: "Le pseudo doit contenir entre 2 et 20 caractères.",
    favoriteLeagues: "Ligues Favorites",
    favoriteLeaguesDesc: "Vos catégories de matchs suivies",
    manageLeagues: "Choisir les Ligues Favorites",
    saveChanges: "Enregistrer les Modifications",
    selectLeaguesToFollow: "Sélectionnez les ligues à suivre",
    syncSuccess: "Préférences synchronisées avec succès",
    today: "Aujourd'hui",
    dailyAttendance: "Présence Quotidienne",
    reasonWelcomePoints: "Points de bienvenue",
    last7Days: "7 Derniers Jours",
    last30Days: "30 Derniers Jours",
    allTime: "Tout le Temps",
    activityStats: "Classements & Stats",
    totalInteractions: "Interactions Totales",
    loadingLeagues: "Chargement des ligues...",
    following: "Abonné",
    views: "Vues",
    comments: "Commentaires",
    discussionHub: "Hub de Discussion",
    syncingHub: "Synchronisation...",
    firstIntelligenceReport: "Postez votre premier commentaire",
    relatedIntelligence: "Actualités Liées",
    relatedNews: "Actualités Liées",
    reply: "Répondre",
    report: "Signaler",
    delete: "Supprimer",
    replyingTo: "Répondre à",
    typeIntelligenceUpdate: "Écrire une mise à jour...",
    establishReport: "Établir un rapport...",
    unauthorizedLogin: "Non autorisé. Connexion requise.",
    deleteCommentTitle: "Supprimer le commentaire ?",
    loginRequiredTitle: "Connectez-vous pour rejoindre l'action",
    signInLabel: "Se Connecter",
    changingLanguage: "Mise à jour de la langue...",
    intelligenceAudio: "Rapport Vocal IA",
    mergeFailed: "Échec de fusion",
    keyBriefing: "Briefing Clé",
    loadingIntelligence: "Chargement...",
    articleNotFound: "Article non trouvé",
    goBack: "Retour",
    joinConversation: "Rejoignez la conversation...",
    loginParticipate: "Connectez-vous pour participer",
    leagueSelectionDescLoggedIn: "Choisissez les ligues. Vos choix sont synchronisés.",
    leagueSelectionDescGuest: "Choisissez les ligues. Sessions invités : 3 min.",
    leagueStage: "Phase de Ligue",
    knockoutStage: "Phase Finale",
    scenariosTab: "Scénarios",
    syncSelectedFeed: "Synchroniser le Flux",
    selectAtLeastOneLeague: "Sélectionnez au moins une ligue.",
    syncFailedTryAgain: "Échec de synchro. Veuillez réessayer.",
    yourLeagues: "vos ligues",
    edit: "Modifier",
    loadMore: "Charger plus",
    latestMovements: "Derniers Mouvements",
    syncingMarketIntel: "Synchronisation des données...",
    loadingNewsFeed: "Préparation de votre flux...",
    analyzingTalent: "Analyse des données...",
    syncingFixtures: "Calendrier des Matchs...",
    syncingMatchDetail: "Infos sur le Match...",
    curatingShorts: "Préparation des Highlights...",
    postingComment: "Publication du Commentaire...",
    searchingFor: "Recherche de",
    matchStats: "Stats",
    lineUp: "Composition",
    timeline: "Chronologie",
    talk: "Talk",
    matchHighlights: "Highlights du Match",
    latestTeamNews: "Dernières Infos de l'Équipe",
    close: "Fermer",
    fullTime: "FT",
    startingXI: "Onze de Départ",
    substitutes: "Remplaçants",
    injuries: "Blessés",
    coach: "Entraîneur",
    ownGoal: "But contre son camp",
    waitingKickoff: "En attente du coup d'envoi",
    matchStarted: "Match Commencé",
    lineupAnnouncement: "Compos 60 min avant le coup d'envoi",
    noStatsSynced: "Aucune stat synchronisée",
    post: "Poster",
    discoverMore: "Découvrir plus",
    shareSuccess: "Lien copié dans le presse-papiers",
    consultingGrid: "Consultation des données...",
    matchesFound: "Matchs Trouvés",
    zeroIntel: "Zéro Info",
    refineSearch: "Affinez vos paramètres de recherche",
    awaitingPersonnel: "Attente Identification",
    scanningFrequency: "Scan de la fréquence",
    searchNewsPlaceholder: "Rechercher actus",
    searchAllLeagues: "Rechercher ligues",
    searchPlayerPlaceholder: "Rechercher (anglais)",
    searchGamePlaceholder: "Chercher matchs...",
    searchShortsPlaceholder: "Chercher highlights...",
    deleteAccount: "Supprimer le Compte",
    deleteAccountConfirm: "Voulez-vous supprimer votre compte ? Toutes vos données seront perdues.",
    confirm: "Confirmer",
    yes: "Oui",
    no: "Non",
    closingAccount: "Fermeture du compte...",
    joined: "Inscrit le",
    agentTools: "Outils Agent",
    supportInfo: "Support & Infos",
    accountActions: "Actions du Compte",
    marketHotspots: "Tendances Marché",
    trendingIntel: "Sujet Chaud",
    squadBuilderTitle: "Compo Probable",
    squadBuilderSub: "Simulateur Tactique",
    forwards: "Attaquants",
    midfielders: "Milieux",
    defenders: "Défenseurs",
    goalkeepers: "Gardiens",
    selectPersonnel: "Sélectionner Personnel",
    personnelFound: "Aucun personnel trouvé",
    selectFormation: "Choisir Formation",
    searchingSector: "Recherche...",
    move: "Déplacer",
    clear: "Effacer",
    squadTheme: "Thème du Terrain",
    themeGrass: "Pelouse Fraîche",
    themeBlueprint: "Plan Tactique",
    themeStealth: "Stealth Nocturne",
    themePremium: "Or Premium",
    themeGlass: "Glass Morph",
    themePaper: "Papier Classique",
    themeCyber: "Grille Cyber",
    themeRetroMud: "Boue Rétro",
    themeNeonFuture: "Futur Néon",
    ftResult: "Résultat Final",
    scheduled: "Programmé",
    stadiumCap: "Cap.",
    syncingIntel: "Synchronisation...",
    standings: "Classement",
    scorers: "Buteurs",
    assists: "Passeurs",
    assistsFor: "Passes",
    managerialCareer: "Carrière Manager",
    singleMatchPerformance: "Performance du Match",
    seasonIntelPerformance: "Performance Saison",
    retrievingIntel: "Récupération...",
    saveImage: "Sauver Image",
    shareToFeed: "Partager",
    aiMatchPrediction: "Intelligence Tactique IA",
    simulatingScenarios: "Simulation en cours...",
    runSimulation: "Générer Rapport",
    predictedWinner: "Domination Attendue",
    expectedScore: "Score Projeté",
    tacticalInsight: "Raison de l'Analyse",
    aiSimulationDesc: "Scouts IA simulent les matchs sur la forme, stats et tactiques.",
    noSectorActivity: "Aucune Activité",
    noSectorActivityDesc: "Aucun match prévu à cette date.",
    season2526: "Saison 25/26",
    momentumEfficiency: "Momentum & Efficacité",
    avgGoals: "Buts Moyens",
    perMatch: "par match",
    goalBalance: "Balance des Buts",
    goalsFor: "Buts Pour",
    goalsAgainst: "Buts Contre",
    offensiveDominance: "Domination Offensive",
    defensiveLeakage: "Faiblesse Défensive",
    teamDNAIndices: "Indices ADN d'Équipe",
    matchOutcomeDistribution: "Répartition des Résultats",
    cleanSheets: "Clean Sheets",
    failedToScore: "Sans Marquer",
    scoredPenalties: "Penaltys Réussis",
    missedPenalties: "Penaltys Manqués",
    bigWins: "Larges Victoires",
    toughLosses: "Lourdes Défaites",
    noVerifiedTransfers: "Aucun mouvement vérifié ces 12 derniers mois",
    reportTitle: "Signaler Commentaire",
    reportDesc: "Choisissez une raison",
    reportReasonSpam: "Spam ou trompeur",
    reportReasonHarassment: "Harcèlement ou haine",
    reportReasonInappropriate: "Contenu inapproprié",
    reportReasonViolence: "Violence ou danger",
    reportReasonOther: "Autre",
    reportOtherPlaceholder: "Veuillez préciser...",
    submitReport: "Envoyer Signalement",
    maintenanceTitle: "Rafraîchissement Système",
    maintenanceDesc: "Bientôt de retour avec de nouveaux highlights.\nMerci de votre patience.",
    maintenanceUntil: "Reprise à 09:00 KST (00:00 UTC)",
    shareIntelligence: "Écrire dans le fil",
    whatsHappening: "Quoi de neuf dans le foot ?",
    postSuccess: "Flux partagé avec succès",
    uploadingIntel: "Téléchargement...",
    addLink: "Ajouter Lien",
    linkPlaceholder: "Collez le lien ici (ex. https://...)",
    linkValidationError: "Le lien doit commencer par https://",
    urlRestricted: "Accès restreint par le site.",
    urlPaywall: "Cet article peut nécessiter un abonnement.",
    urlDynamicWarning: "Contenu complexe. Analyse limitée.",
    aiAnalyzing: "Analyse...",
    aiWaitNote: "Prend environ 20-40 secondes.",
    scoutingStatus1: "Contact réseau scouting...",
    scoutingStatus2: "Vérification valeurs marché...",
    scoutingStatus3: "Synthèse tactique...",
    scoutingStatus4: "Finalisation rapport...",
    aiTimeout: "Analyse trop longue (+60s). Réessayez ou vérifiez le lien.",
    aiNotFootball: "Veuillez nous parler d'actu foot.",
    aiDraftTitle: "Brouillon IA",
    aiDraftSubtitle: "Prêt pour votre flux",
    extractedTitle: "Titre Extrait",
    generatedContent: "Contenu Généré",
    aiDraftDisclaimer: "Référence. 'Appliquer' pour éditer et poster.",
    applyToEditor: "Appliquer à l'Éditeur",
    imageSourceLabel: "Source",
    selectionDone: "Fait",
    inquiryHistory: "Historique Consultations",
    emailSupport: "Support E-mail",
    myHistory: "Mon Historique",
    newInquiry: "Nouvelle Consultation",
    noInquiryHistory: "Aucun historique trouvé.",
    completed: "Terminé",
    response: "Réponse",
    inquiryGeneral: "Général",
    inquiryAccount: "Compte/Login",
    inquiryContent: "Contenu/Correction",
    inquiryError: "Erreur",
    inquirySuggestion: "Suggestion",
    clearLocalStorage: "Effacer Stockage Local",
    clearLocalStorageConfirm: "Effacer données sauf infos utilisateur ? Vos préférences seront reset.",
    attendance: "Présence",
    attendanceDesc: "Bonus quotidiens",
    favoriteTeams: "Équipes Favorites",
    favoriteTeamsDesc: "Équipes suivies",
    matchPredictions: "Prédictions Matchs",
    matchPredictionsDesc: "Mes rapports tactiques de prédiction de match analysés par l'IA",
    pointHistoryTitle: "Historique Points",
    pointHistorySub: "Gains et utilisation",
    english: "Anglais (UK)",
    korean: "Coréen (KR)",
    clearingData: "Effacement...",
    logoutConfirm: "Voulez-vous vous déconnecter ?",
    teamDetails: "Détails Équipe",
    teamNotFound: "Infos équipe non trouvées.",
    homeStadium: "Stade Domicile",
    recentMatches: "Matchs Récents",
    squad: "Effectif",
    goalkeeper: "Gardien",
    defender: "Défenseur",
    midfielder: "Milieu",
    attacker: "Attaquant",
    languageSaveSuccess: "Paramètres de langue sauvés.",
    languageAiNote: "Résumés et analyses IA seront fournis dans la langue choisie.",
    "Shots on Goal": "Tirs Cadrés",
    "Shots off Goal": "Tirs Non Cadrés",
    "Total Shots": "Total Tirs",
    "Blocked Shots": "Tirs Bloqués",
    "Shots insidebox": "Tirs dans la surface",
    "Shots outsidebox": "Tirs hors surface",
    "Fouls": "Fautes",
    "Corner Kicks": "Corners",
    "Offsides": "Hors-jeux",
    "Ball Possession": "Possession",
    "Yellow Cards": "Cartons Jaunes",
    "Red Cards": "Cartons Rouges",
    "Goalkeeper Saves": "Arrêts Gardien",
    "Total passes": "Total Passes",
    "Passes accurate": "Passes Réussies",
    "Passes %": "Passes %",
    "Expected Goals": "Expected Goals (xG)",
    expected_goals: "Expected Goals (xG)",
    goals_prevented: "Buts Évités",
    noIntelTitle: "Flux Vide",
    noIntelDesc: "Aucune news à cette date.",
    noSectorIntel: "Infos non disponibles",
    noContentFound: "Contenu non trouvé",
    performanceHistory: "Performance par Saison",
    detailedSeasonBreakdown: "Détails Saison",
    recentForm: "Forme Récente",
    noContentDesc: "Il n'y a pas de données à afficher pour le moment. Souhaitez-vous consulter d'autres menus ?",
    unlockFullIntel: "Débloquer infos complètes",
    careerIntelNotAvailable: "Infos carrière non dispos",
    transferHistory: "Historique Transferts",
    freeAgent: "Agent Libre",
    capturingImage: "Capture image 3D...",
    classicGround: "Terrain Classique",
    realStadium: "Stade Réel",
    imageUploadFailed: "Échec upload image.",
    captureFailed: "Échec capture.",
    noFavoriteTeams: "Aucune Équipe Favorite",
    noFavoriteTeamsDesc: "Tapez le cœur sur les détails matchs pour ajouter.",
    removeFavoriteTeam: "Retirer Favori",
    removeFavoriteTeamConfirm: "Voulez-vous retirer cette équipe ?",
    setDefaultTeamTitle: "Équipe par défaut ?",
    setDefaultTeamDesc: "Mettre cette équipe en principal ? Une seule possible.",
    defaultTeam: "Équipe par Défaut",
    selectDefaultTeam: "Mettre en principal",
    contactSupport: "Support 1:1",
    contactSupportDesc: "Contactez XLEVEN pour toute question.",
    mySupportHistory: "Mon Historique Support",
    mySupportHistoryDesc: "Voir vos questions et réponses.",
    myPageDesc: "Gérez profil, présence, points et rapports IA sur votre page XLEVEN.",
    attendanceDescSEO: "Connectez-vous chaque jour et gagnez des points.",
    pointHistoryDescSEO: "Vérifiez vos gains et dépenses de points.",
    playerAge: "Âge",
    playerHeight: "Taille",
    playerWeight: "Poids",
    matchPredictionsDescSEO: "Consultez vos données de prédiction de match et vos rapports tactiques analysés par l'IA.",
    recentActivityDescSEO: "Voir vos commentaires et activité.",
    favoriteLeaguesDescSEO: "Choisissez les ligues à suivre.",
    favoriteTeamsDescSEO: "Voir vos équipes suivies.",
    languageDescSEO: "Changez la langue du service.",
    allMatchFixturesSeoTitle: "Calendrier Matchs",
    allMatchFixturesSeoDesc: "Scores, calendriers et résultats des ligues mondiales.",
    leagueMatchFixturesSeoTitle: "Calendrier des Matchs",
    leagueMatchFixturesSeoDesc: "Scores, calendriers et résultats de {{leagueName}}.",
    noticeUpdate: "Mise à Jour Avis",
    checkNow: "Voir Maintenant",
    loading: "Chargement...",
    loadingMore: "Chargement suite...",
    noPredictionsYet: "Pas encore de prédiction",
    analyzeMatchesDesc: "Analysez les matchs et recevez des rapports IA.",
    exploreMatches: "Voir la liste des matchs",
    predictionAccuracy: "Précision",
    analysisStatistics: "Stats d'Analyse",
    totalAnalysis: "Total Analyses",
    searchByTeam: "Chercher par équipe...",
    lastWeek: "Dernière semaine",
    lastMonth: "Dernier mois",
    myAiTacticalReports: "Mes Rapports IA",
    formation: "Formation",
    theme: "Thème",
    swapTip: "Glisser pour déplacer",
    squadAnalysis: "Analyse Effectif",
    newsTitle: "Titre",
    translateToEn: "Traduire en Anglais",
    translateToKo: "Traduire en Coréen",
    translating: "Traduction...",
    addSource: "Ajouter Source",
    sourcePlaceholder: "Nom source (ex. bbc)",
    apiAndCopyright: "Infos API & Copyright",
    noMajorGamesToday: "Aucun match majeur aujourd'hui dans vos ligues.",
    adminTools: "Outils Admin",
    adminControlCenter: "Centre de Contrôle Admin",
    adminControlCenterDesc: "Gérer users, posts et protocoles",
    addFavoriteLeaguesTitle: "Suivre vos Ligues",
    addFavoriteLeaguesDesc: "Choisissez les ligues pour votre accueil.",
    setupNow: "Configurer",
    addFavoriteLeaguesButton: "Ajouter Ligues",
    deleteFeedConfirm: "Supprimer ce post ? Irréversible.",
    reportFeedTitle: "Signaler Post",
    editFeed: "Éditer Flux",
    deleteFeed: "Supprimer Flux",
    reportFeed: "Signaler Flux",
    alreadyReported: "Déjà signalé.",
    reportCompleted: "Signalement envoyé.",
    externalSourceReportError: "Sources externes non signalables directement.",
    postDeletedSuccess: "Flux supprimé avec succès",
    scanningSectorData: "Scan des Données...",
    searchResults: "Résultats",
    analysisFailed: "Échec analyse",
    feedPostPointEarned: "Flux posté ! +{{amount}}P gagnés",
    failedToPostNews: "Échec postage flux",
    feedDeletePointDeducted: "10P déduits pour suppression.",
    failedToDelete: "Échec suppression",
    seoDefaultDescription: "Actu foot, rumeurs, highlights et analyse IA. Premier, La Liga, Champions sur XLEVEN.",
    seoDefaultKeywords: "foot, actu, transfert, score, analyse, Premier League, La Liga, Champions, IA",
    seoHomeTitle: "Actu Foot & Rumeurs Transferts - Analyse IA",
    topTransfersSeoDesc: "Analyse des plus gros transferts de l'histoire.",
    latestMovementsSeoDesc: "Mouvements et annonces officielles en temps réel.",
    playerDetailSeoDesc: "Données, stats, historique et forme de {{playerName}}.",
    playerDetailSeoTitle: "{{playerName}} - {{position}} ({{team}})",
    synchronizingIntelligence: "Synchronisation...",
    summer: "Été",
    winter: "Hiver",
    dataProvidedBy: "Données par",
    leagueHighlightsSeoDesc: "Highlights de {{leagueName}}.",
    matches: "Matchs",
    awaitingMarketIntel: "Attente infos marché...",
    scanningSectorIntel: "Scan secteur...",
    noticeTitle: "Mise à Jour XLEVEN",
    noticeBody: "Moteur IA Gemini 2.5 actif. Rapports scouting et prédictions boostés.",
    dontShowToday: "Ne plus montrer aujourd'hui",
    emailRequired: "Entrez votre e-mail",
    resetFailed: "Échec envoi lien",
    resendFailed: "Échec renvoi",
    emailNotConfirmedMsg: "E-mail non vérifié. Regardez vos messages.",
    resendSuccess: "Succès envoi",
    resendAction: "Renvoyer Vérification",
    invalidCredentials: "E-mail ou mot de passe invalide.",
    tooManyRequests: "Trop de requêtes. Réessayez plus tard.",
    fixtures: "Calendrier",
    activeSource: "Ligue Sélectionnée",
    updateSectors: "Mise à jour Ligues",
    configureIntelSources: "Configurez vos ligues",
    searchingGlobalDatabase: "Recherche en cours...",
    noMatchingSectors: "Aucun secteur trouvé",
    majorLeagues: "Grandes Ligues",
    majorCups: "Grandes Copas",
    addedSectors: "Secteurs Ajoutés",
    goToToday: "Aller à Aujourd'hui",
    scanningGrid: "Scan...",
    rating: "Note",
    goals: "Buts",
    passPercentage: "Passes %",
    dribbles: "Dribbles",
    defense: "Défense",
    captain: "Capitaine",
    injured: "Blessé",
    club: "Club",
    played: "MJ",
    points: "Pts",
    goalDiff: "DB",
    win: "V",
    draw: "N",
    loss: "D",
    ucl: "UCL",
    uel: "UEL",
    rel: "REL",
    noConcludedMatches: "Aucun match terminé",
    loadingRecords: "Chargement...",
    from: "de",
    to: "à",
    transfer: "Transfert",
    openOriginal: "Ouvrir original",
    refreshLiveData: "Rafraîchir Données",
    syncingMatchIntelDesc: "Synchronisation...",
    newPassword: "Nouveau Mot de Passe",
    updatePassword: "Changer Mot de Passe",
    passwordChanged: "Mot de passe changé !",
    passwordChangedDesc: "Votre mot de passe a été mis à jour.",
    passwordMinLength: "Mín 8 carac.",
    passwordLetters: "Lettres requises",
    passwordNumbers: "Chiffres requis",
    passwordSpecial: "Carac. spéciaux requis",
    passwordMatch: "Coïncident",
    passwordSameAsOld: "Doit être différent de l'ancien",
    resetIntel: "Reset Mot de Passe",
    verifyIdentity: "Vérifiez votre identité",
    accountEmail: "E-mail du Compte",
    enterRegisteredEmail: "E-mail enregistré",
    authorizeReset: "Autoriser Reset",
    backToEntry: "Retour",
    nicknameUpdated: "Pseudo mis à jour.",
    profileImageUpdated: "Photo de profil changée.",
    backgroundImageUpdated: "Photo de couverture changée.",
    uploadFailed: "Échec upload. Réessayez.",
    fileSizeError: "Fichier trop gros. Máx 5Mo.",
    pointHistory: "Historique Points",
    pointGuide: "Infos Points",
    pointGuideDesc: "Points par activité. Serviront pour de futurs services.",
    noPointHistory: "Aucun historique trouvé.",
    loadingPointHistory: "Chargement...",
    gatheringIntel: "Collecte...",
    syncingPointHistory: "Synchronisation...",
    reasonDailyAttendance: "Présence Quotidienne",
    reason7DayBonus: "Bonus 7 Jours",
    reasonNewsPost: "Post Flux",
    reasonNewsDelete: "Suppression Flux",
    reasonCommentPost: "Commentaire",
    reasonCommentDelete: "Suppression Commentaire",
    reasonAiReport: "Rapport IA",
    reasonRegularEarn: "Gain Régulier",
    reasonAdminSpecialReward: "Prime Admin Special",
    reasonNeonPitch: "Jouer au Jeu : NEON PITCH",
    reasonTripleBetMultiple: "Triple Bet Sélection Multiple",
    reasonTripleBetAi: "Triple Bet Analyse IA",
    reasonFootyMaster: "Jouer au Jeu : FOOTY MASTER",
    pointEarned: "Points gagnés !",
    pointDeducted: "Points déduits.",
    commentPosted: "Commentaire posté !",
    commentDeleted: "Commentaire supprimé.",
    feedPosted: "Flux posté !",
    feedDeleted: "Flux supprimé.",
    attendanceComplete: "Présence validée !",
    firstLoginToday: "Premier login du jour !",
    deleteCancel: "Annuler Suppression",
    deleteConfirmDesc: "Irréversible. Continuer ?",
    editCancel: "Annuler Édition",
    editCancelDesc: "Non sauvé. Voulez-vous quitter ?",
    postCancel: "Annuler Postage",
    postCancelDesc: "Non sauvé. Voulez-vous quitter ?",
    errorLoadingImages: "Échec chargement images.",
    errorProcessingAttendance: "Échec présence.",
    errorAnalysis: "Échec analyse.",
    errorReport: "Échec signalement.",
    errorDelete: "Échec suppression.",
    loginRequired: "Connexion requise.",
    enterTitleAndContent: "Entrez titre et contenu.",
    inquirySubmitted: "Demande envoyée.",
    errorInquiry: "Échec envoi demande.",
    category: "Catégorie",
    title: "Titre",
    content: "Contenu",
    inquiryPlaceholder: "Détaillez votre demande",
    titlePlaceholder: "Titre de la demande",
    inquiryNote: "Réponse bientôt. Peut tarder le week-end.",
    submitInquiry: "Envoyer Demande",
    attendanceStreak: "Série de Présence",
    attendanceNote: "Entrez chaque jour pour plus de gains",
    attendanceCompleted: "Présence OK",
    checkAttendanceNow: "Valider Présence",
    weeklyProgress: "Progrès Semaine",
    baseReward: "Prime Base",
    streakBonus: "Bonus Série",
    attendanceResetNote: "Reset à minuit (00:00).",
    present: "Présent",
    frame: "Cadre",
    searchPlaceholder: "Chercher par raison, signaleur...",
    playerAndTransferManagement: "Gestion Joueurs",
    playerManagementDesc: "Données marché et groupes",
    latestTransfers: "Derniers Transferts",
    groupList: "Liste Groupes",
    playerSearchPlaceholder: "Chercher joueur ou club...",
    addItem: "Ajouter Item",
    playerIntel: "Infos Joueur",
    movement: "Mouvement",
    valueFee: "Valeur/Prix",
    noItemsFound: "Aucun item trouvé",
    createGroup: "Créer Groupe",
    editGroup: "Éditer Groupe",
    addPersonnel: "Ajouter Personnel",
    editPersonnel: "Éditer Personnel",
    deleteItem: "Supprimer Item",
    deleteGroupConfirmDesc: "Supprimer groupe ? Données liées seront perdues.",
    deleteItemConfirmDesc: "Supprimer cet item ? Irréversible.",
    systemSettingsDesc: "Moteur et politiques système",
    awardPoints: "Donner Points",
    awardPointsDesc: "Donner points à l'user.",
    award: "Donner",
    awardSuccess: "Points donnés avec succès.",
    amount: "Quantité",
    reason: "Razón",
    auditIntelligenceDesc: "Revoir les flux communauté",
    auditReportsDesc: "Revoir les signalements",
    noResultsFound: "Aucun résultat",
    noTrendingData: "Aucune tendance",
    pointDeduction: "Déduction Points",
    insufficientPoints: "Points Insuficientes",
    rechargeRequired: "Recharge Requise",
    allMatchFixtures: "Tous les Matchs",
    leagueMatchFixtures: "Matchs de Ligue",
    allMatchFixturesDesc: "Scores, calendriers et résultats.",
    playerStatsDesc: "Données, stats et historique.",
    newsFeedDesc: "News et rumeurs par date.",
    shortsDesc: "Highlights et shorts sans pub.",
    maintenanceResumes: "Reprise 09:00 KST (00:00 UTC)",
    swipeGuide: "Swippez gauche/droite",
    swipeDateGuide: "pour voir par date",
    apiInfoDesc1: "Données API-Sports (API-Football). Droits aux fournisseurs et ligues.",
    apiInfoDesc2: "Analyses et résumés par Gemini IA. Seul référence.",
    apiInfoDesc3: "Vidéos via YouTube API. Droits aux chaînes.",
    apiInfoDesc4: "Images BBC Sport et Pexels (Royalty-free).",
    apiInfoDesc5: "Logos et photos aux proprios originaux.",
    apiInfoDesc6: "Usage pour reportage et stats. Pas de revente.",
    apiSportsData: "API Données Sport",
    apiAiIntelligence: "Analyse IA",
    apiMediaVideo: "Média & Vidéo",
    apiNewsAssets: "Assets News",
    apiBbcSource: "Sources BBC Sport",
    apiCopyrightDisclaimer: "Avis Copyright",
    privacyDesc1: "XLEVEN respecte votre vie privée. Cette politique détaille tout.",
    privacySection1Title: "1. Données Collectées",
    privacySection1Desc: "Pas de collecte directe. Auto-collecte par usage.",
    privacySection2Title: "2. Usage des Données",
    privacySection2Desc: "Amélioration, stats et pubs.",
    privacySection3Title: "3. Cookies",
    privacySection3Desc1: "Cookies pour vos préférences.",
    privacySection3Desc2: "Désactivables via le navigateur.",
    privacySection4Title: "4. Google AdSense",
    privacySection4Desc1: "Pubs tierces utilisées.",
    privacySection4Desc2: "Google utilise des cookies basés sur vos visites.",
    privacySection4Desc3: "Pubs personnalisées via cookie DART.",
    privacySection4Desc4: "Désactivable via réglages Google.",
    privacySection4Link: "Politique Google",
    privacySection5Title: "5. Tiers",
    privacySection5Desc: "Pas de vente. Sauf si loi l'exige.",
    privacySection6Title: "6. Liens Externes",
    privacySection6Desc: "Pas responsables des sites tiers.",
    privacyContactEmail: "E-mail",
    privacyContactSite: "Nom Site",
    privacyEffectiveDate: "Date : 20 Jan 2026",
    privacyItemIP: "IP",
    privacyItemBrowser: "Navigateur",
    privacyItemDate: "Date/Heure",
    privacyItemPage: "Pages",
    privacyItemCookie: "Cookies",
    privacyUsageStats: "Stats usage",
    privacyUsageImprove: "Contenu et user exp.",
    privacyUsageAds: "Ads et optimisation",
    privacySection5Desc1: "Cookies utilisés pour services et pubs.",
    privacySection5Desc2: "Google utilise des cookies pour servir les pubs.",
    privacySection5Desc3: "Désactivation possible des pubs personnalisées.",
    termsSection1Title: "Art 1 (Objet)",
    termsSection1Desc: "Définit conditions d'usage de XLEVEN.",
    termsSection2Title: "Art 2 (Définitions)",
    termsSection2Desc: "1. User : membre ou non. 2. Contenu : news, données, etc.",
    termsSection3Title: "Art 3 (Revision)",
    termsSection3Desc: "Revision possible via avis interne.",
    termsSection4Title: "Art 4 (Contenu)",
    termsSection4Desc: "Scores, news, IA et communauté.",
    termsSection5Title: "Art 5 (Copyright)",
    termsSection5Desc: "1. Données protégées. 2. Pas d'usage commercial sans accord.",
    termsSection6Title: "Art 6 (Publicité)",
    termsSection6Desc: "Pubs possibles pour maintenir le service.",
    copyFailed: "Échec copie.",
    newsFeedSeoTitle: "Football Feed",
    newsFeedSeoDesc: "Check latest football news and real-time transfer rumors from major leagues around the world by date.",
    pexelsGallery: "Pexels Gallery",
    highFidelityAssets: "High fidelity football assets",
    tapToPlayWithSound: "Tap to Play with Sound",
    videoUnavailable: "This video is unavailable in your region or has been removed.",
    shortsPreparingTitle: "Preparing Shorts Videos",
    shortsPreparingDesc: "We are currently collecting the latest videos. Please check back shortly!",
    shortsSeoTitle: "Football Highlights & Shorts | XLEVEN",
    shortsSeoDesc: "Enjoy the hottest global football highlights and shorts videos seamlessly. Experience the best football moments recommended by AI.",
    gameStoreTitle: "Jeux de Football",
    newGamePreparing: "Nouveaux Jeux Bientôt",
    newGamePreparingDesc: "Des jeux de football exclusifs à XLEVEN seront bientôt disponibles. Restez à l'écoute !",
    ranking: "Classement",
    play: "Jouer",
    gameRanking: "Classement du Jeu",
    fetchingRankings: "Récupération du classement...",
    noRankingsYet: "Pas encore de classement",
    preparing: "Préparation...",
    toto_history: "Historique des Prédictions",
    toto_submit: "Envoyer",
    toto_check_predictions: "Vérifier les Prédictions",
    toto_round_format: "Round {{n}}",
    toto_finished: "Terminé",
    toto_in_progress: "En Cours",
    toto_success_count: "Prédictions Réussies",
    toto_submitted_at: "Envoyé le",
    toto_not_participated: "Vous n'avez pas participé à ce round.",
    toto_detailed_results: "Résultats Détaillés",
    toto_correct: "Correct",
    toto_incorrect: "Incorrect",
    toto_my_pick: "(Mon Choix)",
    toto_result: "(Résultat)",
    toto_win: "V",
    toto_draw: "N",
    toto_loss: "D",
    toto_ai_winner: "Vainqueur",
    toto_ai_score: "Score",
    toto_ai_win_rate: "Taux de Victoire",
    toto_ai_tactical: "Analyse Tactique",
    toto_save_failed: "Échec de l'enregistrement.",
    toto_predictions_status: "État des Prédictions",
    toto_view_analysis: "Voir l'Analyse",
    toto_ai_analysis: "Analyse IA",
    toto_predict_title: "Prédisez 14 matchs",
    toto_win_points: "et gagnez des points !",
    toto_challenge_win: "Défiez & Gagnez",
    toto_players_joined: "{{count}} joueurs inscrits",
    toto_rules_title: "Règles du Jeu",
    toto_rules_policy: "Politique du Jeu TRIPLE BET",
    toto_rules_1: "Un seul résultat peut être sélectionné par match.",
    toto_rules_2: "Gagnez 10 points et 10 points de score par pronostic correct.",
    toto_rules_3: "Déduction de 10p pour l'analyse IA.",
    toto_rules_4: "Choix multiples autorisés jusqu'à 20.",
    toto_rules_5: "Pas de déduction jusqu'à 14. Déduction pour 15(10p), 16(20p), 17(30p). Total 210p pour 20 choix.",
    toto_rules_6: "* Accès limité si les points sont insuffisants.",
    toto_login_required: "Connexion Requise",
    toto_login_desc: "Veuillez vous connecter pour participer au jeu TOTO.",
    toto_login_button: "Se connecter maintenant",
    toto_no_round_title: "Aucun round actif",
    toto_no_round_desc: "Un nouveau round commencera bientôt. Veuillez patienter !",
    toto_already_participated: "Vous avez déjà participé.",
    webtoonHeroTitle: "Le football, et bien plus encore,",
    webtoonHeroTitleColor: "XLEVEN Webtoon",
    webtoonHeroDesc: "Séries originales de webtoons de football mises à jour chaque semaine. Découvrez des histoires spéciales que vous ne trouverez nulle part ailleurs.",
    noWebtoons: "Aucun webtoon enregistré pour le moment.",
    webtoonSeoTitle: "Collection de Webtoons de Football",
    webtoonSeoDesc: "Découvrez les derniers webtoons de football sur XLEVEN. Profitez d'histoires et de séries de football originales mises à jour chaque semaine.",
    toto_round_expired: "Ce tour est terminé.",
    toto_submit_expired: "L'achat n'est pas disponible car la date limite est dépassée.",
    toto_predict_all: "Veuillez prédire tous les matchs.",
    toto_insufficient_points: "Points insuffisants. (Requis : {{amount}}p)",
    toto_saved_with_deduction: "Enregistré ! ({{amount}}p déduits)",
    toto_saved_success: "Enregistré avec succès !",
    toto_ai_completed: "Analyse IA terminée !",
    toto_ai_error: "Erreur lors de l'analyse.",
    toto_exit_title: "Quitter le jeu ?",
    toto_exit_desc: "Vos prédictions ne seront pas enregistrées.",
    toto_exit_confirm: "Quitter",
    toto_exit_cancel: "Continuer",
    toto_seo_title: "Défi Triple Pari - Jeu de Pronostics de Football Hebdomadaire",
    toto_seo_description: "Prédisez les résultats des matchs de football des ligues du monde entier mis à jour chaque semaine et gagnez des points. Augmentez votre probabilité de gagner avec des données d'analyse IA.",
    toto_seo_keywords: "Triple Pari, Pronostics Football, Toto, XLEVEN, Paris Sportifs, Analyse Football",
    toto_result_seo_title: "Mon Historique Triple Pari - Résultats des Pronostics Football",
    toto_result_seo_description: "Consultez vos résultats de pronostics de matchs de football hebdomadaires et les points gagnés. Analysez votre précision avec des rapports détaillés.",
    toto_result_seo_keywords: "Résultats Triple Pari, Historique Pronostics, Toto Football, XLEVEN, Précision Matchs",
    neon_pitch_seo_title: "NEON PITCH - Jeu d'Arcade de Football Rétro",
    neon_pitch_seo_description: "Découvrez le frisson de l'arcade de football rétro. Contrôlez le ballon néon, évitez les obstacles et visez le meilleur score dans NEON PITCH.",
    neon_pitch_seo_keywords: "Neon Pitch, Jeu de Football, Jeu d'Arcade, Football Rétro, Jeux XLEVEN, Jeu HTML5",
    "neon_pitch_score": "Score",
    "neon_pitch_best": "Meilleur",
    "neon_pitch_time_left": "Temps Restant",
    "neon_pitch_streak": "Série !",
    "neon_pitch_fever_unleashed": "FIÈVRE DE BUTS DÉCHAÎNÉE !",
    "neon_pitch_adrenaline_gauge": "Jauge d’Adrénaline",
    "neon_pitch_instructions": "Marquez un maximum de points !",
    "neon_pitch_exit": "RETOUR À LA BOUTIQUE",
    "neon_pitch_full_time": "Fin du Match",
    "neon_pitch_total_score": "Score Total",
    "neon_pitch_max_combo": "Combo Max",
    "neon_pitch_rematch": "REJOUER LE MATCH",
    "neon_pitch_deduction_toast": "10 Points Déduits",
    "neon_pitch_kickoff": "COUP D’ENVOI",
    neon_pitch_insufficient_points: "Points insuffisants.",
    viewTranslation: "Voir la traduction",
    viewOriginal: "Voir l'original",
    selectPostType: "Sélectionnez le type de publication",
    overallStrength: "Force Globale",
    attackPower: "Puissance d'Attaque",
    defensePower: "Puissance Défensive",
    winProbability: "Probabilité de Victoire",
    strength: "Force",
    attackingPotential: "Potentiel d'Attaque",
    defensivePotential: "Potentiel Défensif",
    poissonDistribution: "Distribution de Poisson",
    strengthH2h: "Force H2H",
    goalsH2h: "Buts H2H",
    winsTheGame: "Gagne le Match",
    lastNMatches: "Derniers {n} Matchs",
    viewH2HDetail: "Afficher les détails",
    footy_master_preparing_arena: "Préparation de l'Arène...",
    footy_master_trivia_quiz: "Quiz de Football",
    footy_master_high_score: "Meilleur Score",
    footy_master_start_desc: "Montrez vos connaissances en football et gagnez des points !",
    footy_master_questions: "Questions",
    footy_master_random: "10 Aléatoires",
    footy_master_time_limit: "Temps Limite",
    footy_master_time_s_q: "15s / Q",
    footy_master_get_started: "COMMENCER",
    footy_master_back_to_store: "Sortie",
    footy_master_back_to_start: "Retour au Début",
    footy_master_question_n_of_m: "Question {{n}} sur {{m}}",
    footy_master_mission_complete: "Mission Terminée",
    footy_master_total_score: "Score Total",
    footy_master_accuracy: "Précision",
    footy_master_play_again: "REJOUER",
    footy_master_exit_to_store: "QUITTER VERS BOUTIQUE",
    footy_master_cat_worldcup: "Coupe du Monde",
    footy_master_cat_epl: "EPL",
    footy_master_cat_laliga: "La Liga",
    footy_master_cat_ucl: "UCL",
    footy_master_cat_kleague: "K-League",
    footy_master_commentary_perfect: "Parfait ! Vous êtes une encyclopédie vivante du football ! 🏆⚽️",
    footy_master_commentary_great: "Excellent travail ! Vous êtes presque un expert ! 🔥👏",
    footy_master_commentary_good: "Pas mal ! Encore un petit effort pour devenir un maître ! 💪✨",
    footy_master_commentary_average: "Vous avez peut-être besoin d'un peu plus d'étude ! On réessaie ? 📚⚽️",
    footy_master_commentary_poor: "C'est pas grave ! Le chemin pour devenir un maître est toujours difficile ! 🏃‍♂️🌟",
    footy_master_seo_title: "FOOTY MASTER - Jeu de Quiz de Football Mondial",
    footy_master_seo_description: "Montrez vos connaissances en football ! Résolvez des quiz sur la Coupe du Monde, l'EPL, la La Liga et l'UCL pour gagner des points et devenir un Footy Master.",
    footy_master_seo_keywords: "Footy Master, Quiz Football, Trivia Football, Jeu de Football, Quiz Coupe du Monde, Quiz EPL, Jeux XLEVEN",
    noCommentsYet: "Aucun commentaire pour le moment",
    addAComment: "Ajouter un commentaire...",
    deleteCommentConfirm: "Supprimer ce commentaire ?",
    matchTalk: "Discussion du Match",
    phantomStadium: "Stade Fantôme",
    matchAnalysis: "Analyse du Match",
    noPostsFound: "Aucune publication trouvée",
    beTheFirstToPost: "Soyez le premier à publier !",
    noAnalysisFound: "Aucune analyse trouvée",
    beTheFirstToAnalyze: "Soyez le premier à analyser !",
    viewMore: "Voir plus",
    deleteConfirm: "Confirmer la Suppression",
    deleteConfirmMessage: "Êtes-vous sûr de vouloir supprimer ce contenu ? Cette action est irréversible.",
    viewReplies: "Voir les réponses",
    hideReplies: "Masquer les réponses",
    failedToLoadQuizzes: "Impossible de charger les quiz",
    quizCreatedSuccessfully: "Le quiz a été créé avec succès",
    quizDeleted: "Le quiz a été supprimé",
    deleteFailed: "Échec de la suppression",
    deleteSuccess: "Supprimé avec succès",
    reportSubmitted: "Signalement envoyé",
    failedToDeductPoints: "Échec de la déduction des points",
    failedToUpdatePassword: "Échec de la mise à jour du mot de passe",
    failedToUpdateNickname: "Échec de la mise à jour du pseudonyme",
    fileSizeUnder5MB: "La taille du fichier doit être inférieure à 5 Mo",
    saveFailed: "Échec de l'enregistrement",
    supportXlevenService: "Support du service XLEVEN",
    copySuccess: "Lien copié dans le presse-papiers",
    setFavoriteTeamFirst: "Veuillez d'abord définir une équipe favorite",
    aiTacticalInsight: "Aperçu Tactique de l'IA",
    strategicAnalysisReport: "Rapport d'Analyse Stratégique",
    winProbabilityDistribution: "Distribution de Probabilité de Victoire",
    aiConfidence: "Confiance de l'IA",
    viewAll: "Voir Tout",
    viewDetails: "Voir les détails",
    hotPost: "Post Populaire",
    syncingActivities: "Synchronisation des activités...",
    intelligenceReport: "Rapport d'Intelligence",
    matchIntel: "Intel du Match",
    koreanFeed: "Flux Coréen",
    englishFeed: "Flux Anglais",
    maxLeaguesReached: "Un maximum de 10 ligues peut être sélectionné",
    maxLeaguesReachedGuest: "Les non-membres peuvent sélectionner un maximum de 3 ligues",
  },
}

/**
 * Returns the translation for a given key and language.
 */
export const t = (lang: Language, key: string): string => {
  return translations[lang]?.[key] || key
}

/**
 * Returns a formatted translation replacing {{placeholders}} with provided params.
 */
export const tr = (lang: Language, key: string, params?: Record<string, string | number>): string => {
  let str = t(lang, key);
  if (!params) return str;
  Object.keys(params).forEach(k => {
    const re = new RegExp(`{{\\s*${k}\\s*}}`, 'g');
    str = str.replace(re, String(params[k]));
  });
  return str;
}
